function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;});keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {ownKeys(Object(source), true).forEach(function (key) {_defineProperty(target, key, source[key]);});} else if (Object.getOwnPropertyDescriptors) {Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));} else {ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}(function ($) {
  var $ = jQuery = $;

  var cc = {
    sections: [] };


  theme.Shopify = {
    formatMoney: function formatMoney(t, r) {
      function e(t, r) {
        return void 0 === t ? r : t;
      }
      function a(t, r, a, o) {
        if (r = e(r, 2),
        a = e(a, ","),
        o = e(o, "."),
        isNaN(t) || null == t)
        return 0;
        t = (t / 100).toFixed(r);
        var n = t.split(".");
        return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (n[1] ? o + n[1] : "");
      }
      "string" == typeof t && (t = t.replace(".", ""));
      var o = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      i = r || this.money_format;
      switch (i.match(n)[1]) {
        case "amount":
          o = a(t, 2);
          break;
        case "amount_no_decimals":
          o = a(t, 0);
          break;
        case "amount_with_comma_separator":
          o = a(t, 2, ".", ",");
          break;
        case "amount_with_space_separator":
          o = a(t, 2, " ", ",");
          break;
        case "amount_with_period_and_space_separator":
          o = a(t, 2, " ", ".");
          break;
        case "amount_no_decimals_with_comma_separator":
          o = a(t, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          o = a(t, 0, " ", "");
          break;
        case "amount_with_apostrophe_separator":
          o = a(t, 2, "'", ".");
          break;
        case "amount_with_decimal_separator":
          o = a(t, 2, ".", ".");}

      return i.replace(n, o);
    },
    formatImage: function formatImage(originalImageUrl, format) {
      return originalImageUrl ? originalImageUrl.replace(/^(.*)\.([^\.]*)$/g, '$1_' + format + '.$2') : '';
    },
    Image: {
      imageSize: function imageSize(t) {
        var e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
        return null !== e ? e[1] : null;
      },
      getSizedImageUrl: function getSizedImageUrl(t, e) {
        if (null == e)
        return t;
        if ("master" == e)
        return this.removeProtocol(t);
        var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != o) {
          var i = t.split(o[0]),
          r = o[0];
          return this.removeProtocol(i[0] + "_" + e + r);
        }
        return null;
      },
      removeProtocol: function removeProtocol(t) {
        return t.replace(/http(s)?:/, "");
      } } };


  class ccComponent {
    constructor(name) {var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-".concat(name);
      var _this = this;
      this.instances = [];

      // Initialise any instance of this component within a section
      $(document).on('cc:component:load', function (event, component, target) {
        if (component === name) {
          $(target).find("".concat(cssSelector, ":not(.cc-initialized)")).each(function () {
            _this.init(this);
          });
        }
      });

      // Destroy any instance of this component within a section
      $(document).on('cc:component:unload', function (event, component, target) {
        if (component === name) {
          $(target).find(cssSelector).each(function () {
            _this.destroy(this);
          });
        }
      });

      // Initialise any instance of this component
      $(cssSelector).each(function () {
        _this.init(this);
      });
    }

    init(container) {
      $(container).addClass('cc-initialized');
    }

    destroy(container) {
      $(container).removeClass('cc-initialized');
    }

    registerInstance(container, instance) {
      this.instances.push({
        container,
        instance });

    }

    destroyInstance(container) {
      this.instances = this.instances.filter(item => {
        if (item.container === container) {
          if (typeof item.instance.destroy === 'function') {
            item.instance.destroy();
          }

          return item.container !== container;
        }
      });
    }}

  // requires: throttled-scroll, debouncedresize

  /*
    Define a section by creating a new function object and registering it with the section handler.
    The section handler manages:
      Instantiation for all sections on the current page
      Theme editor lifecycle events
      Deferred initialisation
      Event cleanup

    There are two ways to register a section.
    In a theme:
      theme.Sections.register('slideshow', theme.SlideshowSection);
      theme.Sections.register('header', theme.HeaderSection, { deferredLoad: false });
      theme.Sections.register('background-video', theme.VideoManager, { deferredLoadViewportExcess: 800 });

    As a component:
      cc.sections.push({ name: 'faq', section: theme.Faq });

    Assign any of these to receive Shopify section lifecycle events:
      this.onSectionLoad
      this.afterSectionLoadCallback
      this.onSectionSelect
      this.onSectionDeselect
      this.onBlockSelect
      this.onBlockDeselect
      this.onSectionUnload
      this.afterSectionUnloadCallback
      this.onSectionReorder

    If you add any events using the manager's registerEventListener,
    e.g. this.registerEventListener(element, 'click', this.functions.handleClick.bind(this)),
    these will be automatically cleaned up after onSectionUnload.
   */

  theme.Sections = new function () {
    var _ = this;

    _._instances = [];
    _._deferredSectionTargets = [];
    _._sections = [];
    _._deferredLoadViewportExcess = 300; // load defferred sections within this many px of viewport
    _._deferredWatcherRunning = false;

    _.init = function () {
      $(document).on('shopify:section:load', function (e) {
        // load a new section
        var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
        if (target) {
          _.sectionLoad(target);
        }
      }).on('shopify:section:unload', function (e) {
        // unload existing section
        var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
        if (target) {
          _.sectionUnload(target);
        }
      }).on('shopify:section:reorder', function (e) {
        // unload existing section
        var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
        if (target) {
          _.sectionReorder(target);
        }
      });
      $(window).on('throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader', _._processDeferredSections);
      _._deferredWatcherRunning = true;
    };

    // register a type of section
    _.register = function (type, section, options) {
      _._sections.push({
        type: type,
        section: section,
        afterSectionLoadCallback: options ? options.afterLoad : null,
        afterSectionUnloadCallback: options ? options.afterUnload : null });


      // load now
      $('[data-section-type="' + type + '"]').each(function () {
        if (Shopify.designMode || options && options.deferredLoad === false || !_._deferredWatcherRunning) {
          _.sectionLoad(this);
        } else {
          _.sectionDeferredLoad(this, options);
        }
      });
    };

    // prepare a section to load later
    _.sectionDeferredLoad = function (target, options) {
      _._deferredSectionTargets.push({
        target: target,
        deferredLoadViewportExcess: options && options.deferredLoadViewportExcess ? options.deferredLoadViewportExcess : _._deferredLoadViewportExcess });

      _._processDeferredSections(true);
    };

    // load deferred sections if in/near viewport
    _._processDeferredSections = function (firstRunCheck) {
      if (_._deferredSectionTargets.length) {
        var viewportTop = $(window).scrollTop(),
        viewportBottom = viewportTop + $(window).height(),
        loopStart = firstRunCheck === true ? _._deferredSectionTargets.length - 1 : 0;
        for (var i = loopStart; i < _._deferredSectionTargets.length; i++) {
          var target = _._deferredSectionTargets[i].target,
          viewportExcess = _._deferredSectionTargets[i].deferredLoadViewportExcess,
          sectionTop = $(target).offset().top - viewportExcess,
          doLoad = sectionTop > viewportTop && sectionTop < viewportBottom;
          if (!doLoad) {
            var sectionBottom = sectionTop + $(target).outerHeight() + viewportExcess * 2;
            doLoad = sectionBottom > viewportTop && sectionBottom < viewportBottom;
          }
          if (doLoad || sectionTop < viewportTop && sectionBottom > viewportBottom) {
            // in viewport, load
            _.sectionLoad(target);
            // remove from deferred queue and resume checks
            _._deferredSectionTargets.splice(i, 1);
            i--;
          }
        }
      }

      // remove event if no more deferred targets left, if not on first run
      if (firstRunCheck !== true && _._deferredSectionTargets.length === 0) {
        _._deferredWatcherRunning = false;
        $(window).off('.themeSectionDeferredLoader');
      }
    };

    // load in a section
    _.sectionLoad = function (target) {
      var target = target,
      sectionObj = _._sectionForTarget(target),
      section = false;

      if (sectionObj.section) {
        section = sectionObj.section;
      } else {
        section = sectionObj;
      }

      if (section !== false) {
        var instance = {
          target: target,
          section: section,
          $shopifySectionContainer: $(target).closest('.shopify-section'),
          thisContext: {
            functions: section.functions,
            registeredEventListeners: [] } };


        instance.thisContext.registerEventListener = _._registerEventListener.bind(instance.thisContext);
        _._instances.push(instance);

        //Initialise any components
        if ($(target).data('components')) {
          //Init each component
          var components = $(target).data('components').split(',');
          components.forEach(component => {
            $(document).trigger('cc:component:load', [component, target]);
          });
        }

        _._callSectionWith(section, 'onSectionLoad', target, instance.thisContext);
        _._callSectionWith(section, 'afterSectionLoadCallback', target, instance.thisContext);

        // attach additional UI events if defined
        if (section.onSectionSelect) {
          instance.$shopifySectionContainer.on('shopify:section:select', function (e) {
            _._callSectionWith(section, 'onSectionSelect', e.target, instance.thisContext);
          });
        }
        if (section.onSectionDeselect) {
          instance.$shopifySectionContainer.on('shopify:section:deselect', function (e) {
            _._callSectionWith(section, 'onSectionDeselect', e.target, instance.thisContext);
          });
        }
        if (section.onBlockSelect) {
          $(target).on('shopify:block:select', function (e) {
            _._callSectionWith(section, 'onBlockSelect', e.target, instance.thisContext);
          });
        }
        if (section.onBlockDeselect) {
          $(target).on('shopify:block:deselect', function (e) {
            _._callSectionWith(section, 'onBlockDeselect', e.target, instance.thisContext);
          });
        }
      }
    };

    // unload a section
    _.sectionUnload = function (target) {
      var sectionObj = _._sectionForTarget(target);
      var instanceIndex = -1;
      for (var i = 0; i < _._instances.length; i++) {
        if (_._instances[i].target == target) {
          instanceIndex = i;
        }
      }
      if (instanceIndex > -1) {
        var instance = _._instances[instanceIndex];
        // remove events and call unload, if loaded
        $(target).off('shopify:block:select shopify:block:deselect');
        instance.$shopifySectionContainer.off('shopify:section:select shopify:section:deselect');
        _._callSectionWith(instance.section, 'onSectionUnload', target, instance.thisContext);
        _._unloadRegisteredEventListeners(instance.thisContext.registeredEventListeners);
        _._callSectionWith(sectionObj, 'afterSectionUnloadCallback', target, instance.thisContext);
        _._instances.splice(instanceIndex);

        //Destroy any components
        if ($(target).data('components')) {
          //Init each component
          var components = $(target).data('components').split(',');
          components.forEach(component => {
            $(document).trigger('cc:component:unload', [component, target]);
          });
        }
      } else {
        // check if it was a deferred section
        for (var i = 0; i < _._deferredSectionTargets.length; i++) {
          if (_._deferredSectionTargets[i].target == target) {
            _._deferredSectionTargets[i].splice(i, 1);
            break;
          }
        }
      }
    };

    _.sectionReorder = function (target) {
      var instanceIndex = -1;
      for (var i = 0; i < _._instances.length; i++) {
        if (_._instances[i].target == target) {
          instanceIndex = i;
        }
      }
      if (instanceIndex > -1) {
        var instance = _._instances[instanceIndex];
        _._callSectionWith(instance.section, 'onSectionReorder', target, instance.thisContext);
      }
    };

    // Helpers
    _._registerEventListener = function (element, eventType, callback) {
      element.addEventListener(eventType, callback);
      this.registeredEventListeners.push({
        element,
        eventType,
        callback });

    };

    _._unloadRegisteredEventListeners = function (registeredEventListeners) {
      registeredEventListeners.forEach(rel => {
        rel.element.removeEventListener(rel.eventType, rel.callback);
      });
    };

    _._callSectionWith = function (section, method, container, thisContext) {
      if (typeof section[method] === 'function') {
        try {
          if (thisContext) {
            section[method].bind(thisContext)(container);
          } else {
            section[method](container);
          }
        } catch (ex) {
          var sectionType = container.dataset['sectionType'];
          console.warn("Theme warning: '".concat(method, "' failed for section '").concat(sectionType, "'"));
          console.debug(container, ex);
        }
      }
    };

    _._themeSectionTargetFromShopifySectionTarget = function (target) {
      var $target = $('[data-section-type]:first', target);
      if ($target.length > 0) {
        return $target[0];
      } else {
        return false;
      }
    };

    _._sectionForTarget = function (target) {
      var type = $(target).attr('data-section-type');
      for (var i = 0; i < _._sections.length; i++) {
        if (_._sections[i].type == type) {
          return _._sections[i];
        }
      }
      return false;
    };

    _._sectionAlreadyRegistered = function (type) {
      for (var i = 0; i < _._sections.length; i++) {
        if (_._sections[i].type == type) {
          return true;
        }
      }
      return false;
    };
  }();
  // Loading third party scripts
  theme.scriptsLoaded = {};
  theme.loadScriptOnce = function (src, callback, beforeRun, sync) {
    if (typeof theme.scriptsLoaded[src] === 'undefined') {
      theme.scriptsLoaded[src] = [];
      var tag = document.createElement('script');
      tag.src = src;

      if (sync || beforeRun) {
        tag.async = false;
      }

      if (beforeRun) {
        beforeRun();
      }

      if (typeof callback === 'function') {
        theme.scriptsLoaded[src].push(callback);
        if (tag.readyState) {// IE, incl. IE9
          tag.onreadystatechange = function () {
            if (tag.readyState == "loaded" || tag.readyState == "complete") {
              tag.onreadystatechange = null;
              for (var i = 0; i < theme.scriptsLoaded[this].length; i++) {
                theme.scriptsLoaded[this][i]();
              }
              theme.scriptsLoaded[this] = true;
            }
          }.bind(src);
        } else {
          tag.onload = function () {// Other browsers
            for (var i = 0; i < theme.scriptsLoaded[this].length; i++) {
              theme.scriptsLoaded[this][i]();
            }
            theme.scriptsLoaded[this] = true;
          }.bind(src);
        }
      }

      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      return true;
    } else if (typeof theme.scriptsLoaded[src] === 'object' && typeof callback === 'function') {
      theme.scriptsLoaded[src].push(callback);
    } else {
      if (typeof callback === 'function') {
        callback();
      }
      return false;
    }
  };

  theme.loadStyleOnce = function (src) {
    var srcWithoutProtocol = src.replace(/^https?:/, '');
    if (!document.querySelector('link[href="' + encodeURI(srcWithoutProtocol) + '"]')) {
      var tag = document.createElement('link');
      tag.href = srcWithoutProtocol;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      var firstTag = document.getElementsByTagName('link')[0];
      firstTag.parentNode.insertBefore(tag, firstTag);
    }
  };theme.Disclosure = function () {
    var selectors = {
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]' };


    var classes = {
      listVisible: 'disclosure-list--visible' };


    function Disclosure($disclosure) {
      this.$container = $disclosure;
      this.cache = {};
      this._cacheSelectors();
      this._connectOptions();
      this._connectToggle();
      this._onFocusOut();
    }

    Disclosure.prototype = $.extend({}, Disclosure.prototype, {
      _cacheSelectors: function _cacheSelectors() {
        this.cache = {
          $disclosureList: this.$container.find(selectors.disclosureList),
          $disclosureToggle: this.$container.find(selectors.disclosureToggle),
          $disclosureInput: this.$container.find(selectors.disclosureInput),
          $disclosureOptions: this.$container.find(selectors.disclosureOptions) };

      },

      _connectToggle: function _connectToggle() {
        this.cache.$disclosureToggle.on(
        'click',
        function (evt) {
          var ariaExpanded =
          $(evt.currentTarget).attr('aria-expanded') === 'true';
          $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);

          this.cache.$disclosureList.toggleClass(classes.listVisible);
        }.bind(this));

      },

      _connectOptions: function _connectOptions() {
        this.cache.$disclosureOptions.on(
        'click',
        function (evt) {
          evt.preventDefault();
          this._submitForm($(evt.currentTarget).data('value'));
        }.bind(this));

      },

      _onFocusOut: function _onFocusOut() {
        this.cache.$disclosureToggle.on(
        'focusout',
        function (evt) {
          var disclosureLostFocus =
          this.$container.has(evt.relatedTarget).length === 0;

          if (disclosureLostFocus) {
            this._hideList();
          }
        }.bind(this));


        this.cache.$disclosureList.on(
        'focusout',
        function (evt) {
          var childInFocus =
          $(evt.currentTarget).has(evt.relatedTarget).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
          classes.listVisible);


          if (isVisible && !childInFocus) {
            this._hideList();
          }
        }.bind(this));


        this.$container.on(
        'keyup',
        function (evt) {
          if (evt.which !== 27) return; // escape
          this._hideList();
          this.cache.$disclosureToggle.focus();
        }.bind(this));


        this.bodyOnClick = function (evt) {
          var isOption = this.$container.has(evt.target).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
          classes.listVisible);


          if (isVisible && !isOption) {
            this._hideList();
          }
        }.bind(this);

        $('body').on('click', this.bodyOnClick);
      },

      _submitForm: function _submitForm(value) {
        this.cache.$disclosureInput.val(value);
        this.$container.parents('form').submit();
      },

      _hideList: function _hideList() {
        this.cache.$disclosureList.removeClass(classes.listVisible);
        this.cache.$disclosureToggle.attr('aria-expanded', false);
      },

      unload: function unload() {
        $('body').off('click', this.bodyOnClick);
        this.cache.$disclosureOptions.off();
        this.cache.$disclosureToggle.off();
        this.cache.$disclosureList.off();
        this.$container.off();
      } });


    return Disclosure;
  }();
  /// Show a short-lived text popup above an element
  theme.showQuickPopup = function (message, $origin) {
    var $popup = $('<div class="simple-popup"/>');
    var offs = $origin.offset();
    $popup.html(message).css({ 'left': offs.left, 'top': offs.top }).hide();
    $('body').append($popup);
    $popup.css({ marginTop: -$popup.outerHeight() - 10, marginLeft: -($popup.outerWidth() - $origin.outerWidth()) / 2 });
    $popup.fadeIn(200).delay(3500).fadeOut(400, function () {
      $(this).remove();
    });
  };
  //v1.0
  $.fn.sort = [].sort; // v1.0
  $.fn.fadeOutAndRemove = function (speed, callback) {
    $(this).fadeOut(speed, function () {
      $(this).remove();
      typeof callback == 'function' && callback();
    });
  }; // Turn a <select> tag into clicky boxes
  // Use with: $('select').clickyBoxes()
  $.fn.clickyBoxes = function (prefix) {
    if (prefix == 'destroy') {
      $(this).off('.clickyboxes');
      $(this).next('.clickyboxes').off('.clickyboxes');
    } else {
      return $(this).filter('select:not(.clickybox-replaced)').addClass('clickybox-replaced').each(function () {
        //Make sure rows are unique
        var prefix = prefix || $(this).attr('id');
        //Create container
        var $optCont = $('<ul class="clickyboxes"/>').attr('id', 'clickyboxes-' + prefix).data('select', $(this)).insertAfter(this);

        var $label;
        if ($(this).is('[id]')) {
          $label = $('label[for="' + $(this).attr('id') + '"]'); // Grab real label
        } else {
          $label = $(this).siblings('label'); // Rough guess
        }
        if ($label.length > 0) {
          $optCont.addClass('options-' + removeDiacritics($label.text()).toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, ''));
          if (document.querySelectorAll(".options-product-option").length == 0) {
            document.querySelector(".product-detail-quality").style.display = 'none';
          } else {
            document.querySelector(".product-detail-quality").style.display = 'block';
          }
        }

        //Add options to container
        $(this).find('option').each(function () {
          $('<li/>').appendTo($optCont).append(
          $('<a href="#"/>').attr('data-value', $(this).val()).html($(this).html()).
          addClass('opt--' + removeDiacritics($(this).text()).toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, '')));

        });
        //Select change event
        $(this).hide().addClass('replaced').on('change.clickyboxes keyup.clickyboxes', function () {
          //Choose the right option to show
          var val = $(this).val();
          $optCont.find('a').removeClass('active').filter(function () {
            return $(this).attr('data-value') == val;
          }).addClass('active');
        }).trigger('keyup'); //Initial value
        //Button click event
        $optCont.on('click.clickyboxes', 'a', function () {
          if (!$(this).hasClass('active')) {
            var $clicky = $(this).closest('.clickyboxes');
            $clicky.data('select').val($(this).data('value')).trigger('change');
            $clicky.trigger('change');
          }
          return false;
        });
      });
    }
  };
  // v1.0
  //Find out how wide scrollbars are on this browser
  $.scrollBarWidth = function () {
    var $temp = $('<div/>').css({
      width: 100,
      height: 100,
      overflow: 'scroll',
      position: 'absolute',
      top: -9999 }).
    prependTo('body');
    var w = $temp[0].offsetWidth - $temp[0].clientWidth;
    $temp.remove();
    return w;
  }; //Restyle all select dropdowns
  //NOTE: Only for us on showcase until this can be replaced with jquery.selectreplace.v1.0.js
  var chevronDownIcon = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>';
  $.fn.selectReplace = function (leaveLabel) {
    return $(this).filter('select:not(.replaced, .noreplace)').each(function () {
      //Add formatting containers
      var $opts = $(this).find('option');
      var initialText = $opts.filter(':selected').length > 0 ? $opts.filter(':selected').text() : $opts.first().text();
      var $cont = $(this).addClass('replaced').wrap('<div class="pretty-select">').parent().addClass('id-' + $(this).attr('id')).
      append('<span class="text"><span class="value">' + initialText + '</span></span>' + chevronDownIcon);
      //Label? Move inside
      if ($(this).attr('id')) {
        //Find label
        var $label = $('label[for="' + $(this).attr('id') + '"]');
        //If table cells used for layout, do not move the label
        var $selectTD = $(this).closest('td');
        var $labelTD = $label.closest('td');
        if (!leaveLabel && ($selectTD.length == 0 || $labelTD.length == 0 || $selectTD[0] == $labelTD[0])) {
          //Add to dropdown
          var $labelSpan = $('<span class="label">').html($label.html()).prependTo($cont.find('.text'));
          //Add colon, if it doesn't exist
          if ($labelSpan.slice(-1) != ':') {
            $labelSpan.append(':');
          }
          // remove label element and use aria
          $cont.find('select').attr('aria-label', $label.text());
          $label.remove();
        }
      }
    }).on('change keyup', function () {
      $(this).siblings('.text').find('.value').html($(this).find(':selected').html());
    });
  };$.fn.ccHoverLine = function (opts) {
    $(this).each(function () {
      var $this = $(this);
      if (!$this.hasClass('cc-init')) {
        $this.append("<li class='cc-hover-line'></li>").addClass('cc-init');
        var $hoverLine = $(this).find(".cc-hover-line");

        if (opts && opts.lineCss) {
          $hoverLine.css(opts.lineCss);
        }

        function updateLine() {var $link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $this.find('li a[aria-selected="true"], li a.active');
          if ($link.length === 1) {
            $hoverLine.css({
              width: $link.width(),
              top: $link.position().top + $link.outerHeight(),
              left: $link.position().left });

          }
        }

        updateLine();

        if ($(window).outerWidth() < 768) {
          $(this).find("li").click(function () {
            var $link = $(this).find('a');
            if ($link.length === 1) {
              updateLine($link);
            }
          });
        } else {
          $(this).find("li").hover(function () {
            var $link = $(this).find('a');
            if ($link.length === 1) {
              updateLine($link);
            }
          }, function () {
            updateLine();
          });
        }

        $(window).on('debouncedresizewidth', function () {
          updateLine();
        });
      }
    });
  };
  (function () {
    function throttle(callback, threshold) {
      var debounceTimeoutId = -1;
      var tick = false;

      return function () {
        clearTimeout(debounceTimeoutId);
        debounceTimeoutId = setTimeout(callback, threshold);

        if (!tick) {
          callback.call();
          tick = true;
          setTimeout(function () {
            tick = false;
          }, threshold);
        }
      };
    }

    var scrollEvent = document.createEvent('Event');
    scrollEvent.initEvent('throttled-scroll', true, true);

    window.addEventListener("scroll", throttle(function () {
      window.dispatchEvent(scrollEvent);
    }, 200));

  })();
  theme.cartNoteMonitor = {
    load: function load($notes) {
      $notes.on('change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor', function () {
        theme.cartNoteMonitor.postUpdate($(this).val());
      });
    },

    unload: function unload($notes) {
      $notes.off('.themeCartNoteMonitor');
    },

    updateThrottleTimeoutId: -1,
    updateThrottleInterval: 500,

    postUpdate: function postUpdate(val) {
      clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId);
      theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout(function () {
        $.post(theme.routes.cart_url + '/update.js', {
          note: val },
        function (data) {}, 'json');
      }, theme.cartNoteMonitor.updateThrottleInterval);
    } };

  // Source: https://davidwalsh.name/javascript-debounce-function
  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  theme.debounce = function (func) {var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 700;var immediate = arguments.length > 2 ? arguments[2] : undefined;
    var timeout;
    return function () {
      var context = this,args = arguments;
      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };
  new class extends ccComponent {
    init(container) {
      super.init(container);

      var $container = $(container);

      //Emit's an event to indicate a tab is being changed. Also includes the difference in height
      //between the closing and opening tab
      function dispatchTabChangedEvent() {
        var event = new CustomEvent("cc-tab-changed");
        window.dispatchEvent(event);
      }

      $container.on('click', '[data-cc-toggle-panel]', function () {
        var $tabs = $(this).closest('.cc-tabs');
        var tabIndexToShow = $(this).data('cc-toggle-panel');
        var $tabToClose = $tabs.find('.cc-tabs__tab__panel:visible');
        var $tabToOpen = $tabs.find(".cc-tabs__tab .cc-tabs__tab__panel[aria-labelledby=\"product-tab-panel".concat(tabIndexToShow, "\"]"));
        var openAllTabs = $(this).closest('.cc-tabs[data-cc-tab-allow-multi-open="true"]').length;

        if ($tabs.hasClass('cc-tabs--tab-mode')) {
          if ($tabToOpen.is(':visible')) {
            if ($(window).outerWidth() < 768) {
              $tabToOpen.attr('hidden', '');
              $tabs.find('[role="tab"] [aria-selected="true"]').removeAttr('aria-selected');
            }
          } else {
            $tabToClose.attr('hidden', '');
            $tabToOpen.removeAttr('hidden');
            $tabs.find('[role="tab"] [aria-selected="true"]').removeAttr('aria-selected');
            $tabs.find("[data-cc-toggle-panel=\"".concat(tabIndexToShow, "\"]")).attr('aria-selected', 'true');
          }
        } else {
          var accordionSpeed = 300;
          var tabNeedsClosing = $tabToClose.length;
          var tabNeedsOpening = $tabToOpen.attr('id') !== $tabToClose.attr('id') && $tabToOpen.length;

          if (openAllTabs) {
            if ($tabToOpen.is(':visible')) {
              tabNeedsClosing = true;
              tabNeedsOpening = false;
              $tabToClose = $tabToOpen;
            } else {
              tabNeedsClosing = false;
              tabNeedsOpening = true;
            }
          }

          if ($(window).outerWidth() < 768) {
            if ($tabToOpen.is(':visible')) {
              tabNeedsClosing = true;
              tabNeedsOpening = false;
              $tabToClose = $tabToOpen;
            } else {
              tabNeedsClosing = false;
            }
          }

          if (tabNeedsClosing) {
            $tabToClose.slideUp(accordionSpeed, function () {
              $(this).attr('hidden', '');
              if (!tabNeedsOpening) {
                dispatchTabChangedEvent();
              }
            });
            $tabToClose.prev().removeAttr('aria-selected');
          }

          if (tabNeedsOpening) {
            $tabToOpen.css('display', 'none').removeAttr('hidden').slideDown(accordionSpeed, dispatchTabChangedEvent);
            $tabToOpen.prev().attr('aria-selected', 'true');
          }
        }
        return false;
      });

      if ($container.hasClass('cc-tabs--tab-mode')) {
        $container.find('.cc-tabs__tab-headers').ccHoverLine();
      }
    }

    destroy(container) {
      super.destroy(container);
      $(container).off('click', '[data-cc-toggle-panel]');
    }}(
  'tabs');
  (() => {
    theme.initAnimateOnScroll = function () {
      if (document.body.classList.contains('cc-animate-enabled') && window.innerWidth >= 768) {
        var animationTimeout = typeof document.body.dataset.ccAnimateTimeout !== "undefined" ? document.body.dataset.ccAnimateTimeout : 200;

        if ('IntersectionObserver' in window) {
          var intersectionObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
              // In view and hasn't been animated yet
              if (entry.isIntersecting && !entry.target.classList.contains("cc-animate-complete")) {
                setTimeout(() => {
                  entry.target.classList.add("-in", "cc-animate-complete");
                }, animationTimeout);

                setTimeout(() => {
                  //Once the animation is complete (assume 5 seconds), remove the animate attribute to remove all css
                  entry.target.classList.remove("data-cc-animate");
                  entry.target.style.transitionDuration = null;
                  entry.target.style.transitionDelay = null;
                }, 5000);

                // Remove observer after animation
                observer.unobserve(entry.target);
              }
            });
          });

          document.querySelectorAll('[data-cc-animate]:not(.cc-animate-init)').forEach(elem => {
            //Set the animation delay
            if (elem.dataset.ccAnimateDelay) {
              elem.style.transitionDelay = elem.dataset.ccAnimateDelay;
            }

            ///Set the animation duration
            if (elem.dataset.ccAnimateDuration) {
              elem.style.transitionDuration = elem.dataset.ccAnimateDuration;
            }

            //Init the animation
            if (elem.dataset.ccAnimate) {
              elem.classList.add(elem.dataset.ccAnimate);
            }

            elem.classList.add("cc-animate-init");

            //Watch for elem
            intersectionObserver.observe(elem);
          });
        } else {
          //Fallback, load all the animations now
          var elems = document.querySelectorAll('[data-cc-animate]:not(.cc-animate-init)');
          for (var _i = 0; _i < elems.length; _i++) {
            elems[_i].classList.add("-in", "cc-animate-complete");
          }
        }
      }
    };

    theme.initAnimateOnScroll();

    document.addEventListener('shopify:section:load', () => {
      setTimeout(theme.initAnimateOnScroll, 100);
    });

    //Reload animations when changing from mobile to desktop
    try {
      window.matchMedia('(min-width: 768px)').addEventListener('change', event => {
        if (event.matches) {
          setTimeout(theme.initAnimateOnScroll, 100);
        }
      });
    } catch (e) {}
  })();


  class ccPopup {
    constructor($container, namespace) {
      this.$container = $container;
      this.namespace = namespace;
      this.cssClasses = {
        visible: 'cc-popup--visible',
        bodyNoScroll: 'cc-popup-no-scroll',
        bodyNoScrollPadRight: 'cc-popup-no-scroll-pad-right' };

    }

    /**
     * Open popup on timer / local storage - move focus to input ensure you can tab to submit and close
     * Add the cc-popup--visible class
     * Update aria to visible
     */
    open(callback) {
      // Prevent the body from scrolling
      if (this.$container.data('freeze-scroll')) {
        $('body').addClass(this.cssClasses.bodyNoScroll);

        // Add any padding necessary to the body to compensate for the scrollbar that just disappeared
        var scrollDiv = document.createElement('div');
        scrollDiv.className = 'popup-scrollbar-measure';
        document.body.appendChild(scrollDiv);
        var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        if (scrollbarWidth > 0) {
          $('body').css('padding-right', scrollbarWidth + 'px').addClass(this.cssClasses.bodyNoScrollPadRight);
        }
      }

      // Add reveal class
      this.$container.addClass(this.cssClasses.visible);

      // Track previously focused element
      this.previouslyActiveElement = document.activeElement;

      // Focus on the close button after the animation in has completed
      setTimeout(() => {
        this.$container.find('.cc-popup-close')[0].focus();
      }, 500);

      // Pressing escape closes the modal
      $(window).on('keydown' + this.namespace, event => {
        if (event.keyCode === 27) {
          this.close();
        }
      });

      if (callback) {
        callback();
      }
    }

    /**
     * Close popup on click of close button or background - where does the focus go back to?
     * Remove the cc-popup--visible class
     */
    close(callback) {
      // Remove reveal class
      this.$container.removeClass(this.cssClasses.visible);

      // Revert focus
      if (this.previouslyActiveElement) {
        $(this.previouslyActiveElement).focus();
      }

      // Destroy the escape event listener
      $(window).off('keydown' + this.namespace);

      // Allow the body to scroll and remove any scrollbar-compensating padding
      if (this.$container.data('freeze-scroll')) {
        var transitionDuration = 500;

        var $innerModal = this.$container.find('.cc-popup-modal');
        if ($innerModal.length) {
          transitionDuration = parseFloat(getComputedStyle($innerModal[0])['transitionDuration']);
          if (transitionDuration && transitionDuration > 0) {
            transitionDuration *= 1000;
          }
        }

        setTimeout(() => {
          $('body').removeClass(this.cssClasses.bodyNoScroll).removeClass(this.cssClasses.bodyNoScrollPadRight).css('padding-right', '0');
        }, transitionDuration);
      }

      if (callback) {
        callback();
      }
    }}
  ;
  class PriceRangeInstance {
    constructor(container) {
      this.container = container;
      this.selectors = {
        inputMin: '.cc-price-range__input--min',
        inputMax: '.cc-price-range__input--max',
        control: '.cc-price-range__control',
        controlMin: '.cc-price-range__control--min',
        controlMax: '.cc-price-range__control--max',
        bar: '.cc-price-range__bar',
        activeBar: '.cc-price-range__bar-active' };

      this.controls = {
        min: {
          barControl: container.querySelector(this.selectors.controlMin),
          input: container.querySelector(this.selectors.inputMin) },

        max: {
          barControl: container.querySelector(this.selectors.controlMax),
          input: container.querySelector(this.selectors.inputMax) } };


      this.controls.min.value = parseInt(this.controls.min.input.value === '' ? this.controls.min.input.placeholder : this.controls.min.input.value);
      this.controls.max.value = parseInt(this.controls.max.input.value === '' ? this.controls.max.input.placeholder : this.controls.max.input.value);
      this.valueMin = this.controls.min.input.min;
      this.valueMax = this.controls.min.input.max;
      this.valueRange = this.valueMax - this.valueMin;

      [this.controls.min, this.controls.max].forEach(item => {
        item.barControl.setAttribute('aria-valuemin', this.valueMin);
        item.barControl.setAttribute('aria-valuemax', this.valueMax);
        item.barControl.setAttribute('tabindex', 0);
      });
      this.controls.min.barControl.setAttribute('aria-valuenow', this.controls.min.value);
      this.controls.max.barControl.setAttribute('aria-valuenow', this.controls.max.value);

      this.bar = container.querySelector(this.selectors.bar);
      this.activeBar = container.querySelector(this.selectors.activeBar);
      this.inDrag = false;

      this.bindEvents();
      this.render();
    }

    getPxToValueRatio() {
      return this.bar.clientWidth / (this.valueMax - this.valueMin);
    }

    getPcToValueRatio() {
      return 100.0 / (this.valueMax - this.valueMin);
    }

    setActiveControlValue(value) {
      // only accept valid numbers
      if (isNaN(parseInt(value))) return;

      // clamp & default
      if (this.activeControl === this.controls.min) {
        if (value === '') {
          value = this.valueMin;
        }
        value = Math.max(this.valueMin, value);
        value = Math.min(value, this.controls.max.value);
      } else {
        if (value === '') {
          value = this.valueMax;
        }
        value = Math.min(this.valueMax, value);
        value = Math.max(value, this.controls.min.value);
      }

      // round
      this.activeControl.value = Math.round(value);

      // update input
      if (this.activeControl.input.value != this.activeControl.value) {
        if (this.activeControl.value == this.activeControl.input.placeholder) {
          this.activeControl.input.value = '';
        } else {
          this.activeControl.input.value = this.activeControl.value;
        }
        this.activeControl.input.dispatchEvent(new CustomEvent('change', { bubbles: true, cancelable: false, detail: { sender: 'theme:component:price_range' } }));
      }

      // a11y
      this.activeControl.barControl.setAttribute('aria-valuenow', this.activeControl.value);
    }

    render() {
      this.drawControl(this.controls.min);
      this.drawControl(this.controls.max);
      this.drawActiveBar();
    }

    drawControl(control) {
      control.barControl.style.left = (control.value - this.valueMin) * this.getPcToValueRatio() + '%';
    }

    drawActiveBar() {
      this.activeBar.style.left = (this.controls.min.value - this.valueMin) * this.getPcToValueRatio() + '%';
      this.activeBar.style.right = (this.valueMax - this.controls.max.value) * this.getPcToValueRatio() + '%';
    }

    handleControlTouchStart(e) {
      e.preventDefault();
      this.startDrag(e.target, e.touches[0].clientX);
      this.boundControlTouchMoveEvent = this.handleControlTouchMove.bind(this);
      this.boundControlTouchEndEvent = this.handleControlTouchEnd.bind(this);
      window.addEventListener('touchmove', this.boundControlTouchMoveEvent);
      window.addEventListener('touchend', this.boundControlTouchEndEvent);
    }

    handleControlTouchMove(e) {
      this.moveDrag(e.touches[0].clientX);
    }

    handleControlTouchEnd(e) {
      e.preventDefault();
      window.removeEventListener('touchmove', this.boundControlTouchMoveEvent);
      window.removeEventListener('touchend', this.boundControlTouchEndEvent);
      this.stopDrag();
    }

    handleControlMouseDown(e) {
      e.preventDefault();
      this.startDrag(e.target, e.clientX);
      this.boundControlMouseMoveEvent = this.handleControlMouseMove.bind(this);
      this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this);
      window.addEventListener('mousemove', this.boundControlMouseMoveEvent);
      window.addEventListener('mouseup', this.boundControlMouseUpEvent);
    }

    handleControlMouseMove(e) {
      this.moveDrag(e.clientX);
    }

    handleControlMouseUp(e) {
      e.preventDefault();
      window.removeEventListener('mousemove', this.boundControlMouseMoveEvent);
      window.removeEventListener('mouseup', this.boundControlMouseUpEvent);
      this.stopDrag();
    }

    startDrag(target, startX) {
      if (this.controls.min.barControl === target) {
        this.activeControl = this.controls.min;
      } else {
        this.activeControl = this.controls.max;
      }
      this.dragStartX = startX;
      this.dragStartValue = this.activeControl.value;
      this.inDrag = true;
    }

    moveDrag(moveX) {
      if (this.inDrag) {
        var value = this.dragStartValue + (moveX - this.dragStartX) / this.getPxToValueRatio();
        this.setActiveControlValue(value);
        this.render();
      }
    }

    stopDrag() {
      this.inDrag = false;
    }

    handleControlKeyDown(e) {
      if (e.key === 'ArrowRight') {
        this.incrementControlFromKeypress(e.target, 10.0);
      } else if (e.key === 'ArrowLeft') {
        this.incrementControlFromKeypress(e.target, -10.0);
      }
    }

    incrementControlFromKeypress(control, pxAmount) {
      if (this.controls.min.barControl === control) {
        this.activeControl = this.controls.min;
      } else {
        this.activeControl = this.controls.max;
      }
      this.setActiveControlValue(this.activeControl.value + pxAmount / this.getPxToValueRatio());
      this.render();
    }

    handleInputChange(e) {
      // strip out non numeric values
      e.target.value = e.target.value.replace(/\D/g, '');

      if (!e.detail || e.detail.sender != 'theme:component:price_range') {
        if (this.controls.min.input === e.target) {
          this.activeControl = this.controls.min;
        } else {
          this.activeControl = this.controls.max;
        }
        this.setActiveControlValue(e.target.value);
        this.render();
      }
    }

    handleInputKeyup(e) {
      // enforce numeric chars in the input
      setTimeout(function () {
        this.value = this.value.replace(/\D/g, '');
      }.bind(e.target), 10);
    }

    bindEvents() {
      [this.controls.min, this.controls.max].forEach(item => {
        item.barControl.addEventListener('touchstart', this.handleControlTouchStart.bind(this));
        item.barControl.addEventListener('mousedown', this.handleControlMouseDown.bind(this));
        item.barControl.addEventListener('keydown', this.handleControlKeyDown.bind(this));
        item.input.addEventListener('change', this.handleInputChange.bind(this));
        item.input.addEventListener('keyup', this.handleInputKeyup.bind(this));
      });
    }

    destroy() {
    }}


  class PriceRange extends ccComponent {
    constructor() {var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'price-range';var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-".concat(name);
      super(name, cssSelector);
    }

    init(container) {
      super.init(container);
      this.registerInstance(container, new PriceRangeInstance(container));
    }

    destroy(container) {
      this.destroyInstance(container);
      super.destroy(container);
    }}


  new PriceRange();
  class AccordionInstance {
    constructor(container) {
      this.accordion = container;
      this.itemClass = '.cc-accordion-item';
      this.titleClass = '.cc-accordion-item__title';
      this.panelClass = '.cc-accordion-item__panel';
      this.allowMultiOpen = this.accordion.dataset.allowMultiOpen === 'true';

      // If multiple open items not allowed, set open item as active (if there is one)
      if (!this.allowMultiOpen) {
        this.activeItem = this.accordion.querySelector("".concat(this.itemClass, "[open]"));
      }

      this.bindEvents();
    }

    /**
     * Adds inline 'height' style to a panel, to trigger open transition
     * @param {HTMLDivElement} panel - The accordion item content panel
     */
    static addPanelHeight(panel) {
      panel.style.height = "".concat(panel.scrollHeight, "px");
    }

    /**
     * Removes inline 'height' style from a panel, to trigger close transition
     * @param {HTMLDivElement} panel - The accordion item content panel
     */
    static removePanelHeight(panel) {
      panel.getAttribute('style'); // Fix Safari bug (doesn't remove attribute without this first!)
      panel.removeAttribute('style');
    }

    /**
     * Opens an accordion item
     * @param {HTMLDetailsElement} item - The accordion item
     * @param {HTMLDivElement} panel - The accordion item content panel
     */
    open(item, panel) {
      panel.style.height = '0';

      // Set item to open. Blocking the default click action and opening it this way prevents a
      // slight delay which causes the panel height to be set to '0' (because item's not open yet)
      item.open = true;

      AccordionInstance.addPanelHeight(panel);

      // Slight delay required before starting transitions
      setTimeout(() => {
        item.classList.add('is-open');
      }, 10);

      if (!this.allowMultiOpen) {
        // If there's an active item and it's not the opened item, close it
        if (this.activeItem && this.activeItem !== item) {
          var activePanel = this.activeItem.querySelector(this.panelClass);
          this.close(this.activeItem, activePanel);
        }

        this.activeItem = item;
      }
    }

    /**
     * Closes an accordion item
     * @param {HTMLDetailsElement} item - The accordion item
     * @param {HTMLDivElement} panel - The accordion item content panel
     */
    close(item, panel) {
      AccordionInstance.addPanelHeight(panel);

      item.classList.remove('is-open');
      item.classList.add('is-closing');

      if (this.activeItem === item) {
        this.activeItem = null;
      }

      // Slight delay required to allow scroll height to be applied before changing to '0'
      setTimeout(() => {
        panel.style.height = '0';
      }, 10);
    }

    /**
     * Handles 'click' event on the accordion
     * @param {Object} e - The event object
     */
    handleClick(e) {
      // Ignore clicks outside a toggle (<summary> element)
      var toggle = e.target.closest(this.titleClass);
      if (!toggle) return;

      // Prevent the default action
      // We'll trigger it manually after open transition initiated or close transition complete
      e.preventDefault();

      var item = toggle.parentNode;
      var panel = toggle.nextElementSibling;

      if (item.open) {
        this.close(item, panel);
      } else {
        this.open(item, panel);
      }
    }

    /**
     * Handles 'transitionend' event in the accordion
     * @param {Object} e - The event object
     */
    handleTransition(e) {
      // Ignore transitions not on a panel element
      if (!e.target.matches(this.panelClass)) return;

      var panel = e.target;
      var item = panel.parentNode;

      if (item.classList.contains('is-closing')) {
        item.classList.remove('is-closing');
        item.open = false;
      }

      AccordionInstance.removePanelHeight(panel);
    }

    bindEvents() {
      // Need to assign the function calls to variables because bind creates a new function,
      // which means the event listeners can't be removed in the usual way
      this.clickHandler = this.handleClick.bind(this);
      this.transitionHandler = this.handleTransition.bind(this);

      this.accordion.addEventListener('click', this.clickHandler);
      this.accordion.addEventListener('transitionend', this.transitionHandler);
    }

    destroy() {
      this.accordion.removeEventListener('click', this.clickHandler);
      this.accordion.removeEventListener('transitionend', this.transitionHandler);
    }}


  class Accordion extends ccComponent {
    constructor() {var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'accordion';var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-".concat(name);
      super(name, cssSelector);
    }

    init(container) {
      super.init(container);
      this.registerInstance(container, new AccordionInstance(container));
    }

    destroy(container) {
      this.destroyInstance(container);
      super.destroy(container);
    }}


  new Accordion();
  /**
   * Adjusts the css top property of an element such that it sticks appropriately based on the scroll direction. The
   * container is assumed to be position: sticky, with top: 0 (or whatever).
   *
   * When scrolling down, it'll stick to the bottom of the container, when scrolling up it'll stick to the top of
   * the container.
   */
  class StickyScrollDirectionInstance {
    constructor(container) {
      if (!container) {
        console.warn("StickyScrollDirection component: No container provided");
        return;
      }

      if (window.innerWidth >= 768) {
        this.container = container;
        this.currentTop = parseInt(getComputedStyle(this.container).top);
        this.defaultTop = this.currentTop;
        this.scrollY = window.scrollY;
        this.bindEvents();
      }
    }

    bindEvents() {
      this.scrollListener = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.scrollListener);

      // Use the 'data-cc-sticky-scroll-top' attribute to update the defaultTop. Example use - if the container should
      // stick under the nav, but the nav changes height (either a result from a browser resize, or Theme Editor setting
      // tweak), set this attr the new nav height
      if (typeof this.container.dataset.ccStickyScrollTop !== "undefined") {
        this.observer = new MutationObserver(mutations => {
          for (var mutation of mutations) {
            if (mutation.attributeName === "data-cc-sticky-scroll-top") {
              this.defaultTop = parseInt(mutation.target.dataset.ccStickyScrollTop);
            }
          }
        });
        this.observer.observe(this.container, { attributes: true });
      }
    }

    /**
     * Updates the current css top based on scroll direction
     */
    handleScroll() {
      var bounds = this.container.getBoundingClientRect();
      var maxTop = bounds.top + window.scrollY - this.container.offsetTop + this.defaultTop;
      var minTop = this.container.clientHeight - window.innerHeight;

      if (window.scrollY < this.scrollY) {
        this.currentTop -= window.scrollY - this.scrollY;
      } else {
        this.currentTop += this.scrollY - window.scrollY;
      }

      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.defaultTop);
      this.scrollY = window.scrollY;
      this.container.style.top = this.currentTop + "px";
    }

    destroy() {
      window.removeEventListener('scroll', this.scrollListener);
      if (this.observer) {
        this.observer.disconnect();
      }
    }}


  class StickyScrollDirection extends ccComponent {
    constructor() {var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'sticky-scroll-direction';var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-".concat(name);
      super(name, cssSelector);
    }

    init(container) {
      super.init(container);
      this.registerInstance(container, new StickyScrollDirectionInstance(container));
    }

    destroy(container) {
      this.destroyInstance(container);
      super.destroy(container);
    }}


  new StickyScrollDirection();


  // Manage videos
  theme.VideoManager = new function () {
    var _ = this;

    _._permitPlayback = function (container) {
      return !($(container).hasClass('video-container--background') && $(window).outerWidth() < 768);
    };

    // Youtube
    _.youtubeVars = {
      incrementor: 0,
      apiReady: false,
      videoData: {},
      toProcessSelector: '.video-container[data-video-type="youtube"]:not(.video--init)' };


    _.youtubeApiReady = function () {
      _.youtubeVars.apiReady = true;
      _._loadYoutubeVideos();
    };

    _._loadYoutubeVideos = function (container) {
      if ($(_.youtubeVars.toProcessSelector, container).length) {
        if (_.youtubeVars.apiReady) {

          // play those videos
          $(_.youtubeVars.toProcessSelector, container).each(function () {
            // Don't init background videos on mobile
            if (_._permitPlayback($(this))) {
              $(this).addClass('video--init');
              _.youtubeVars.incrementor++;
              var containerId = 'theme-yt-video-' + _.youtubeVars.incrementor;
              $(this).data('video-container-id', containerId);
              var videoElement = $('<div class="video-container__video-element">').attr('id', containerId).
              appendTo($('.video-container__video', this));
              // var autoplay = $(this).data('video-autoplay');
              var autoplay = 1;
              var loop = $(this).data('video-loop');
              var player = new YT.Player(containerId, {
                height: '360',
                width: '640',
                videoId: $(this).data('video-id'),
                playerVars: {
                  iv_load_policy: 3,
                  modestbranding: 1,
                  autoplay: 1,
                  loop: loop ? 1 : 0,
                  playlist: $(this).data('video-id'),
                  rel: 0,
                  showinfo: 0 },

                events: {
                  onReady: _._onYoutubePlayerReady.bind({ autoplay: autoplay, loop: loop, $container: $(this) }),
                  onStateChange: _._onYoutubePlayerStateChange.bind({ autoplay: autoplay, loop: loop, $container: $(this) }) } });


              _.youtubeVars.videoData[containerId] = {
                id: containerId,
                container: this,
                videoElement: videoElement,
                player: player };

            }
          });
        } else {
          // load api
          theme.loadScriptOnce('https://www.youtube.com/iframe_api');
        }
      }
    };

    _._onYoutubePlayerReady = function (event) {
      event.target.setPlaybackQuality('hd1080');
      if (this.autoplay) {
        event.target.mute();
        event.target.playVideo();
      }

      _._initBackgroundVideo(this.$container);
    };

    _._onYoutubePlayerStateChange = function (event) {
      if (event.data == YT.PlayerState.PLAYING) {
        this.$container.addClass('video--play-started');

        if (this.autoplay) {
          event.target.mute();
        }

        if (this.loop) {
          // 4 times a second, check if we're in the final second of the video. If so, loop it for a more seamless loop
          var finalSecond = event.target.getDuration() - 1;
          if (finalSecond > 2) {
            function loopTheVideo() {
              if (event.target.getCurrentTime() > finalSecond) {
                event.target.seekTo(0);
              }
              setTimeout(loopTheVideo, 250);
            }
            loopTheVideo();
          }
        }
      }
    };

    _._unloadYoutubeVideos = function (container) {
      for (var dataKey in _.youtubeVars.videoData) {
        var data = _.youtubeVars.videoData[dataKey];
        if ($(container).find(data.container).length) {
          data.player.destroy();
          delete _.youtubeVars.videoData[dataKey];
          return;
        }
      }
    };

    // Vimeo
    _.vimeoVars = {
      incrementor: 0,
      apiReady: false,
      videoData: {},
      toProcessSelector: '.video-container[data-video-type="vimeo"]:not(.video--init)' };


    _.vimeoApiReady = function () {
      _.vimeoVars.apiReady = true;
      _._loadVimeoVideos();
    };

    _._loadVimeoVideos = function (container) {
      if ($(_.vimeoVars.toProcessSelector, container).length) {
        if (_.vimeoVars.apiReady) {
          // play those videos

          $(_.vimeoVars.toProcessSelector, container).each(function () {
            // Don't init background videos on mobile
            if (_._permitPlayback($(this))) {
              $(this).addClass('video--init');
              _.vimeoVars.incrementor++;
              var $this = $(this);
              var containerId = 'theme-vi-video-' + _.vimeoVars.incrementor;
              $(this).data('video-container-id', containerId);
              var videoElement = $('<div class="video-container__video-element">').attr('id', containerId).
              appendTo($('.video-container__video', this));
              var autoplay = !!$(this).data('video-autoplay');
              var player = new Vimeo.Player(containerId, {
                url: $(this).data('video-url'),
                width: 640,
                loop: $(this).data('video-autoplay'),
                autoplay: autoplay,
                muted: $this.hasClass('video-container--background') || autoplay });

              player.on('playing', function () {
                $(this).addClass('video--play-started');
              }.bind(this));
              player.ready().then(function () {
                if (autoplay) {
                  player.setVolume(0);
                  player.play();
                }
                if (player.element && player.element.width && player.element.height) {
                  var ratio = parseInt(player.element.height) / parseInt(player.element.width);
                  $this.find('.video-container__video').css('padding-bottom', ratio * 100 + '%');
                }
                _._initBackgroundVideo($this);
              });
              _.vimeoVars.videoData[containerId] = {
                id: containerId,
                container: this,
                videoElement: videoElement,
                player: player,
                autoPlay: autoplay };

            }
          });
        } else {
          // load api
          if (window.define) {
            // workaround for third parties using RequireJS
            theme.loadScriptOnce('https://player.vimeo.com/api/player.js', function () {
              _.vimeoVars.apiReady = true;
              _._loadVimeoVideos();
              window.define = window.tempDefine;
            }, function () {
              window.tempDefine = window.define;
              window.define = null;
            });
          } else {
            theme.loadScriptOnce('https://player.vimeo.com/api/player.js', function () {
              _.vimeoVars.apiReady = true;
              _._loadVimeoVideos();
            });
          }
        }
      }
    };

    _._unloadVimeoVideos = function (container) {
      for (var dataKey in _.vimeoVars.videoData) {
        var data = _.vimeoVars.videoData[dataKey];
        if ($(container).find(data.container).length) {
          data.player.unload();
          delete _.vimeoVars.videoData[dataKey];
          return;
        }
      }
    };

    // Init third party apis - Youtube and Vimeo
    _._loadThirdPartyApis = function (container) {
      //Don't init youtube or vimeo background videos on mobile
      if (_._permitPlayback($('.video-container', container))) {
        _._loadYoutubeVideos(container);
        _._loadVimeoVideos(container);
      }
    };

    // Mp4
    _.mp4Vars = {
      incrementor: 0,
      videoData: {},
      toProcessSelector: '.video-container[data-video-type="mp4"]:not(.video--init)' };


    _._loadMp4Videos = function (container) {
      if ($(_.mp4Vars.toProcessSelector, container).length) {
        // play those videos
        $(_.mp4Vars.toProcessSelector, container).addClass('video--init').each(function () {
          _.mp4Vars.incrementor++;
          var $this = $(this);
          var containerId = 'theme-mp-video-' + _.mp4Vars.incrementor;
          $(this).data('video-container-id', containerId);
          var videoElement = $('<div class="video-container__video-element">').attr('id', containerId).
          appendTo($('.video-container__video', this));

          var $video = $('<video playsinline>');
          if ($(this).data('video-loop')) {
            $video.attr('loop', 'loop');
          }
          if (!$(this).hasClass('video-container--background')) {
            $video.attr('controls', 'controls');
          }
          if ($(this).data('video-autoplay')) {
            $video.attr({ autoplay: 'autoplay', muted: 'muted' });
            $video[0].muted = true; // required by Chrome - ignores attribute
            $video.one('loadeddata', function () {
              this.play();
            });
          }
          $video.on('playing', function () {
            $(this).addClass('video--play-started');
          }.bind(this));
          $video.attr('src', $(this).data('video-url')).appendTo(videoElement);
          _.mp4Vars.videoData[containerId] = {
            element: $video[0] };

        });
      }
    };

    _._unloadMp4Videos = function (container) {
    };

    // background video placement for iframes
    _._initBackgroundVideo = function ($container) {
      if ($container.hasClass('video-container--background') && $container.find('.video-container__video iframe').length) {
        function assessBackgroundVideo() {
          var $media = $('.video-container__media', this),
          $container = $media.length ? $media : this,
          cw = $container.width(),
          ch = $container.height(),
          cr = cw / ch,
          $frame = $('.video-container__video iframe', this),
          vr = $frame.attr('width') / $frame.attr('height'),
          $pan = $('.video-container__video', this),
          vCrop = 75; // pushes video outside container to hide controls
          if (cr > vr) {
            var vh = cw / vr + vCrop * 2;
            $pan.css({
              marginTop: (ch - vh) / 2 - vCrop,
              marginLeft: '',
              height: vh + vCrop * 2,
              width: '' });

          } else {
            var vw = cw * vr + vCrop * 2 * vr;
            $pan.css({
              marginTop: -vCrop,
              marginLeft: (cw - vw) / 2,
              height: ch + vCrop * 2,
              width: vw });

          }
        }
        assessBackgroundVideo.bind($container)();
        $(window).on('debouncedresize.' + $container.data('video-container-id'), assessBackgroundVideo.bind($container));
      }
    };

    // Compatibility with Sections
    this.onSectionLoad = function (container) {
      // url only - infer type
      $('.video-container[data-video-url]:not([data-video-type])').each(function () {
        var url = $(this).data('video-url');

        if (url.indexOf('.mp4') > -1) {
          $(this).attr('data-video-type', 'mp4');
        }

        if (url.indexOf('vimeo.com') > -1) {
          $(this).attr('data-video-type', 'vimeo');
          $(this).attr('data-video-id', url.split('?')[0].split('/').pop());
        }

        if (url.indexOf('youtu.be') > -1 || url.indexOf('youtube.com') > -1) {
          $(this).attr('data-video-type', 'youtube');
          if (url.indexOf('v=') > -1) {
            $(this).attr('data-video-id', url.split('v=').pop().split('&')[0]);
          } else {
            $(this).attr('data-video-id', url.split('?')[0].split('/').pop());
          }
        }
      });

      _._loadThirdPartyApis(container);
      _._loadMp4Videos(container);

      $(window).on('debouncedresize.video-manager-resize', function () {
        _._loadThirdPartyApis(container);
      });

      // play button
      $('.video-container__play', container).on('click', function (evt) {
        evt.preventDefault();
        var $container = $(this).closest('.video-container');
        // reveal
        $container.addClass('video-container--playing');

        // broadcast a play event on the section container
        $(container).trigger("cc:video:play");

        // play
        var id = $container.data('video-container-id');
        if (id.indexOf('theme-yt-video') === 0) {
          _.youtubeVars.videoData[id].player.playVideo();
        } else if (id.indexOf('theme-vi-video') === 0) {
          _.vimeoVars.videoData[id].player.play();
        } else if (id.indexOf('theme-mp-video') === 0) {
          _.mp4Vars.videoData[id].element.play();
        }
      });

      var sectionVideo = document.querySelectorAll('.js-content-with-video');
      var sectionNotified = false;
      function handleScroll() {
        sectionVideo.forEach(function(section) {
          var btnPlay = $('.js-play-video');
          var rect = section.getBoundingClientRect();
          if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2 && !sectionNotified) {
            var $container = btnPlay.closest('.video-container');
            $container.addClass('video-container--playing');
            $(container).trigger("cc:video:play");
            // play
            var id = $container.data('video-container-id');
            _.youtubeVars.videoData[id].player.playVideo();
            if (id.indexOf('theme-yt-video') === 0) {
              _.youtubeVars.videoData[id].player.playVideo();
            } else if (id.indexOf('theme-vi-video') === 0) {
              _.vimeoVars.videoData[id].player.play();
            } else if (id.indexOf('theme-mp-video') === 0) {
              _.mp4Vars.videoData[id].element.play();
            }
            sectionNotified = true;
          }
        })
        //
      }
      window.addEventListener('scroll', handleScroll);
      // modal close button
      $('.video-container__stop', container).on('click', function (evt) {
        evt.preventDefault();
        var $container = $(this).closest('.video-container');
        // hide
        $container.removeClass('video-container--playing');

        // broadcast a stop event on the section container
        $(container).trigger("cc:video:stop");

        // play
        var id = $container.data('video-container-id');
        if (id.indexOf('theme-yt-video') === 0) {
          _.youtubeVars.videoData[id].player.stopVideo();
        } else {
          _.vimeoVars.videoData[id].player.pause();
          _.vimeoVars.videoData[id].player.setCurrentTime(0);
        }
      });
    };

    this.onSectionUnload = function (container) {
      $('.video-container__play, .video-container__stop', container).off('click');
      $(window).off('.' + $('.video-container').data('video-container-id'));
      $(window).off('debouncedresize.video-manager-resize');
      _._unloadYoutubeVideos(container);
      _._unloadVimeoVideos(container);
      _._unloadMp4Videos(container);
      $(container).trigger("cc:video:stop");
    };
  }();

  // Youtube API callback
  window.onYouTubeIframeAPIReady = function () {
    theme.VideoManager.youtubeApiReady();
  };

  // Register the section
  cc.sections.push({
    name: 'video',
    section: theme.VideoManager });

  theme.MapSection = new function () {
    var _ = this;
    _.config = {
      zoom: 14,
      styles: {
        default: [],
        silver: [{ "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5" }] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#bdbdbd" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#dadada" }] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#c9c9c9" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }],
        retro: [{ "elementType": "geometry", "stylers": [{ "color": "#ebe3cd" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#523735" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f1e6" }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#c9b2a6" }] }, { "featureType": "administrative.land_parcel", "elementType": "geometry.stroke", "stylers": [{ "color": "#dcd2be" }] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#ae9e90" }] }, { "featureType": "landscape.natural", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#93817c" }] }, { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#a5b076" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#447530" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#f5f1e6" }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#fdfcf8" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#f8c967" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#e9bc62" }] }, { "featureType": "road.highway.controlled_access", "elementType": "geometry", "stylers": [{ "color": "#e98d58" }] }, { "featureType": "road.highway.controlled_access", "elementType": "geometry.stroke", "stylers": [{ "color": "#db8555" }] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#806b63" }] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] }, { "featureType": "transit.line", "elementType": "labels.text.fill", "stylers": [{ "color": "#8f7d77" }] }, { "featureType": "transit.line", "elementType": "labels.text.stroke", "stylers": [{ "color": "#ebe3cd" }] }, { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#b9d3c2" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#92998d" }] }],
        dark: [{ "elementType": "geometry", "stylers": [{ "color": "#212121" }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#212121" }] }, { "featureType": "administrative", "elementType": "geometry", "stylers": [{ "color": "#757575" }] }, { "featureType": "administrative.country", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "administrative.land_parcel", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.locality", "elementType": "labels.text.fill", "stylers": [{ "color": "#bdbdbd" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#181818" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "featureType": "poi.park", "elementType": "labels.text.stroke", "stylers": [{ "color": "#1b1b1b" }] }, { "featureType": "road", "elementType": "geometry.fill", "stylers": [{ "color": "#2c2c2c" }] }, { "featureType": "road", "elementType": "labels.text.fill", "stylers": [{ "color": "#8a8a8a" }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#373737" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#3c3c3c" }] }, { "featureType": "road.highway.controlled_access", "elementType": "geometry", "stylers": [{ "color": "#4e4e4e" }] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "featureType": "transit", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#000000" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#3d3d3d" }] }],
        night: [{ "elementType": "geometry", "stylers": [{ "color": "#242f3e" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#746855" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#242f3e" }] }, { "featureType": "administrative.locality", "elementType": "labels.text.fill", "stylers": [{ "color": "#d59563" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#d59563" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#263c3f" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#6b9a76" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#38414e" }] }, { "featureType": "road", "elementType": "geometry.stroke", "stylers": [{ "color": "#212a37" }] }, { "featureType": "road", "elementType": "labels.text.fill", "stylers": [{ "color": "#9ca5b3" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#746855" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#1f2835" }] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#f3d19c" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#2f3948" }] }, { "featureType": "transit.station", "elementType": "labels.text.fill", "stylers": [{ "color": "#d59563" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#17263c" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#515c6d" }] }, { "featureType": "water", "elementType": "labels.text.stroke", "stylers": [{ "color": "#17263c" }] }],
        aubergine: [{ "elementType": "geometry", "stylers": [{ "color": "#1d2c4d" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#8ec3b9" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#1a3646" }] }, { "featureType": "administrative.country", "elementType": "geometry.stroke", "stylers": [{ "color": "#4b6878" }] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#64779e" }] }, { "featureType": "administrative.province", "elementType": "geometry.stroke", "stylers": [{ "color": "#4b6878" }] }, { "featureType": "landscape.man_made", "elementType": "geometry.stroke", "stylers": [{ "color": "#334e87" }] }, { "featureType": "landscape.natural", "elementType": "geometry", "stylers": [{ "color": "#023e58" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#283d6a" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#6f9ba5" }] }, { "featureType": "poi", "elementType": "labels.text.stroke", "stylers": [{ "color": "#1d2c4d" }] }, { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#023e58" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#3C7680" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#304a7d" }] }, { "featureType": "road", "elementType": "labels.text.fill", "stylers": [{ "color": "#98a5be" }] }, { "featureType": "road", "elementType": "labels.text.stroke", "stylers": [{ "color": "#1d2c4d" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#2c6675" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#255763" }] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#b0d5ce" }] }, { "featureType": "road.highway", "elementType": "labels.text.stroke", "stylers": [{ "color": "#023e58" }] }, { "featureType": "transit", "elementType": "labels.text.fill", "stylers": [{ "color": "#98a5be" }] }, { "featureType": "transit", "elementType": "labels.text.stroke", "stylers": [{ "color": "#1d2c4d" }] }, { "featureType": "transit.line", "elementType": "geometry.fill", "stylers": [{ "color": "#283d6a" }] }, { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#3a4762" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#0e1626" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#4e6d70" }] }] } };


    _.apiStatus = null;

    this.geolocate = function ($map) {
      var deferred = $.Deferred();
      var geocoder = new google.maps.Geocoder();
      var address = $map.data('address-setting');

      geocoder.geocode({ address: address }, function (results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          deferred.reject(status);
        }

        deferred.resolve(results);
      });

      return deferred;
    };

    this.createMap = function (container) {
      var $map = $('.map-section__map-container', container);

      return _.geolocate($map).
      then(
      function (results) {
        var mapOptions = {
          zoom: _.config.zoom,
          styles: _.config.styles[$(container).data('map-style')],
          center: results[0].geometry.location,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          disableDefaultUI: true,
          zoomControl: true };


        _.map = new google.maps.Map($map[0], mapOptions);
        _.center = _.map.getCenter();

        var marker = new google.maps.Marker({
          map: _.map,
          position: _.center,
          clickable: false });


        google.maps.event.addDomListener(window, 'resize', function () {
          google.maps.event.trigger(_.map, 'resize');
          _.map.setCenter(_.center);
        });
      }.bind(this)).

      fail(function () {
        var errorMessage;

        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = theme.strings.addressNoResults;
            break;
          case 'OVER_QUERY_LIMIT':
            errorMessage = theme.strings.addressQueryLimit;
            break;
          default:
            errorMessage = theme.strings.addressError;
            break;}


        // Only show error in the theme editor
        if (Shopify.designMode) {
          var $mapContainer = $map.parents('.map-section');

          $mapContainer.addClass('page-width map-section--load-error');
          $mapContainer.
          find('.map-section__wrapper').
          html(
          '<div class="errors text-center">' + errorMessage + '</div>');

        }
      });
    };

    this.onSectionLoad = function (target) {
      var $container = $(target);
      // Global function called by Google on auth errors
      window.gm_authFailure = function () {
        if (!Shopify.designMode) return;

        $container.addClass('page-width map-section--load-error');
        $container.
        find('.map-section__wrapper').
        html(
        '<div class="errors text-center">' + theme.strings.authError + '</div>');

      };

      // create maps
      var key = $container.data('api-key');

      if (typeof key !== 'string' || key === '') {
        return;
      }

      // load map
      theme.loadScriptOnce('https://maps.googleapis.com/maps/api/js?key=' + key, function () {
        _.createMap($container);
      });
    };

    this.onSectionUnload = function (target) {
      if (typeof window.google !== 'undefined' && typeof google.maps !== 'undefined') {
        google.maps.event.clearListeners(_.map, 'resize');
      }
    };
  }();

  // Register the section
  cc.sections.push({
    name: 'map',
    section: theme.MapSection });

  /**
   * Popup Section Script
   * ------------------------------------------------------------------------------
   *
   * @namespace Popup
   */

  theme.Popup = new function () {
    /**
     * Popup section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */

    var dismissedStorageKey = 'cc-theme-popup-dismissed';

    this.onSectionLoad = function (container) {
      this.namespace = theme.namespaceFromSection(container);
      this.$container = $(container);
      this.popup = new ccPopup(this.$container, this.namespace);

      var dismissForDays = this.$container.data('dismiss-for-days'),
      delaySeconds = this.$container.data('delay-seconds'),
      showPopup = true,
      testMode = this.$container.data('test-mode'),
      lastDismissed = window.localStorage.getItem(dismissedStorageKey);

      // Should we show it during this page view?
      // Check when it was last dismissed
      if (lastDismissed) {
        var dismissedDaysAgo = (new Date().getTime() - lastDismissed) / (1000 * 60 * 60 * 24);
        if (dismissedDaysAgo < dismissForDays) {
          showPopup = false;
        }
      }

      // Check for error or success messages
      if (this.$container.find('.cc-popup-form__response').length) {
        showPopup = true;
        delaySeconds = 1;

        // If success, set as dismissed
        if (this.$container.find('.cc-popup-form__response--success').length) {
          this.functions.popupSetAsDismissed.call(this);
        }
      }

      // Prevent popup on Shopify robot challenge page
      if (document.querySelector('.shopify-challenge__container')) {
        showPopup = false;
      }

      // Show popup, if appropriate
      if (showPopup || testMode) {
        setTimeout(() => {
          this.popup.open();
        }, delaySeconds * 1000);
      }

      // Click on close button or modal background
      this.$container.on('click' + this.namespace, '.cc-popup-close, .cc-popup-background', () => {
        this.popup.close(() => {
          this.functions.popupSetAsDismissed.call(this);
        });
      });
    };

    this.onSectionSelect = function () {
      this.popup.open();
    };

    this.functions = {
      /**
       * Use localStorage to set as dismissed
       */
      popupSetAsDismissed: function popupSetAsDismissed() {
        window.localStorage.setItem(dismissedStorageKey, new Date().getTime());
      } };


    /**
     * Event callback for Theme Editor `section:unload` event
     */
    this.onSectionUnload = function () {
      this.$container.off(this.namespace);
    };
  }();

  // Register section
  cc.sections.push({
    name: 'newsletter-popup',
    section: theme.Popup });

  /**
   * StoreAvailability Section Script
   * ------------------------------------------------------------------------------
   *
   * @namespace StoreAvailability
   */

  theme.StoreAvailability = function (container) {
    var loadingClass = 'store-availability-loading';
    var initClass = 'store-availability-initialized';
    var storageKey = 'cc-location';

    this.onSectionLoad = function (container) {
      this.namespace = theme.namespaceFromSection(container);
      this.$container = $(container);
      this.productId = this.$container.data('store-availability-container');
      this.sectionUrl = this.$container.data('section-url');
      this.$modal;

      this.$container.addClass(initClass);
      this.transitionDurationMS = parseFloat(getComputedStyle(container).transitionDuration) * 1000;
      this.removeFixedHeightTimeout = -1;

      // Handle when a variant is selected
      $(window).on("cc-variant-updated".concat(this.namespace).concat(this.productId), (e, args) => {
        if (args.product.id === this.productId) {
          this.functions.updateContent.bind(this)(
          args.variant ? args.variant.id : null,
          args.product.title,
          this.$container.data('has-only-default-variant'),
          args.variant && typeof args.variant.available !== "undefined");

        }
      });

      // Handle single variant products
      if (this.$container.data('single-variant-id')) {
        this.functions.updateContent.bind(this)(
        this.$container.data('single-variant-id'),
        this.$container.data('single-variant-product-title'),
        this.$container.data('has-only-default-variant'),
        this.$container.data('single-variant-product-available'));

      }
    };

    this.onSectionUnload = function () {
      $(window).off("cc-variant-updated".concat(this.namespace).concat(this.productId));
      this.$container.off('click');
      if (this.$modal) {
        this.$modal.off('click');
      }
    };

    this.functions = {
      // Returns the users location data (if allowed)
      getUserLocation: function getUserLocation() {
        return new Promise((resolve, reject) => {
          var storedCoords;

          if (sessionStorage[storageKey]) {
            storedCoords = JSON.parse(sessionStorage[storageKey]);
          }

          if (storedCoords) {
            resolve(storedCoords);

          } else {
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
              function (position) {
                var coords = {
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude };


                //Set the localization api
                fetch('/localization.json', {
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json' },

                  body: JSON.stringify(coords) });


                //Write to a session storage
                sessionStorage[storageKey] = JSON.stringify(coords);

                resolve(coords);
              }, function () {
                resolve(false);
              }, {
                maximumAge: 3600000, // 1 hour
                timeout: 5000 });


            } else {
              resolve(false);
            }
          }
        });
      },

      // Requests the available stores and calls the callback
      getAvailableStores: function getAvailableStores(variantId, cb) {
        return $.get(this.sectionUrl.replace('VARIANT_ID', variantId), cb);
      },

      // Haversine Distance
      // The haversine formula is an equation giving great-circle distances between
      // two points on a sphere from their longitudes and latitudes
      calculateDistance: function calculateDistance(coords1, coords2, unitSystem) {
        var dtor = Math.PI / 180;
        var radius = unitSystem === 'metric' ? 6378.14 : 3959;

        var rlat1 = coords1.latitude * dtor;
        var rlong1 = coords1.longitude * dtor;
        var rlat2 = coords2.latitude * dtor;
        var rlong2 = coords2.longitude * dtor;

        var dlon = rlong1 - rlong2;
        var dlat = rlat1 - rlat2;

        var a =
        Math.pow(Math.sin(dlat / 2), 2) +
        Math.cos(rlat1) * Math.cos(rlat2) * Math.pow(Math.sin(dlon / 2), 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return radius * c;
      },

      // Updates the existing modal pickup with locations with distances from the user
      updateLocationDistances: function updateLocationDistances(coords) {
        var unitSystem = this.$modal.find('[data-unit-system]').data('unit-system');
        var self = this;

        this.$modal.find('[data-distance="false"]').each(function () {
          var thisCoords = {
            latitude: parseFloat($(this).data('latitude')),
            longitude: parseFloat($(this).data('longitude')) };


          if (thisCoords.latitude && thisCoords.longitude) {
            var distance = self.functions.calculateDistance(
            coords, thisCoords, unitSystem).toFixed(1);

            $(this).html(distance);

            //Timeout to trigger animation
            setTimeout(() => {
              $(this).closest('.store-availability-list__location__distance').addClass('-in');
            }, 0);
          }

          $(this).attr('data-distance', 'true');
        });
      },

      // Requests the available stores and updates the page with info below Add to Basket, and append the modal to the page
      updateContent: function updateContent(variantId, productTitle, isSingleDefaultVariant, isVariantAvailable) {
        this.$container.off('click', '[data-store-availability-modal-open]');
        this.$container.off('click' + this.namespace, '.cc-popup-close, .cc-popup-background');
        $('.store-availabilities-modal').remove();

        if (!isVariantAvailable) {
          //If the variant is Unavailable (not the same as Out of Stock) - hide the store pickup completely
          this.$container.addClass(loadingClass);
          if (this.transitionDurationMS > 0) {
            this.$container.css('height', '0px');
          }
        } else {
          this.$container.addClass(loadingClass);
          if (this.transitionDurationMS > 0) {
            this.$container.css('height', this.$container.outerHeight() + 'px');
          }
        }

        if (isVariantAvailable) {
          this.functions.getAvailableStores.call(this, variantId, response => {
            if (response.trim().length > 0 && !response.includes('NO_PICKUP')) {
              this.$container.html(response);
              this.$container.html(this.$container.children().first().html()); // editor bug workaround

              this.$container.find('[data-store-availability-modal-product-title]').html(productTitle);

              if (isSingleDefaultVariant) {
                this.$container.find('.store-availabilities-modal__variant-title').remove();
              }

              this.$container.find('.cc-popup').appendTo('body');

              this.$modal = $('body').find('.store-availabilities-modal');
              var popup = new ccPopup(this.$modal, this.namespace);

              this.$container.on('click', '[data-store-availability-modal-open]', () => {
                popup.open();

                //When the modal is opened, try and get the users location
                this.functions.getUserLocation().then(coords => {
                  if (coords && this.$modal.find('[data-distance="false"]').length) {
                    //Re-retrieve the available stores location modal contents
                    this.functions.getAvailableStores.call(this, variantId, response => {
                      this.$modal.find('.store-availabilities-list').html($(response).find('.store-availabilities-list').html());
                      this.functions.updateLocationDistances.bind(this)(coords);
                    });
                  }
                });

                return false;
              });

              this.$modal.on('click' + this.namespace, '.cc-popup-close, .cc-popup-background', () => {
                popup.close();
              });

              this.$container.removeClass(loadingClass);

              if (this.transitionDurationMS > 0) {
                var newHeight = this.$container.find('.store-availability-container').outerHeight();
                this.$container.css('height', newHeight > 0 ? newHeight + 'px' : '');
                clearTimeout(this.removeFixedHeightTimeout);
                this.removeFixedHeightTimeout = setTimeout(() => {
                  this.$container.css('height', '');
                }, this.transitionDurationMS);
              }
            }
          });
        }
      } };


    // Initialise the section when it's instantiated
    this.onSectionLoad(container);
  };

  // Register section
  cc.sections.push({
    name: 'store-availability',
    section: theme.StoreAvailability });



  // ensure root_url ends in a slash
  if (!/\/$/.test(theme.routes.root_url)) theme.routes.root_url += '/';

  /*================ General Barry Bits ================*/
  theme.icons = {
    left: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
    right: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
    close: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
    chevronLightLeft: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 14.51,6.51 14,6 8,12 14,18 14.51,17.49 9.03,12 Z"></path></svg>',
    chevronLightRight: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 10,6 9.49,6.51 14.97,12 9.49,17.49 10,18 16,12 Z"></path></svg>',
    chevronDown: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>',
    tick: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>',
    add: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
    loading: '<svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: transparent; display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="currentColor" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(263.279 50 50)"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>',
    chevronRight: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path><polyline points="10 17.83 15.4 12.43 10 7.03" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:1.5px"></polyline></svg>',
    chevronLeft: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"/> <polyline points="14.4 7.03 9 12.43 14.4 17.83" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:1.5px"/></svg>',
    dotsActive: '<?xml version="1.0" encoding="UTF-8"?><svg id="a" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 182.21 167"><image transform="scale(.28)" xlink:href="data:image/png;base64,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"/></svg>',
    dots: '<?xml version="1.0" encoding="UTF-8"?><svg id="a" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 157.64 144.48"><image transform="scale(.24)" xlink:href="data:image/png;base64,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"/></svg>' };


  theme.swipers = {};

  theme.productData = {};

  theme.viewport = {
    isXs: () => {
      return $(window).outerWidth() < 768;
    },
    isSm: () => {
      return $(window).outerWidth() >= 768;
    },
    isMd: () => {
      return $(window).outerWidth() >= 992;
    },
    isLg: () => {
      return $(window).outerWidth() >= 1200;
    },
    isXlg: () => {
      return $(window).outerWidth() >= 1441;
    },
    scroll: {
      currentScrollTop: -1,

      to: function to($elem) {var scrollTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;var cb = arguments.length > 3 ? arguments[3] : undefined;
        if ($elem && typeof $elem === 'string') {
          $elem = $($elem);
        }

        if (scrollTop === -1 && $elem && $elem.length) {
          var navHeight = theme.Nav().bar.isInline() ? 0 : theme.Nav().bar.height();
          scrollTop = $elem.offset().top - navHeight - offset;
        }

        $('html,body').animate({ scrollTop }, 700, () => {
          if (cb) {
            cb();
          }
        });
      },

      // Locks scrolling on the body in place
      lock: () => {
        theme.viewport.scroll.currentScrollTop = window.scrollY;

        //Set the body top to the current scroll position so we dont get jumped to the top
        document.body.style.top = -window.scrollY + 'px';
        document.body.style.width = '100%';
        document.body.style.position = 'fixed';

        if (document.body.scrollHeight > window.outerHeight) {
          //There is a vertical scrollbar, compensate for that
          document.body.style.overflowY = 'scroll';
        }
      },

      unlock: () => {
        document.body.style.top = null;
        document.body.style.overflowY = null;
        document.body.style.width = null;
        document.body.style.position = null;
        window.scrollTo({ top: theme.viewport.scroll.currentScrollTop, behavior: 'instant' });
      } }

    // ,
    // isElementInView: (el) => {
    //   // Special bonus for those using jQuery
    //   if (typeof jQuery === "function" && el instanceof jQuery) {
    //     el = el[0];
    //   }
    //
    //   var rect = el.getBoundingClientRect();
    //
    //   return (
    //     rect.top >= 0 &&
    //     rect.left >= 0 &&
    //     rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    //     rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    //   );
    // },
  };

  theme.device = {
    cache: {
      isTouch: null,
      isRetinaDisplay: null },

    isTouch: () => {
      if (theme.device.cache.isTouch !== null) {
        return theme.device.cache.isTouch;
      } else {
        try {
          document.createEvent("TouchEvent");
          theme.device.cache.isTouch = true;
        } catch (e) {
          theme.device.cache.isTouch = false;
        } finally {
          return theme.device.cache.isTouch;
        }
      }
    },
    isRetinaDisplay() {
      if (theme.device.cache.isRetinaDisplay !== null) {
        return theme.device.cache.isRetinaDisplay;
      } else {
        if (window.matchMedia) {
          var mq = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
          theme.device.cache.isRetinaDisplay = mq && mq.matches || window.devicePixelRatio > 1;
        } else {
          theme.device.cache.isRetinaDisplay = false;
        }
        return theme.device.cache.isRetinaDisplay;
      }
    } };


  if (window.Element && !Element.prototype.closest) {
    Element.prototype.closest =
    function (s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
      i,
      el = this;
      do {
        i = matches.length;
        while (--i >= 0 && matches.item(i) !== el) {};
      } while (i < 0 && (el = el.parentElement));
      return el;
    };
  }
  ;

  /*================ Components ================*/
  theme.Nav = function () {var $navBar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $('#site-control');
    return {
      bar: {
        //Actions
        turnOpaque: _turnOpaque => {
          if (_turnOpaque) {
            $navBar.addClass('nav-opaque');
          } else {
            $navBar.removeClass('nav-opaque');
          }
        },
        hide: _hide => {
          if (_hide) {
            $navBar.addClass('nav-hidden');
          } else {
            $navBar.removeClass('nav-hidden');
          }
        },
        fadeOut: _fadeOut => {
          if (_fadeOut) {
            $navBar.addClass('nav-fade-out');
          } else {
            $navBar.removeClass('nav-fade-out');
          }
        },
        hideAnnouncement: hide => {
          if (hide) {
            $navBar.addClass('announcement-hidden');
          } else {
            $navBar.removeClass('announcement-hidden');
          }
        },

        //Note: Don't reference $navBar below as the object may have changed (if in theme editor)

        //Settings
        hasOpaqueSetting: () => {
          return $('#site-control').data('opacity').includes('opaque');
        },
        hasStickySetting: () => {
          return $('#site-control').data('positioning') === "sticky";
        },
        isInline: () => {
          return $('#site-control').data('positioning') === "inline";
        },
        hasInlineLinks: () => {
          return $('#site-control.nav-inline-desktop').length === 1;
        },
        getPositionSetting: () => {
          return $('#site-control').data('positioning');
        },
        getOpacitySetting: () => {
          return $('#site-control').data('opacity');
        },

        //Current state
        isCurrentlyOpaque: () => {
          return $('#site-control').hasClass('nav-opaque');
        },
        isAnnouncementBar: () => {
          return $('#site-control').find('.cc-announcement__inner').length === 1;
        },
        hasLocalization: () => {
          return $('#site-control').hasClass('has-localization');
        },
        heightExcludingAnnouncementBar: () => {
          return Math.round($('#site-control').find('.site-control__inner').outerHeight());
        },
        heightOfAnnouncementBar: () => {
          return Math.round($('#site-control').find('.announcement').outerHeight());
        },
        height: () => {
          //Returns the height including the announcement bar
          return Math.round($('#site-control').outerHeight());
        } } };


  };

  theme.ProductMediaGallery = function ($gallery, $thumbs, isFeaturedProduct, isQuickbuy, galleryId) {
    var _this = this;
    var currentMedia;
    var initialisedMedia = {};
    var $viewInSpaceButton = $gallery.find('.view-in-space');
    var $swiperCont = $gallery.find('.swiper-container');
    var swiper;
    var preventSizeRedraw = false;
    var vimeoApiReady = false;
    var isFirstRun = true;
    var mediaCount = $gallery.find('.theme-img:visible').length;
    var isCarouselLayout = $gallery.data('layout') === 'carousel';
    var isGalleryNarrow = $gallery.closest('.product-area').hasClass('product-area--restrict-width');
    var $productThumbnails = $gallery.closest('.product-area').find('.product-area__thumbs');
    var isMediaGroupingEnabled = $gallery.data('variant-image-grouping');
    var underlineSelectedMedia = $gallery.data('underline-selected-media');

    var nav = theme.Nav();

    this.Image = function ($elem, autoplay) {
      this.show = function () {
        $elem.addClass('product-media--activated');
        $elem.show();
      };

      this.play = function () {
        $gallery.find('.product-media--current').removeClass('product-media--current');
        $elem.addClass('product-media--current');
      };

      this.destroy = function () {};
      this.pause = function () {
        $elem.removeClass('product-media--activated');
      };

      this.hide = function () {
        $elem.hide();
      };

      //Init the image
      this.show();
    };

    this.Video = function ($elem, autoplay) {
      var _video = this;
      var playerObj = {
        play: function play() {},
        pause: function pause() {},
        destroy: function destroy() {} };

      var videoElement = $elem.find('video')[0];

      this.show = function () {
        $elem.addClass('product-media--activated');
        $elem.show();
        _this.slideshowTabFix();
      };

      this.play = function () {
        $gallery.find('.product-media--current').removeClass('product-media--current');
        $elem.addClass('product-media--current');
        _video.show();
        playerObj.play();
      };

      this.pause = function () {
        playerObj.pause();
        $elem.removeClass('product-media--activated');
      };

      this.hide = function () {
        playerObj.pause();
        $elem.hide();
      };

      this.destroy = function () {
        playerObj.destroy();
        $(videoElement).off('playing', handlePlay);
        $(document).off('fullscreenchange', delayedSwiperResize);
      };

      //Init the video
      theme.loadStyleOnce('https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css');

      // set up a controller for Plyr video
      window.Shopify.loadFeatures([{
        name: 'video-ui',
        version: '1.0',
        onLoad: function () {
          playerObj = {
            playerType: 'html5',
            element: videoElement,
            plyr: new Shopify.Plyr(videoElement, {
              controls: [
              'play',
              'progress',
              'mute',
              'volume',
              'play-large',
              'fullscreen'],

              loop: {
                active: $elem.data('enable-video-looping') },

              autoplay: theme.viewport.isSm() && autoplay,
              hideControlsOnPause: true,
              iconUrl: '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
              tooltips: {
                controls: false,
                seek: true } }),


            play: function play() {
              this.plyr.play();
            },
            pause: function pause() {
              this.plyr.pause();
            },
            destroy: function destroy() {
              this.plyr.destroy();
            } };

          $elem.addClass('product-media--video-loaded');

          // Disable swipe on the model
          $elem.find('.plyr__controls').addClass('swiper-no-swiping');

          initialisedMedia[$elem.data('media-id')] = _video;
        }.bind(this) }]);


      function handlePlay() {
        _this.pauseAllMedia($elem.data('media-id'));
      }

      $(videoElement).on('playing', handlePlay);

      function delayedSwiperResize(event) {
        preventSizeRedraw = true;

        // If not fullscreen
        if (window.innerHeight !== screen.height) {
          setTimeout(function () {
            preventSizeRedraw = true;
          }, 200);
        }
      }

      //When fullscreen ends, trigger a delayed resize to ensure swiper resets correctly
      $(document).on('fullscreenchange', delayedSwiperResize);

      _video.show();
    };

    this.ExternalVideo = function ($elem, autoplay) {
      var isPlaying = false;
      var _video = this;
      var playerObj = {
        play: function play() {},
        pause: function pause() {},
        destroy: function destroy() {} };

      var iframeElement = $elem.find('iframe')[0];

      this.play = function () {
        $gallery.find('.product-media--current').removeClass('product-media--current');
        $elem.addClass('product-media--current');
        _video.show();
        playerObj.play();
      };

      this.togglePlayPause = function () {
        if (isPlaying) {
          _video.pause();
        } else {
          _video.play();
        }
      };

      this.pause = function () {
        playerObj.pause();
        $elem.removeClass('product-media--activated');
      };

      this.show = function () {
        $elem.addClass('product-media--activated');
        $elem.show();
        _this.slideshowTabFix();
      };

      this.hide = function () {
        playerObj.pause();
        $elem.hide();
      };

      this.destroy = function () {
        playerObj.destroy();
        $elem.off('click', '.product-media--video-mask', _video.togglePlayPause);
      };

      //Init the external videoSingle 3d model only
      if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(iframeElement.src)) {
        var loadYoutubeVideo = function loadYoutubeVideo() {
          playerObj = {
            playerType: 'youtube',
            element: iframeElement,
            player: new YT.Player(iframeElement, {
              videoId: $elem.data('video-id'),
              events: {
                onReady: function onReady() {
                  initialisedMedia[$elem.data('media-id')] = _video;

                  $elem.addClass('product-media--video-loaded');

                  if (autoplay && theme.viewport.isSm()) {
                    _video.play();
                  }
                },
                onStateChange: function onStateChange(event) {
                  if (event.data === 1) {
                    _this.pauseAllMedia($elem.data('media-id'));
                  }
                  isPlaying = event.data === YT.PlayerState.PLAYING || event.data === YT.PlayerState.BUFFERING || event.data === YT.PlayerState.UNSTARTED;

                  if (event.data === 0 && $elem.data('enable-video-looping')) {
                    event.target.seekTo(0);
                  }
                } } }),


            play: function play() {
              this.player.playVideo();
            },
            pause: function pause() {
              this.player.pauseVideo();
            },
            destroy: function destroy() {
              this.player.destroy();
            } };

        };

        if (window.YT && window.YT.Player) {
          loadYoutubeVideo();
        } else {
          // set up a controller for YouTube video
          var temp = window.onYouTubeIframeAPIReady;
          window.onYouTubeIframeAPIReady = function () {
            temp();
            loadYoutubeVideo();
          };

          theme.loadScriptOnce('https://www.youtube.com/iframe_api');
        }
      } else if (/vimeo\.com/.test(iframeElement.src)) {
        var loadVimeoVideos = function loadVimeoVideos() {
          if (vimeoApiReady) {
            if ($elem.data('enable-video-looping')) {
              iframeElement.setAttribute('src', iframeElement.getAttribute('src') + '&loop=1');
            }

            if (autoplay && $(window).width() >= 768) {
              iframeElement.setAttribute('src', iframeElement.getAttribute('src') + '&autoplay=1&muted=1');
            }

            playerObj = {
              playerType: 'vimeo',
              element: iframeElement,
              player: new Vimeo.Player(iframeElement),
              play: function play() {
                this.player.play();
              },
              pause: function pause() {
                this.player.pause();
              },
              destroy: function destroy() {
                this.player.destroy();
              } };


            playerObj.player.ready().then(function () {
              initialisedMedia[$elem.data('media-id')] = _video;
              $elem.addClass('product-media--video-loaded');
            });

          } else {
            theme.loadScriptOnce('https://player.vimeo.com/api/player.js', function () {
              vimeoApiReady = true;
              loadVimeoVideos();
            });
          }
        };
        loadVimeoVideos();
      }

      $elem.on('click', '.product-media--video-mask', _video.togglePlayPause);

      _video.show();
    };

    this.Model = function ($elem, autoplay) {
      var _model = this;
      var playerObj = {
        play: function play() {},
        pause: function pause() {},
        destroy: function destroy() {} };

      var modelElement = $elem.find('model-viewer')[0];

      this.show = function () {
        $elem.show();
        $elem.addClass('product-media--activated');
        _this.slideshowTabFix();
        _model.updateViewInSpaceButton();
      };

      this.updateViewInSpaceButton = function () {
        if (window.ShopifyXR && $viewInSpaceButton.length) {
          //Change the view in space button to launch this model
          $viewInSpaceButton.attr('data-shopify-model3d-id', $elem.data('media-id'));
          window.ShopifyXR.setupXRElements();
        }
      };

      this.play = function () {
        $gallery.find('.product-media--current').removeClass('product-media--current');
        $elem.addClass('product-media--current');
        _model.show();
        playerObj.play();
      };

      this.pause = function () {
        $elem.removeClass('product-media--activated');
        playerObj.pause();
      };

      this.hide = function () {
        playerObj.pause();
        $elem.hide();

        if (window.ShopifyXR && $viewInSpaceButton.length) {
          //Reset the view in space button to launch the first model
          $viewInSpaceButton.attr('data-shopify-model3d-id', $viewInSpaceButton.data('shopify-model3d-first-id'));
          $viewInSpaceButton.attr('data-shopify-title', $viewInSpaceButton.data('shopify-first-title'));
          window.ShopifyXR.setupXRElements();
        }
      };

      this.destroy = function () {
        //Nothing needed
      };

      this.initAugmentedReality = function () {
        if ($('.model-json', $gallery).length) {
          var doInit = function doInit() {
            if (!window.ShopifyXR) {
              document.addEventListener('shopify_xr_initialized', function shopifyXrEventListener(event) {
                doInit();

                //Ensure this only fires once
                event.target.removeEventListener(event.type, shopifyXrEventListener);
              });

              return;
            }

            window.ShopifyXR.addModels(JSON.parse($('.model-json', $gallery).html()));
            window.ShopifyXR.setupXRElements();
          };

          window.Shopify.loadFeatures([{
            name: 'shopify-xr',
            version: '1.0',
            onLoad: doInit }]);

        }
      };

      //Init the model
      theme.loadStyleOnce('https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css');

      window.Shopify.loadFeatures([
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: function () {
          playerObj = new Shopify.ModelViewerUI(modelElement);
          $elem.addClass('product-media--model-loaded');

          if (autoplay && theme.viewport.isSm()) {
            _model.play();
          }

          // add mouseup event proxy to fix carousel swipe gestures
          $('<div class="theme-event-proxy">').on('mouseup', function (e) {
            e.stopPropagation();
            e.preventDefault();
            document.dispatchEvent(new MouseEvent('mouseup'));
          }).appendTo(
          $(this).find('.shopify-model-viewer-ui__controls-overlay'));


          // Prevent the buttons from submitting the form
          $elem.find('button').attr('type', 'button');

          // Disable swipe on the model
          $elem.find('.shopify-model-viewer-ui').addClass('swiper-no-swiping');

        }.bind(this) }]);



      $elem.find('model-viewer').on('shopify_model_viewer_ui_toggle_play', function () {
        _this.pauseAllMedia($elem.data('media-id'));
        $elem.addClass('product-media-model--playing');
        $gallery.on('click', '.product-media:not([data-media-type="model"])', _model.pause);
      });

      $elem.find('model-viewer').on('shopify_model_viewer_ui_toggle_pause', function () {
        $elem.removeClass('product-media-model--playing');
        $gallery.off('click', '.product-media:not([data-media-type="model"])', _model.pause);
      });

      $elem.on('click', '.product-media--model-mask', function () {
        if (isCarouselLayout) {
          //If we're on a featured product, delay the initialisation of the model until the current slide has changed
          _this.swipeToSlideIfNotCurrent($elem);
          setTimeout(_model.play, 500);
        } else {
          _model.play();
        }
      });

      initialisedMedia[$elem.data('media-id')] = _model;

      _model.show();

      if (!window.ShopifyXR) {
        _model.initAugmentedReality();
      }
    };

    this.pauseAllMedia = function (ignoreKey) {
      for (var key in initialisedMedia) {
        if (initialisedMedia.hasOwnProperty(key) && (!ignoreKey || key != ignoreKey)) {
          initialisedMedia[key].pause();
        }
      }
    };

    this.showMedia = function ($mediaToShow, autoplay, preventHide) {
      //In with the new
      if ($mediaToShow.length) {
        //Out with the old
        if (currentMedia && !preventHide) {
          currentMedia.pause();
        }

        //Function to instantiate and return the relevant media
        var getMedia = function getMedia(MediaType) {
          var media;

          if (initialisedMedia.hasOwnProperty($mediaToShow.data('media-id'))) {
            media = initialisedMedia[$mediaToShow.data('media-id')];

            if (autoplay && theme.viewport.isSm()) {
              media.show();
              //Delay play so its easier for users to understand that it paused
              setTimeout(media.play, 250);
            } else {
              media.show();
            }
          } else {
            media = new MediaType($mediaToShow, autoplay);
          }

          return media;
        };

        //Initialise the media
        if ($mediaToShow.data('media-type') === "image") {
          currentMedia = getMedia(_this.Image);
        } else if ($mediaToShow.data('media-type') === "video") {
          currentMedia = getMedia(_this.Video);
        } else if ($mediaToShow.data('media-type') === "external_video") {
          currentMedia = getMedia(_this.ExternalVideo);
        } else if ($mediaToShow.data('media-type') === "model") {
          currentMedia = getMedia(_this.Model);
        } else {
          console.warn('Media is unknown', $mediaToShow);
          $gallery.find('.product-media:visible').hide();
          $mediaToShow.show();
        }
      }
    };

    this.swipeToSlideIfNotCurrent = function ($elem) {
      var $slide = $elem.closest('.swiper-slide');
      swiper.slideTo($slide.index(), 500);
    };

    this.destroy = function () {
      for (var i = 0; i < initialisedMedia.length; i++) {
        initialisedMedia[i].destroy();
      }

      if (!isCarouselLayout) {
        $(window).off("load.productTemplateGallery".concat(galleryId, " scroll.productTemplateGallery").concat(galleryId), detectHeaderOverGallery);
      }

      $gallery.closest('.product-area').off('click', '.product-area__thumbs__thumb a', handleThumbnailClick);
      $gallery.off('click', '[data-full-size]', handleImageClick);

      $gallery.off('variantImageSelected', _this.pauseAllMedia);
      $(window).off("ccScrollToMedia.productTemplateGallery".concat(galleryId));
      $(window).off(".".concat(galleryId));

      if ($thumbs && $thumbs.length) {
        $thumbs.off('click');
      }

      destroySwiper();
      destroyColumns();

      if ($productThumbnails.length) {
        destroyThumbnails();
      }
    };

    this.slideshowTabFix = function () {
      if (swiper) {
        // which slide are we going to?
        var $activeMedia = $swiperCont.find('.product-media--current'),
        $activeSlide = null;

        if ($activeMedia.length) {
          $activeSlide = $activeMedia.closest('.swiper-slide');
        } else {
          $activeSlide = $swiperCont.find('.swiper-slide.swiper-slide-active');
        }

        // tabindex everything to prevent tabbing into hidden slides
        $activeSlide.find('a, input, button, select, iframe, video, model-viewer, [tabindex]').each(function () {
          if (typeof $(this).data('theme-slideshow-original-tabindex') !== 'undefined') {
            if ($(this).data('theme-slideshow-original-tabindex') === false) {
              $(this).removeAttr('tabindex');
            } else {
              $(this).attr('tabindex', $(this).data('theme-slideshow-original-tabindex'));
            }
          } else {
            $(this).removeAttr('tabindex');
          }
        });
        $($swiperCont.find('.swiper-slide')).not($activeSlide).find('a, input, button, select, iframe, video, model-viewer, [tabindex]').each(function () {
          if (typeof $(this).data('theme-slideshow-original-tabindex') === 'undefined') {
            $(this).data('theme-slideshow-original-tabindex',
            typeof $(this).attr('tabindex') !== 'undefined' ?
            $(this).attr('tabindex') :
            false);

          }
          $(this).attr('tabindex', '-1');
        });
      }
    };

    this.scrollToMedia = function (mediaId) {
      var $variantImage = $("[data-media-id=\"".concat(mediaId, "\"]"));

      //Scroll to that variant image
      if ($variantImage.length && ($('body').hasClass('template-product') || isQuickbuy) && theme.viewport.isSm()) {
        var offset = parseInt($gallery.find('.theme-images').css('padding-top').replace('px', ''));
        var scrollAmount;

        if (!isQuickbuy) {
          scrollAmount = $variantImage.offset().top - offset + 1;

          //If the nav is opaque and sticky, compensate for the nav when scrolling
          if (nav.bar.hasOpaqueSetting() && nav.bar.hasStickySetting() ||
          isGalleryNarrow && nav.bar.hasStickySetting() ||
          $gallery.data('column-count') > 1 && $(window).outerWidth() >= 1100) {
            scrollAmount -= nav.bar.heightExcludingAnnouncementBar();
          }

          //If scrolling up and the nav is set hide on scroll down, subtract the nav from the new position
          if (scrollAmount < $(window).scrollTop() && nav.bar.getPositionSetting() === 'peek' && nav.bar.hasOpaqueSetting()) {
            scrollAmount -= nav.bar.heightExcludingAnnouncementBar();
          }

          scrollAmount = scrollAmount < 200 ? 0 : scrollAmount;
        } else {
          scrollAmount = $variantImage.offset().top - $(window).scrollTop() + $('#quick-buy-modal').scrollTop();
        }

        if ($gallery.data('column-count') === 1 && $(window).outerWidth() >= 1100 && isQuickbuy) {
          scrollAmount -= isGalleryNarrow ? 60 : -1; //The distance from the top of the viewport
        }

        if (isQuickbuy) {
          $('#quick-buy-modal').animate({
            scrollTop: scrollAmount },
          800);
        } else {
          $('html,body').animate({
            scrollTop: scrollAmount },
          800);
        }
      }
    };

    function detectHeaderOverGallery() {
      var nav = theme.Nav();
      $('body').toggleClass('header-over-gallery', $(window).scrollTop() < $gallery.height() - nav.bar.height());
    }

    function initColumns() {
      var columns = $gallery.data('column-count');
      var isCollage = $gallery.data('layout') === 'collage';

      if (isCollage) {
        var $collageImages = $gallery.find('.theme-img:visible');
        $collageImages.first().addClass('theme-img--collage-full');
        // $collageImages.last().addClass('theme-img--collage-last');
      }

      var $elements = $gallery.find('.theme-img:visible:not(.theme-img--collage-full)');

      var $finalImage,offset = 0;
      if ($elements.length % 2 > 0 && isCollage) {
        $finalImage = $elements.children().last();
        offset = 1;
      }

      var elementsPerCol = Math.ceil(($elements.length - offset) / columns);
      var $colContainer = $gallery.find('.theme-images');
      var currentCol = -1;
      var $colWrapper;

      if (columns > 1 && $elements.length - offset > 1) {
        $elements.each(function (i) {
          if (offset === 0 || i < $elements.length - offset) {
            if (currentCol < Math.floor(i / elementsPerCol)) {
              $colWrapper = $("<div class=\"media-column\"></div>").appendTo($colContainer);
              currentCol++;
            }

            $(this).appendTo($colWrapper);
          }
        });
      }

      if ($finalImage) {
        $finalImage.parent().addClass('theme-img--collage-full').addClass('theme-img--collage-last').appendTo($colContainer);
      }
    }

    function destroyColumns() {
      var $colContainer = $gallery.find('.theme-images');
      $colContainer.find('.theme-img').each(function () {
        $(this).appendTo($colContainer).removeClass('theme-img--collage-full').removeClass('theme-img--collage-last');
      });
      $(window).off('debouncedresize.columnheights');

      $colContainer.find('.media-column').remove();
    }

    //Check if media should be displayed in columns
    if (theme.viewport.isSm() && $gallery.data('column-count') === 2) {
      setTimeout(initColumns, 0);
    }

    //Init all media
    $gallery.find('.product-media').each(function (index) {
      _this.showMedia($(this), false, true);
    });

    //Init swiper
    var $swiperExternalVideos = $swiperCont.find('[data-media-type="external_video"]');

    //Scrolls to the media of the clicked thumbnail
    function handleThumbnailClick(e) {
      e.preventDefault();
      var mediaId = $(this).closest('[data-media-thumb-id]').data('media-thumb-id');
      var $media = $gallery.find(".product-media[data-media-id=\"".concat(mediaId, "\"]"));
      //Scroll to that variant image
      if ($media.length) {
        //fixed and not data-opacity="transparent"
        $gallery.closest('.product-area').find('.thumb-active').removeClass('thumb-active');
        $(this).addClass('thumb-active');
        setTimeout(() => {_this.scrollToMedia(mediaId);}, 0);
      }

      return false;
    }

    //Opens the zoom modal
    function handleImageClick() {
      var nav = theme.Nav();

      if (theme.viewport.isSm()) {
        var thisSmallSizeImageUrl = $(this).find('.rimage-wrapper > img')[0].currentSrc;
        var $allImages = $(this).closest('.theme-images').find('[data-full-size]:visible');
        var imageHtml = "<a href=\"#\" data-modal-close class=\"modal-close\">&times;</a>";

        $allImages.each(function () {
          var smallSizeImageUrl = $(this).find('.rimage-wrapper > img')[0].currentSrc;
          var fullSizeImageUrl = $(this).data('full-size');
          var extraAttrs = thisSmallSizeImageUrl === smallSizeImageUrl ? "id='zoom-image'" : "";

          //Build the html for the images within the modal
          imageHtml += "<img class=\"zoom-image\" ".concat(extraAttrs, " src=\"").concat(smallSizeImageUrl, "\" data-full-size=\"").concat(fullSizeImageUrl, "\"/>");
        });

        showThemeModal($('<div class="theme-modal theme-modal--fullscreen temp -light"  role="dialog" aria-modal="true"/>').append("\n           <div class='inner-scroller -out'>".concat(
        imageHtml, "</div>")), 'product-image', function ($modal) {

          var $mainImage = $('#zoom-image');
          $mainImage.attr('src', $mainImage.data('full-size'));

          setTimeout(() => {
            //Set full resolution of the other images
            $modal.find('[data-full-size]').each(function () {
              $(this).attr('src', $(this).data('full-size'));
            });
          }, 100);

          setTimeout(() => {
            //Scroll to the middle of the image
            $modal.scrollTop($mainImage.position().top + ($mainImage.outerHeight() / 2 - $modal.outerHeight() / 2));

            //Scroll to the top of the image
            $modal.find('.inner-scroller').removeClass('-out');
          }, 1000);
        });
      }
    }

    // Bind listeners
    if ($gallery.hasClass('theme-gallery--thumbs-enabled')) {
      $gallery.closest('.product-area').on('click', '.product-area__thumbs__thumb a', handleThumbnailClick);
    }

    if ($gallery.hasClass('theme-gallery--zoom-enabled')) {
      $gallery.on('click', '[data-full-size]', handleImageClick);
    }

    $(window).off("ccScrollToMedia.productTemplateGallery".concat(galleryId)).on("ccScrollToMedia.productTemplateGallery".concat(
    galleryId), function (e, mediaId) {
      if ($gallery.data('scroll-to-variant-media') !== false || theme.viewport.isXs()) {
        setTimeout(() => {_this.scrollToMedia(mediaId);}, 0);
      }
    });

    if (!isCarouselLayout) {
      $(detectHeaderOverGallery);
      // indicate if header over the gallery
      $(window).on("scroll.productTemplateGallery".concat(galleryId), detectHeaderOverGallery);
    } else {
      // set external video dimensions for featured products
      $swiperExternalVideos.each(function () {
        $(this).width($gallery.outerHeight() * $(this).data('aspectratio'));
      });
    }

    function initThumbnails() {
      $('.carousel-wrapper .carousel:not(.slick-initialized)', $productThumbnails).each(function ($slick) {
        $(this).on('init reInit setPosition', function () {
          var lastSlide = $(this).find('.slick-slide:last');
          if (lastSlide.length > 0) {
            var slideInnerWidth = lastSlide.position().left + lastSlide.outerWidth(true);
            var $carouselWrapper = $(this).parent();
            var carouselWidth = $carouselWrapper.outerWidth(true);

            if (carouselWidth > slideInnerWidth) {
              $(this).find('.slick-next, .slick-prev').addClass('theme-unnecessary').attr('tabindex', '-1');
            } else {
              $(this).find('.slick-next, .slick-prev').removeClass('theme-unnecessary').attr('tabindex', '0');
            }
          }
        }).on('init reInit setPosition', function ($slick) {
          $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');
          setTimeout(function () {
            $($slick.target).find('.slick-slide a').attr('tabindex', '0');
          });
        }).slick({
          autoplay: false,
          fade: false,
          infinite: false,
          useTransform: true,
          arrows: true,
          dots: true,
          slidesToShow: 5,
          slidesToScroll: 5,
          centerMode: false,
          verticalSwiping: true,
          vertical: true,
          prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronDown + '</button>',
          nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronDown + '</button>',
          responsive: [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3 } },


          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4 } }] });




      });

      if (theme.viewport.isMd()) {
        _this.adjustGalleryMargin = () => {
          $gallery.css('margin-top', "-".concat($productThumbnails.outerHeight(), "px"));
        };
        _this.adjustGalleryMargin();
        $(window).on('resize.thumbHeight', _this.adjustGalleryMargin);
        $(window).on('debouncedresizewidth.thumbHeight', _this.adjustGalleryMargin);
      }
    }

    function destroyThumbnails() {
      $('.carousel-wrapper .carousel', $productThumbnails).off('init reInit setPosition');
      $('.slick-slider', $productThumbnails).slick('unslick');
      $(window).off('resize.thumbHeight');
      $(window).off('debouncedresizewidth.thumbHeight');
    }

    function toggleThumbnailVisibility() {
      $('.slick-slider', $productThumbnails).slick('slickFilter', '[data-cc-hidden="false"]');
    }
    // Hides the irrelevant variant media
    function initVariantImageGrouping() {
      var productData = theme.OptionManager.getProductData(null, $gallery.data('product-id'));

      if (productData.media && productData.media.length > 1 &&
      productData.variants && productData.variants.length > 1 &&
      productData.options && productData.options.length > 0) {

        var getFirstMatchingOptionIndex = function getFirstMatchingOptionIndex(productOptions) {
          productOptions = productOptions.map(option => option.toLowerCase());

          var colorOptions = $gallery.data('variant-image-grouping-option').split(',');

          for (var colorOption of colorOptions) {
            var index = productOptions.indexOf(colorOption.trim());
            if (index > -1) {
              return index;
            }
          }

          return -1;
        };

        var colorOptionIndex = getFirstMatchingOptionIndex(productData.options);

        //If this product contains a grouping field (eg Color)
        if (colorOptionIndex > -1) {
          var mediaByVariantColor = [];
          productData.variants.forEach(variant => {
            if (variant.featured_media) {
              if (!mediaByVariantColor[variant.featured_media.id]) {
                mediaByVariantColor[variant.featured_media.id] = [];
              }
              mediaByVariantColor[variant.featured_media.id].push(variant.options[colorOptionIndex]);
            }
          });

          var previousColor;
          var slideContainer = $gallery[0].querySelector('.theme-images');
          var allSlides = $gallery[0].querySelectorAll('.theme-img');

          $gallery.on('variantImageSelected', (e, variant) => {
            var targetColor = variant.options[colorOptionIndex];
            var currentColor,newMediaVisible = false;

            //Only update the thumbnails when the color changes
            if (previousColor != targetColor) {
              if (isCarouselLayout || theme.viewport.isXs()) {
                slideContainer.innerHTML = "";
                slideContainer.append(...allSlides);
              }

              if ($productThumbnails.length) {
                $('.slick-slider', $productThumbnails).slick('slickUnfilter');
              }

              productData.media.forEach(media => {
                if (mediaByVariantColor[media.id]) {
                  currentColor = mediaByVariantColor[media.id];
                }

                var mediaElement = $gallery[0].querySelector("[data-media-id=\"".concat(media.id, "\"]"));
                if (mediaElement) {
                  var showMedia = !!(currentColor && currentColor.includes(targetColor));
                  if (mediaElement.parentElement.getAttribute('aria-hidden') == showMedia.toString()) {
                    newMediaVisible = true;
                  }

                  //Remove images which precede any variant image
                  if (!currentColor) {
                    mediaElement.parentElement.remove();
                  }

                  mediaElement.parentElement.setAttribute('aria-hidden', !showMedia);

                  if (isCarouselLayout || theme.viewport.isXs()) {
                    if (showMedia) {
                      // Lazy load any media that needs it
                      var lazyImage = mediaElement.querySelector('.lazyload--manual');
                      if (lazyImage) {
                        lazyImage.classList.remove('lazyload--manual');
                        lazyImage.classList.add('lazyload');
                      }
                    } else {
                      mediaElement.parentElement.remove();
                    }
                  }

                  if ($productThumbnails.length) {
                    var thumbnailElement = $productThumbnails[0].querySelector("[data-media-thumb-id=\"".concat(media.id, "\"]"));
                    if (thumbnailElement) {
                      thumbnailElement.setAttribute('data-cc-hidden', !showMedia);
                    }
                  }
                }
              });

              if (isCarouselLayout && newMediaVisible) {
                updateSwiperSlidesPerView();
              }

              if (theme.viewport.isSm() && $gallery.data('column-count') === 2 && !isFirstRun && newMediaVisible) {
                //Reinit columns/collage
                setTimeout(() => {
                  destroyColumns();
                  initColumns();
                }, 0);
              }

              if ($productThumbnails.length) {
                setTimeout(toggleThumbnailVisibility, 0);
              }

              isFirstRun = false;
              previousColor = targetColor;
            }
          });
        }
      }
    }

    // Check the number of visible media and update the carousel options accordingly
    function updateSwiperSlidesPerView() {
      var visibleSlides = $gallery[0].querySelectorAll('.theme-img:not([aria-hidden="true"])');
      var swiperId = $gallery.find('.swiper-container:first').attr('data-swiper-id');
      if (swiperId) {
        var thisSwiper = theme.swipers[swiperId];
        if (thisSwiper && thisSwiper.params) {
          thisSwiper.params.breakpoints[10000].slidesPerView = visibleSlides.length < 2 ? 1 : 2;
          $gallery.attr('data-media-count', visibleSlides.length);
          thisSwiper.currentBreakpoint = false;
          thisSwiper.update();
        }
      }
    }

    if (isMediaGroupingEnabled) {
      initVariantImageGrouping();
    }

    var initialisedSectionVariants = [];
    $gallery.on('variantImageSelected', function (e, args) {
      _this.pauseAllMedia();

      var $container = $(this);
      var sectionId = $container.closest('[data-section-id]').data('section-id');

      if ($(this).find('.swiper-container-horizontal').length) {
        var swiperId = $('.swiper-container:first', this).attr('data-swiper-id');
        var swiper = theme.swipers[swiperId];
        var $swiperContainer = this;

        setTimeout(function () {
          var matchIndex = 0,$match;
          $('.swiper-container:first .swiper-slide:not([aria-hidden="true"]) .product-media', $swiperContainer).each(function (index) {
            if ($(this).data('media-id') == args.featured_media.id) {
              matchIndex = index;
              $match = $(this);
            }
          });

          swiper.update();
          swiper.slideTo(matchIndex, theme.viewport.isXs() ? 500 : 800);

          if (underlineSelectedMedia) {
            $container.find('.product-media--active-variant').removeClass('product-media--active-variant');

            if ($match) {
              $match.closest('.product-media').addClass('product-media--active-variant');
            }
          }
        }, args.eventType === 'firstrun' ? 1500 : 0);
        //Above: If its the first page load, wait 1.5s for media to load

      } else if (!$(this).hasClass('featured-product__gallery')) {
        var isFirstSection = $container.closest('.shopify-section').index() === 0;
        if (isFirstSection || initialisedSectionVariants.includes(sectionId)) {
          $(window).trigger('ccScrollToMedia', args.featured_media.id);
        }
        initialisedSectionVariants.push(sectionId);

        if ($gallery.data('column-count') > 1 && underlineSelectedMedia) {
          $gallery.find('.product-media--active-variant').removeClass('product-media--active-variant');
          $gallery.find("[data-media-id=\"".concat(args.featured_media.id, "\"]")).addClass('product-media--active-variant');
        }
      }

      setTimeout(() => {
        //If thumbs, scroll to the active one and add a class to it
        var $thumbSlider = $("[data-section-id=\"".concat(sectionId, "\"] .product-area__thumbs .carousel.slick-initialized"));
        if ($thumbSlider.length === 1 && ($container.data('scroll-to-variant-media') !== false || theme.viewport.isXs())) {
          var $activeSlide = $thumbSlider.find("[data-media-thumb-id=\"".concat(args.featured_media.id, "\"]:first"));
          if ($activeSlide.length) {
            $thumbSlider.find('.thumb-active').removeClass('thumb-active');
            $activeSlide.find('a').addClass('thumb-active');
            $thumbSlider.slick('slickGoTo', $activeSlide.data('slick-index'));
          }
        }
      }, 0);
    });

    function initSwiper() {
      destroyColumns();

      var extraSwiperOpts = {};

      if ($swiperCont.data('swiper-nav-style') === 'dots') {
        extraSwiperOpts = {
          dynamicBullets: true,
          pagination: {
            el: $swiperCont.find('.swiper-pagination')[0],
            dynamicBullets: true } };


      } else {
        extraSwiperOpts = {
          navigation: {
            nextEl: $swiperCont.find('.swiper-button-next')[0],
            prevEl: $swiperCont.find('.swiper-button-prev')[0] } };


      }

      //Init swiper
      var swiperOpts = _objectSpread(_objectSpread({
        mode: 'horizontal',
        resizeReInit: true,
        autoHeight: false,
        scrollContainer: true,
        grabCursor: true,
        createPagination: false,
        preventClicks: false,
        freeMode: true,
        freeModeFluid: false,
        slidesPerView: mediaCount > 1 ? 2 : 1,
        loop: true,
        loopFillGroupWithBlank: true,
        spaceBetween: isCarouselLayout && isGalleryNarrow || isFeaturedProduct ? 20 : 0,
        dynamicBullets: false,
        mousewheel: {
          invert: true,
          forceToAxis: true },

        scrollbar: {
          el: $swiperCont.find('.swiper-scrollbar')[0],
          draggable: true } },

      extraSwiperOpts), {}, {
        breakpoints: {
          767: _objectSpread({
            autoHeight: true,
            slidesPerView: 1,
            spaceBetween: 0,
            freeMode: false,
            freeModeFluid: false },
          extraSwiperOpts),

          1199: {
            slidesPerView: 1 },

          10000: {
            slidesPerView: mediaCount > 1 ? 2 : 1 } },


        on: {
          init: function init() {
            lazySizes.autoSizer.checkElems();
            $swiperCont.find('.swiper-slide-active .lazyload--manual').removeClass('lazyload--manual').addClass('lazyload');

            var lazyLoadDelay = 500;

            if (theme.viewport.isXs()) {
              lazyLoadDelay = window.localStorage.getItem('is_first_visit') === null ? 6000 : 2000;
            }

            //Lazy load all slider images
            setTimeout(function () {
              $swiperCont.find('.lazyload--manual').removeClass('lazyload--manual').addClass('lazyload');
            }, lazyLoadDelay);

            //Hack for iPhone X - where loading the page on slower connection sometimes causes Swiper to steal focus
            if (theme.viewport.isXs() && $('.product-detail__form__options a:not(.size-chart-link)').length && !isCarouselLayout) {
              $('.product-detail__form__options a:not(.size-chart-link):first').focus();
              setTimeout(() => {
                $(window).scrollTop(0);
              }, 500);
            }

            //Hack for Safari (2021/08) - where images don't always draw on mobile screens - switching display mode forces it to redraw correctly
            if (theme.viewport.isXs() && /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
              setTimeout(function () {
                $swiperCont.find('.swiper-wrapper').css('display', 'inline-flex').css('vertical-align', 'bottom');
              }, 500);
              setTimeout(function () {
                $swiperCont.find('.swiper-wrapper').css('display', '').css('vertical-align', '');
              }, 1000);
            }
          },
          slideChangeTransitionStart: function slideChangeTransitionStart() {
            //Load the next image if not already
            $swiperCont.find('.swiper-slide-active .lazyload--manual').removeClass('lazyload--manual').addClass('lazyload');
          },
          slideChangeTransitionEnd: function slideChangeTransitionEnd(e) {
            // Pause any media after changing slide
            _this.pauseAllMedia();

            // Update the view in space button on swipe
            if (theme.viewport.isXs() || isCarouselLayout) {
              var $activeMedia = $gallery.find('.swiper-slide-active .product-media');
              var activeMediaObj = initialisedMedia[$activeMedia.data('media-id')];

              if (activeMediaObj) {
                if ($activeMedia.data('media-type') === 'model') {
                  activeMediaObj.updateViewInSpaceButton();
                } else if (window.ShopifyXR && $viewInSpaceButton.length) {
                  //Reset the view in space button to launch the first model
                  $viewInSpaceButton.attr('data-shopify-model3d-id', $viewInSpaceButton.data('shopify-model3d-first-id'));
                  $viewInSpaceButton.attr('data-shopify-title', $viewInSpaceButton.data('shopify-first-title'));
                  window.ShopifyXR.setupXRElements();
                }
              }
            }

            _this.slideshowTabFix();
          } } });



      swiper = new Swiper($swiperCont, swiperOpts);

      var randomId = new Date().getTime();
      theme.swipers[randomId] = swiper;
      $swiperCont.attr('data-swiper-id', randomId);

      var startIndex = $gallery.find('.current-img').index();
      swiper.slideTo(startIndex, 0);

      if (isCarouselLayout) {
        if (underlineSelectedMedia) {
          $gallery.find('.current-img .product-media').addClass('product-media--active-variant');
        }

        if (isMediaGroupingEnabled) {
          updateSwiperSlidesPerView();
        }
      }

      //Disable swipe on single products within the featured product slider
      if ($gallery.hasClass('featured-product__gallery--single')) {
        $swiperCont.addClass('swiper-no-swiping');
      }

      //Fixes bug where the last slide gets cut off if its a model
      setTimeout(function () {
        $(window).trigger('resize');

        //Load lazy images
        lazySizes.autoSizer.checkElems();

        if (swiper) {
          swiper.update();
        }

        //Autoplay the active slide on desktop
        if (theme.viewport.isSm() && !isCarouselLayout) {
          _this.showMedia($swiperCont.find('.swiper-slide.swiper-slide-active .product-media'), false, true);
        }

        if (isCarouselLayout) {
          _this.slideshowTabFix();
        }
      }, isCarouselLayout ? 3000 : 1000);
    }

    function destroySwiper() {
      $swiperCont.removeClass('swiper-no-swiping');
      if (swiper) {
        swiper.destroy(true);
      }
      initColumns();

      if ($productThumbnails.length && theme.viewport.isMd()) {
        initThumbnails();
      }
    }

    var swiperEnabled = false;
    function toggleSwiper() {
      if (theme.viewport.isXs() && !swiperEnabled) {
        swiperEnabled = true;
        initSwiper();
      } else if (theme.viewport.isSm() && swiperEnabled) {
        swiperEnabled = false;
        destroySwiper();
        $swiperCont.find('.lazyload--manual').removeClass('lazyload--manual').addClass('lazyload');
      } else if (theme.viewport.isSm()) {
        $swiperCont.find('.lazyload--manual').removeClass('lazyload--manual').addClass('lazyload');
      }
    }

    $(function () {
      if (isCarouselLayout) {
        initSwiper();
        $(window).on('cc-mobile-viewport-size-change.swiper', () => {
          destroySwiper();
          initSwiper();
        });

      } else {
        toggleSwiper();
        $(window).on('debouncedresize.swiper', toggleSwiper);
      }

      if ($productThumbnails.length) {
        if (theme.viewport.isMd()) {
          initThumbnails();
        }
      }
    });
  };
  ;
  theme.initContentSlider = function (target, afterChange) {
    $('.slideshow', target).each(function () {
      var autoplaySpeed = $(this).data('autoplay-speed') * 1000;
      var speed = $(this).data('transition') == 'instant' ? 0 : 600;

      $(this).on('init', function () {
        $('.slick-current .lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');

        //Lazyload all slide images after a few seconds
        $(function () {
          setTimeout(() => {
            $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');
          }, window.localStorage.getItem('is_first_visit') === null ? 5000 : 2000);
        });

      }).slick({
        autoplay: $(this).data('autoplay'),
        fade: $(this).data('transition') === 'slide' && theme.viewport.isXs() ? false : true,
        speed: speed,
        autoplaySpeed: autoplaySpeed,
        arrows: $(this).data('navigation') == 'arrows',
        dots: $(this).data('navigation') == 'dots',
        // pauseOnHover: $(this).data('transition') != 'instant' || $(this).data('autoplay-speed') > 2, // no pause when quick & instant
        infinite: true,
        useTransform: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + '</button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + '</button>',
        pauseOnHover: false,
        cssEase: 'cubic-bezier(0.25, 1, 0.5, 1)',
        lazyLoad: $(this).find('[data-lazy]').length > 0 ? 'ondemand' : null,
        customPaging: function customPaging(slider, i) {
          // return "<button class=\"custom-dot\" type=\"button\" data-role=\"none\" role=\"button\" tabindex=\"0\">" + theme.icons.dots + "</button>";
          return '<button class="custom-dot black" type="button" data-role="none" role="button" tabindex="0">' + theme.icons.dots + '</button>' + '<button class="custom-dot yellow" type="button" data-role="none" role="button" tabindex="0">' + theme.icons.dotsActive + '</button>';

        },
        responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false, //$(this).data('navigation') == 'arrows',
            dots: $(this).data('navigation') != 'none', // $(this).data('navigation') == 'none' || $(this).data('navigation') == 'dots',
            lazyLoad: $(this).find('[data-lazy]').length > 0 ? 'progressive' : null } }] }).



      on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $(slick.$slides).filter('.slick--out').removeClass('slick--out');

        //Lazy load the next slide image if not already loaded
        var $unloadedImage = $(slick.$slides.get(nextSlide)).find('.lazyload--manual');
        if ($unloadedImage.length) {
          $unloadedImage.removeClass('lazyload--manual').addClass('lazyload');
        }

        if ($(this).data('transition') === 'slide' || $(this).data('transition') === 'zoom') {
          var $outgoingSlide = $(slick.$slides.get(currentSlide));
          $outgoingSlide.addClass('slick--leaving');
        }
      }).on('afterChange', function (event, slick, currentSlide) {
        $(slick.$slides).filter('.slick--leaving').addClass('slick--out').removeClass('slick--leaving');

        if (afterChange) {
          afterChange(currentSlide);
        }
      });
    });
  };

  theme.initProductSlider = function ($swiperCont) {var isBlog = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var slidesInView = $swiperCont.data('products-in-view');

    var breakpoints = {
      767: {
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        spaceBetween: 10 },

      900: {
        slidesPerView: slidesInView === 4 || slidesInView === 3 ? 2 : slidesInView },
        slidesPerGroup: 2,

      1439: {
        slidesPerView: slidesInView === 4 || slidesInView === 3 ? 3 : slidesInView },
        slidesPerGroup: 3,

      3000: {
        slidesPerView: slidesInView,
        slidesPerGroup: 4,
        spaceBetween: 20 } };

    if (isBlog) {
      var isFirstPostBig = $swiperCont.data('first-post-big');

      if (isFirstPostBig) {
        breakpoints = {
          767: {
            slidesPerView: 1.2,
            spaceBetween: 10 },

          1024: {
            slidesPerView: 'auto' },

          1600: {
            slidesPerView: 'auto' },

          3000: {
            slidesPerView: 'auto',
            spaceBetween: 20 } };


      } else {
        breakpoints = {
          767: {
            slidesPerView: 1.2,
            spaceBetween: 10 },

          1024: {
            slidesPerView: 2 },

          1600: {
            slidesPerView: 3 },

          3000: {
            slidesPerView: 4,
            spaceBetween: 20 } };

      }
    }

    //Init swiper
    new Swiper($swiperCont, {
      mode: 'horizontal',
      resizeReInit: true,
      freeMode: true,
      freeModeFluid: true,
      scrollContainer: true,
      grabCursor: true,
      createPagination: false,
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      mousewheel: {
        invert: true,
        forceToAxis: true
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      scrollbar: {
        el: $swiperCont.find('.swiper-scrollbar')[0],
        draggable: true },

      navigation: {
        nextEl: $swiperCont.find('.swiper-button-next')[0],
        prevEl: $swiperCont.find('.swiper-button-prev')[0] },

      breakpoints: breakpoints,
      on: {
        init: function init() {
          lazySizes.autoSizer.checkElems();
        } } });


  };

  theme.convertOptionsToBoxes = function (container) {
    // show box-style options
    var $clickies = $(container).find('select[data-make-box]').each(function () {
      $(this).find('option[value=""]').remove(); //Remove 'Pick a' option, if exists
    }).clickyBoxes().parent().addClass('has-clickyboxes');
    $('.selector-wrapper:not(.cc-swatches) .clickyboxes').ccHoverLine({
      lineCss: {
        height: '2px' } });

    if ($clickies.length > 0) {

      const low = document.querySelector('.opt--low');
      const qualityLow = document.querySelector('.icon_low');
      const qualityLowSelect = document.querySelector('.icon_low_select');
      const medium = document.querySelector('.opt--medium');
      const qualityMedium = document.querySelector('.icon_medium');
      const qualityMediumSelect = document.querySelector('.icon_medium_select');
      const high = document.querySelector('.opt--high');
      const qualityHigh = document.querySelector('.icon_high');
      const qualityHighSelect = document.querySelector('.icon_high_select');

      // change icon when click option product low
      low.addEventListener("click", function(){
        if (qualityLow.style.display !== 'none') {
          qualityLowSelect.style.display = 'block';
          qualityLow.style.display = 'none';
          qualityMediumSelect.style.display = 'none';
          qualityMedium.style.display = 'block';
          qualityHighSelect.style.display = 'none';
          qualityHigh.style.display = 'block';
        }
        else {
          qualityLow.style.display = 'none';
          qualityLowSelect.style.display = 'block';
        }
      });

      // change icon when click option product medium

      medium.addEventListener("click", function(){
        if (qualityMedium.style.display !== 'none') {
          qualityMedium.style.display = 'none';
          qualityMediumSelect.style.display = 'block';
          qualityLowSelect.style.display = 'none';
          qualityLow.style.display = 'block';
          qualityHighSelect.style.display = 'none';
          qualityHigh.style.display = 'block';
        }
        else {
          qualityMedium.style.display = 'none';
          qualityMediumSelect.style.display = 'block';
        }
      });

      // change icon when click option product high

      high.addEventListener("click", function(){
        if (qualityHigh.style.display !== 'none') {
          qualityHigh.style.display = 'none';
          qualityHighSelect.style.display = 'block';
          qualityLowSelect.style.display = 'none';
          qualityLow.style.display = 'block';
          qualityMedium.style.display = 'block';
          qualityMediumSelect.style.display = 'none';
        }
        else {
          qualityHigh.style.display = 'none';
          qualityHighSelect.style.display = 'block';
        }
      });
    } else {
      document.querySelector(".product-detail-quality").style.display = 'none';
    }

    // If we have clicky boxes, add the disabled-state to options that have no valid variants
    if ($clickies.length > 0) {
      var productData = theme.OptionManager.getProductData($(container));

      // each option
      for (var optionIndex = 0; optionIndex < productData.options.length; optionIndex++) {
        // list each value for this option
        var optionValues = {};
        for (var variantIndex = 0; variantIndex < productData.variants.length; variantIndex++) {
          var variant = productData.variants[variantIndex];
          if (typeof optionValues[variant.options[optionIndex]] === 'undefined') {
            optionValues[variant.options[optionIndex]] = false;
          }
          // mark true if an option is available
          if (variant.available) {
            optionValues[variant.options[optionIndex]] = true;
          }
        }
        // mark any completely unavailable options
        for (var key in optionValues) {
          if (!optionValues[key]) {
            $('.selector-wrapper:eq(' + optionIndex + ') .clickyboxes li a', container).filter(function () {
              return $(this).attr('data-value') == key;
            }).addClass('unavailable');
          }
        }
      }
    }
  };


  theme.loadInfiniteScroll = function (container, cb) {
    var infiniteLoadCount = 1;

    /// Pagination-replacement
    $('[data-infinite-scroll-container] .pagination.infiniscroll:not(.infinit)', container).addClass('infinit').each(function () {
      var waitForTrigger = $(this).hasClass('wait-for-trigger');
      var $pager = $('<div class="pager-button"><a href="#" aria-label="' + theme.strings.loadMore + '">' + theme.icons.loading + '</a></div>');
      $(this).replaceWith($pager);
      $pager.find('a').attr('href', $(this).find('.next a').attr('href'));

      $pager.on('click', 'a', function (e) {
        if ($(this).hasClass('loading')) {
          return false;
        }
        //Show spinner
        $(this).addClass('loading');
        //Load next page
        var $link = $(this);
        $.get($(this).attr('href'), function (data) {
          infiniteLoadCount++;
          var isCollage = false;
          // var $data = $($.parseHTML(data));
          // //Grab products & insert into page
          // var indexOffset = $('.product-list .product-block').length;
          // var $newProducts = $data.find('.product-list .product-block').hide().appendTo('.product-list').filter('.product-block').each(function(index){
          //   $(this).removeAttr('data-loop-index').data('loop-index', indexOffset + index);
          // });

          var $data = $($.parseHTML(data));
          //Grab products & insert into page
          if ($('[data-infinite-scroll-results].product-list--columns', container).length) {
            //Collage
            isCollage = true;
            var $newProducts = $data.find('[data-infinite-scroll-results]').hide();
            $newProducts.prepend('<h2>' + theme.strings.page.replace('{{ page }}', infiniteLoadCount) + '</h2>');

            var $newProducts = $newProducts.insertBefore('[data-infinite-scroll-container] .pager-button');
          } else {
            //Not collage
            var $newProducts = $data.find('[data-infinite-scroll-results] .product-block').hide().appendTo('[data-infinite-scroll-results]');
          }

          $('[data-infinite-scroll-container]', container).filter('.product-block').each(function (index) {
            $(this).removeAttr('data-loop-index').data('loop-index', index);
            i++;
          });

          //Sort by offset from the top
          //Fix height
          if (!isCollage) {
            $('[data-infinite-scroll-results]', container).height($('[data-infinite-scroll-results]', container).height());

            //Prep entry transitions
            $newProducts.addClass('pre-trans').css('display', '');

            //Find total height to slide to
            var newHeight = 0;
            $('[data-infinite-scroll-results]', container).children().each(function () {
              var h = $(this).position().top + $(this).height();
              if (h > newHeight) newHeight = h;
            });

            //Slide down, reveal & prep for more
            $('[data-infinite-scroll-results]', container).animate({ height: newHeight }, 500, function () {
              $(this).css('height', '');

              //At this point, we're ready to transition in & load more
              $newProducts.removeClass('pre-trans');

              theme.inlineVideos.init(container);
              theme.initAnimateOnScroll();
              new ProductBlock();
              lazySizes.autoSizer.checkElems();
              if (cb) {
                cb();
              }
            });
          } else {
            setTimeout(function () {
              $newProducts.fadeIn();
              theme.inlineVideos.init(container);
              theme.initAnimateOnScroll();
              lazySizes.autoSizer.checkElems();
              if (cb) {
                cb();
              }
            }, 300);
          }

          //Spin no more
          var $next = $data.find('[data-infinite-scroll-container] .pagination .next a');

          if ($next.length == 0) {
            //We are out of products
            $pager.slideUp();
          } else {
            //More to show
            $link.attr('href', $next.attr('href')).removeClass('loading');
          }
        });

        return false;
      });
      if (!waitForTrigger) {
        //Infiniscroll
        $(window).on('throttled-scroll.infiniscroll', function () {
          if ($(window).scrollTop() + $(window).height() > $pager.offset().top - 500) {
            $pager.find('a').trigger('click');
          }
        });
      }
    });
  };

  theme.unloadInfiniteScroll = function (container) {
    if (container) {
      $('.pagination.infiniscroll.infinit', container).removeClass('infinit');
    }

    $(window).off('throttled-scroll.infiniscroll');
  };

  theme.applyAjaxToProductForm = function ($formContainer) {
    var shopifyAjaxAddURL = theme.routes.cart_add_url + '.js';

    $formContainer.filter('[data-ajax-add-to-cart="true"]:not(.feedback-go_to_cart)').find('.product-purchase-form').on('submit', function (e) {
      e.preventDefault();
      var $form = $(this);

      //Disable add button
      var $btn = $(this).find('[type=submit]').attr('disabled', 'disabled').addClass('confirmation adding');
      $btn.data('originalHtml', $btn.html()).html(theme.strings.productAddingToCart);

      var $stickyBtn = $('.product-area__add-to-cart-xs button');
      var updateStickyButton = theme.viewport.isXs() && $stickyBtn.length;
      if (updateStickyButton) {
        $stickyBtn.attr('disabled', 'disabled');
        $stickyBtn.data('originalHtml', $stickyBtn.html()).html(theme.strings.productAddingToCart);
      }

      //Add to cart
      $.post(shopifyAjaxAddURL, $form.serialize(), function (itemData) {
        //Enable add button
        $btn.html(theme.icons.tick + ' ' + theme.strings.productAddedToCart);

        if (updateStickyButton) {
          $stickyBtn.html(theme.icons.tick + ' ' + theme.strings.productAddedToCart);
        }

        setTimeout(function () {
          $btn.removeAttr('disabled').removeClass('confirmation').html($btn.data('originalHtml'));
          if (updateStickyButton) {
            $stickyBtn.removeAttr('disabled').removeClass('confirmation').html($stickyBtn.data('originalHtml'));
          }
        }, 4000);

        if ($form.hasClass('feedback-add_in_modal') || $form.hasClass('feedback-add_in_modal_no_checkout')) {
          var product = $.parseJSON(itemData);
          var noCheckoutButton = $form.hasClass('feedback-add_in_modal_no_checkout');

          //Preload the thumbnail image
          var thumbUrl = theme.Shopify.formatImage(product.image, '300x');
          var img = new Image();
          img.src = thumbUrl;

          $btn.removeClass('adding');

          var variantHtml = "";

          var $priceElem = $form.closest('.product-area__details__inner').find('.price-area');
          if ($priceElem.length) {
            variantHtml += "<p class=\"cart-product__content__price\">".concat($priceElem.html(), "</p>");
          }

          if (product.selling_plan_allocation && product.selling_plan_allocation.selling_plan.name) {
            variantHtml += "<p class=\"cart-product__content__meta\">".concat(product.selling_plan_allocation.selling_plan.name, "</p>");
          }

          if (product.options_with_values && product.options_with_values.length) {
            for (var _i2 = 0; _i2 < product.options_with_values.length; _i2++) {
              var option = product.options_with_values[_i2];
              if (option.name !== "Title" && option.value !== "Default Title") {
                variantHtml += "<p class=\"cart-product__content__meta\">".concat(option.name, ": ").concat(option.value, "</p>");
              }
            }
          }

          var offset = 25;
          var nav = theme.Nav();
          if (nav.bar.getPositionSetting() !== "inline") {
            offset = nav.bar.height();
          }

          showThemeModal([
          '<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">', "<div class=\"inner\" style=\"top:".concat(
          offset, "px\">"),
          '<a href="#" data-modal-close class="modal-close">&times;</a>',
          '<h4 id="added-to-cart-title">' + theme.icons.tick + theme.strings.productAddedToCart + '</h4>',
          '<div class="cart-product">', "<div class=\"cart-product__image\"><img src=\"".concat(
          thumbUrl, "\" alt=\"").concat(product.featured_image.alt, "\"/></div>"),
          '<div class="cart-product__content">' +
          '<p class="cart-product__content__title">', product.product_title, '</p>' + "".concat(
          variantHtml ? variantHtml : '') +
          '</div>',
          '</div>', "<p class=\"links ".concat(
          noCheckoutButton ? 'links--no-checkout' : '', "\">"),
          '<a href="' + theme.routes.cart_url + "\" class=\"button ".concat(noCheckoutButton ? '' : 'alt', "\">") + theme.strings.viewCart + '</a>',
          '<a href="' + theme.routes.checkout + '" class="button button--checkout" [data-cc-checkout-button]>' + theme.strings.popupCheckout + '</a> ',
          '</p>',
          '</div>',
          '</div>'].
          join(''), "added-to-cart", null);
        }

        // Update header (& cart if on cart)
        $.get(theme.routes.cart_url, function (data) {
          var cartUpdateSelector = '#site-control .cart:not(.nav-search), [data-section-type="cart-template"]';
          var $newCartObj = $($.parseHTML('<div>' + data + '</div>')).find(cartUpdateSelector);
          $(cartUpdateSelector).each(function (index) {
            $($newCartObj[index]).find('[data-cc-animate]').removeAttr('data-cc-animate');
            $(this).replaceWith($newCartObj[index]);
            $(this).parent().find('[data-cc-animate]').removeAttr('data-cc-animate');
          });
        });
      }, 'text').fail(function (data) {
        //Enable add button
        $btn.removeAttr('disabled').removeClass('confirmation').html($btn.data('originalHtml'));

        if (updateStickyButton) {
          $stickyBtn.removeAttr('disabled').removeClass('confirmation').html($stickyBtn.data('originalHtml'));
        }

        //Not added, show message
        if (typeof data != 'undefined' && typeof data.status != 'undefined') {
          var jsonRes = $.parseJSON(data.responseText);
          var $statusMessageContainer = $form.find('.product-status-message');
          $statusMessageContainer.html(jsonRes.description);
          $statusMessageContainer.slideDown().fadeIn();

          setTimeout(() => {
            $statusMessageContainer.slideUp();
          }, 8000);
        } else {
          //Some unknown error? Disable ajax and submit the old-fashioned way.
          $form.attr('ajax-add-to-cart', 'false').submit();
        }
      });
    });
  };

  theme.removeAjaxFromProductForm = function ($formContainer) {
    $formContainer.find('form.product-purchase-form').off('submit');
  };

  // Manage option dropdowns
  theme.OptionManager = new function () {
    var _ = this;

    _._getVariantOptionElement = function (variant, $container) {
      return $container.find('select[name="id"] option[value="' + variant.id + '"]');
    };

    _.selectors = {
      container: '.product-area',
      gallery: '.theme-gallery',
      priceArea: '.price-area',
      variantIdInputs: '[name="id"]',
      submitButton: '.product-detail__form input[type=submit], .product-detail__form button[type=submit], .product-area__add-to-cart-xs button',
      multiOption: '.option-selectors' };


    _.strings = {
      priceNonExistent: theme.strings.priceNonExistent,
      buttonDefault: theme.strings.buttonDefault,
      buttonPreorder: theme.strings.buttonPreorder,
      buttonNoStock: theme.strings.buttonNoStock,
      buttonNoVariant: theme.strings.buttonNoVariant,
      unitPriceSeparator: theme.strings.unitPriceSeparator,
      inventoryNotice: theme.strings.onlyXLeft,
      inventoryLowStock: theme.strings.inventoryLowStock,
      inventoryInStock: theme.strings.inventoryInStock,
      priceSoldOut: theme.strings.priceSoldOut };


    _._getString = function (key, variant) {
      var string = _.strings[key];
      if (variant) {
        if (string) {
          string = string.replace('[PRICE]', '<span class="theme-money">' + theme.Shopify.formatMoney(variant.price, theme.money_format_with_code_preference) + '</span>');
        } else {
          console.warn("No string for key '".concat(key, "' was found."));
        }
      }
      return string;
    };

    _.getProductData = function ($form, productId) {
      if (!productId) {
        productId = $form.data('product-id');
      }
      var data = null;
      if (!theme.productData[productId]) {
        theme.productData[productId] = JSON.parse(document.getElementById('cc-product-json-' + productId).innerHTML);
      }
      data = theme.productData[productId];
      if (!data) {
        console.log('Product data missing (id: ' + $form.data('product-id') + ')');
      }
      return data;
    };

    _.getBaseUnit = function (variant) {
      return variant.unit_price_measurement.reference_value === 1 ?
      variant.unit_price_measurement.reference_unit :
      variant.unit_price_measurement.reference_value +
      variant.unit_price_measurement.reference_unit;
    },

    _.addVariantUrlToHistory = function (variant) {
      if (variant) {
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({ path: newurl }, '', newurl);
      }
    };

    _.updateSku = function (variant, $container) {
      $container.find('.sku .sku__value').html(variant ? variant.sku : '');
      $container.find('.sku').toggleClass('sku--no-sku', !variant || !variant.sku);
    };

    _.updateBarcode = function (variant, $container) {
      $container.find('.barcode .barcode__value').html(variant ? variant.barcode : '');
      $container.find('.barcode').toggleClass('barcode--no-barcode', !variant || !variant.barcode);
    };

    _.updateInventoryNotice = function (variant, $container) {
      var $inventoryNotice = $container.find('.product-inventory-notice');
      var $inventoryNoticeText = $container.find('.product-inventory-notice__text');
      var $inventoryNoticeIndicator = $container.find('.product-inventory-notice__indicator');

      if ($inventoryNotice.length) {
        var invCount = _._getVariantOptionElement(variant, $container).data('inventory');
        var invData = $inventoryNotice[0].dataset;

        var showInventoryCount = invData.showInventoryCount === "always" ||
        invData.showInventoryCount === "low" && invCount <= invData.inventoryThreshold;

        var notice;
        if (showInventoryCount) {
          notice = _._getString('inventoryNotice').replace('[[ quantity ]]', invCount);
        } else {
          if (invCount <= parseInt(invData.inventoryThreshold)) {
            notice = _._getString('inventoryLowStock');
          } else {
            notice = _._getString('inventoryInStock');
          }
        }

        //Update the bar indicator
        if ($inventoryNoticeIndicator.length === 1) {
          var $bar = $inventoryNoticeIndicator.find('span');
          var newWidth;
          if (invCount >= invData.indicatorScale) {
            newWidth = 100;
          } else {
            newWidth = (100 / parseInt(invData.indicatorScale) * invCount).toFixed(1);
          }

          if (invCount <= parseInt(invData.inventoryThreshold)) {
            $bar.css('width', newWidth + '%').css('background-color', invData.indicatorScaleColorBelow);
          } else {
            $bar.css('width', newWidth + '%').css('background-color', invData.indicatorScaleColorAbove);
          }
        }

        if (invCount && invCount > 0 && (invData.showInventoryNotice === "always" || invCount <= parseInt(invData.inventoryThreshold))) {
          $inventoryNotice.removeClass('product-inventory-notice--no-inventory').slideDown(300);
          $inventoryNoticeText.html(notice);
        } else {
          $inventoryNotice.addClass('product-inventory-notice--no-inventory').slideUp(300);
        }
      }
    };

    _.updateBackorder = function (variant, $container) {
      var $backorder = $container.find('.backorder');
      if ($backorder.length) {
        if (variant && variant.available) {
          if (variant.inventory_management && _._getVariantOptionElement(variant, $container).data('stock') == 'out') {
            var productData = _.getProductData($container);
            $backorder.find('.backorder__variant').html(productData.title + (variant.title.indexOf('Default') >= 0 ? '' : ' - ' + variant.title));
            $backorder.show();
          } else {
            $backorder.hide();
          }
        } else {
          $backorder.hide();
        }
      }
    };

    _.updatePrice = function (variant, $container) {
      var $priceArea = $container.find(_.selectors.priceArea);
      $priceArea.removeClass('on-sale');

      if (variant && variant.available == true) {
        var $newPriceArea = $('<div>');
        if (variant.compare_at_price > variant.price) {
          $('<span class="was-price theme-money">').html(theme.Shopify.formatMoney(variant.compare_at_price, theme.money_format_with_code_preference)).appendTo($newPriceArea);
          $newPriceArea.append(' ');
          $priceArea.addClass('on-sale');
        }
        $('<span class="current-price theme-money">').html(theme.Shopify.formatMoney(variant.price, theme.money_format_with_code_preference)).appendTo($newPriceArea);
        if (variant.unit_price_measurement) {
          var $newUnitPriceArea = $('<div class="unit-price">').appendTo($newPriceArea);
          $('<span class="unit-price__price theme-money">').html(theme.Shopify.formatMoney(variant.unit_price, theme.money_format)).appendTo($newUnitPriceArea);
          $('<span class="unit-price__separator">').html(_._getString('unitPriceSeparator')).appendTo($newUnitPriceArea);
          $('<span class="unit-price__unit">').html(_.getBaseUnit(variant)).appendTo($newUnitPriceArea);
        }
        $priceArea.html($newPriceArea.html());
      }
    };

    _._updateButtonText = function ($button, string, variant) {
      $button.each(function () {
        var newVal;
        newVal = _._getString('button' + string, variant);
        if (newVal !== false) {
          if ($(this).is('input')) {
            $(this).val(newVal);
          } else {
            $(this).html(newVal);
          }
        }
      });
    };

    _.updateButtons = function (variant, $container) {
      var $button = $container.find(_.selectors.submitButton);
      if (variant && variant.available == true) {
        $button.removeAttr('disabled');


        if ($container.data('is-preorder')) {
          _._updateButtonText($button, 'Preorder', variant);
        } else {
          _._updateButtonText($button, 'Default', variant);
        }
      } else {
        $button.attr('disabled', 'disabled');
        if (variant) {
          _._updateButtonText($button, 'NoStock', variant);
        } else {
          _._updateButtonText($button, 'NoVariant', variant);
        }
      }
    };

    _.updateContainerStatusClasses = function (variant, $container) {
      $container.toggleClass('variant-status--unavailable', !variant.available);
      $container.toggleClass('variant-status--backorder', variant.available &&
      variant.inventory_management &&
      _._getVariantOptionElement(variant, $container).data('stock') == 'out');
    };

    _.updateVariantOptionStatusClasses = function (variant, $container) {
      var productData = _.getProductData($container);

      //For the given array of option values, find variants which share the same options
      function getMatchingVariants(optionValues) {
        // console.log(`Finding variants with option values: ${optionValues}`);

        var tempVariants = productData.variants;

        var matchingVariants = tempVariants.filter(thisVariant => {
          var variantMatches = true;

          for (var j = 0; j < optionValues.length; j++) {
            if (thisVariant.options[j] !== optionValues[j]) {
              variantMatches = false;
              break;
            }
          }

          return variantMatches;
        });

        return matchingVariants;
      }

      //Returns an object of all the possible values for the given option with each option set to false
      function getAllValuesForOption(i) {
        var allOptionValues = {};

        for (var l = 0; l < productData.variants.length; l++) {
          var value = productData.variants[l].options[i];
          if (value) {
            allOptionValues[value] = false;
          }
        }

        return allOptionValues;
      }

      if (variant === false) {
        //The variant is unavailable, fabricate variant options based on the current selection
        variant = {
          options: [] };


        $container.find('.selector-wrapper a.active[data-value]').each(function () {
          variant.options.push($(this).data('value'));
        });
      }

      if (variant && variant.options && variant.options.length > 1) {
        var optionValues = [...variant.options];
        var optionStock = {};

        //Iterate the current variant option selection from the bottom up
        for (var _i3 = variant.options.length - 1; _i3 >= 0; _i3--) {
          optionValues.pop();

          //Get an object of values for this option all with stock set to false
          var optionAvailability = getAllValuesForOption(_i3);

          //Get variants which have the parent options
          var matchingVariants = getMatchingVariants(optionValues);

          //Check for in stock options within matching variants
          for (var k = 0; k < matchingVariants.length; k++) {
            if (matchingVariants[k].available) {
              var value = matchingVariants[k].options[_i3];
              if (value) {
                optionAvailability[value] = true;
              }
            }
          }

          //Add this option value to the master object of availability for this variant
          optionStock[productData.options[_i3]] = optionAvailability;
        }

        //Update the UI to reflect stock
        $('.selector-wrapper', $container).each(function () {
          var optionName = $(this).data('option-name');
          for (var [option, isAvailable] of Object.entries(optionStock[optionName])) {
            option = removeDiacritics(option).toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, '');
            $(this).find(".clickyboxes .opt--".concat(option)).toggleClass('unavailable', !isAvailable);
          }
        });
      }
    };

    _.initProductOptions = function ($productForm) {
      if ($productForm.hasClass('theme-init')) return;

      var productData = _.getProductData($productForm);
      $productForm.addClass('theme-init');

      // init option selectors
      $productForm.find(_.selectors.multiOption).on('change.themeProductOptions', 'select', function () {
        var selectedOptions = [];
        $(this).closest(_.selectors.multiOption).find('select').each(function () {
          selectedOptions.push($(this).val());
        });
        // find variant
        var variant = false;
        for (var i = 0; i < productData.variants.length; i++) {
          var v = productData.variants[i];
          var matchCount = 0;
          for (var j = 0; j < selectedOptions.length; j++) {
            if (v.options[j] == selectedOptions[j]) {
              matchCount++;
            }
          }
          if (matchCount == selectedOptions.length) {
            variant = v;
            break;
          }
        }
        // trigger change
        if (variant) {
          $productForm.find(_.selectors.variantIdInputs).val(variant.id);
        }
        // a jQuery event may not be picked up by all listeners
        $productForm.find(_.selectors.variantIdInputs).each(function () {
          this.dispatchEvent(
          new CustomEvent('change', { bubbles: true, cancelable: false, detail: variant }));

        });
      });

      // init variant ids
      $productForm.find(_.selectors.variantIdInputs).each(function () {
        // change state for original dropdown
        $(this).on('change.themeProductOptions firstrun.themeProductOptions', function (e) {
          if ($(this).is('input[type=radio]:not(:checked)')) {
            return; // handle radios - only update for checked
          }
          var variant = e.detail;
          if (!variant && variant !== false) {
            for (var i = 0; i < productData.variants.length; i++) {
              if (productData.variants[i].id == $(this).val()) {
                variant = productData.variants[i];
              }
            }
          }
          var $container = $(this).closest(_.selectors.container);

          // string overrides
          var $addToCart = $container.find(_.selectors.submitButton).filter('[data-add-to-cart-text]');
          if ($addToCart.length) {
            _.strings.buttonDefault = $addToCart.data('add-to-cart-text');
          }

          // update price
          _.updatePrice(variant, $container);

          // update buttons
          _.updateButtons(variant, $container);

          // emit an event to broadcast the variant update
          $(window).trigger('cc-variant-updated', {
            variant: variant,
            product: productData });


          // retrigger stuff, eg hover line
          $(window).trigger('debouncedresizewidth');

          // variant images
          if (variant && variant.featured_media) {
            $container.find(_.selectors.gallery).trigger('variantImageSelected', variant);
          }

          // extra details
          _.updateBarcode(variant, $container);
          _.updateSku(variant, $container);
          _.updateInventoryNotice(variant, $container);
          //_.updateTransferNotice(variant, $container);
          _.updateBackorder(variant, $container);
          _.updateContainerStatusClasses(variant, $container);

          if ($productForm.find('[data-show-realtime-availability="true"]').length > 0) {
            _.updateVariantOptionStatusClasses(variant, $productForm);
          }

          // variant urls
          if ($productForm.data('enable-history-state') && e.type == 'change') {
            _.addVariantUrlToHistory(variant);
          }

          // notify quickbuy of content change
          $productForm.find('.quickbuy-container').trigger('changedsize');

          // allow other things to hook on
          $productForm.trigger('variantChanged', variant);
        });

        // first-run
        $(this).trigger('firstrun');
      });

      // ajax
      theme.applyAjaxToProductForm($productForm);
    };

    _.unloadProductOptions = function ($productForm) {
      $productForm.removeClass('theme-init').each(function () {
        $(this).trigger('unloading').off('.themeProductOptions');
        $(this).find(_.selectors.multiOption).off('.themeProductOptions');
        theme.removeAjaxFromProductForm($productForm);
      });
    };
  }();
  ;
  theme.addControlPaddingToModal = function () {
    $('.theme-modal.reveal > .inner').css('padding-top', theme.Nav().bar.height());
  };

  theme.assessTopSectionPadding = function () {
    var $topBlogSection = $('#page-content .shopify-section:first-child.section-featured-blog .slideshow-blog');
    if ($topBlogSection.length) {
      $topBlogSection.addClass('slideshow-blog--top');

      var nav = theme.Nav();
      if ($topBlogSection.find('.slideshow-blog__title').length) {
        $topBlogSection.find('.slideshow-blog__title').css('top', nav.bar.height());
      }

      if ($topBlogSection.find('.slideshow-blog__view-all').length) {
        $topBlogSection.find('.slideshow-blog__view-all').css('top', nav.bar.height());
      }
    }
  };

  theme.allowRTEFullWidthImages = function (container) {
    $('.rte--allow-full-width-images p > img, .rte--allow-full-width-images div > img', container).each(function () {
      if ($(this).siblings().length == 0) {
        $(this).parent().addClass('no-side-pad');
      }
    });
    $('.rte--allow-full-width-images p > a > img, .rte--allow-full-width-images div > a > img', container).each(function () {
      if ($(this).siblings().length == 0 && $(this).parent().siblings().length == 0) {
        $(this).parent().addClass('no-side-pad');
      }
    });
  };

  theme.browserHas3DTransforms = function () {
    var el = document.createElement('p'),
    has3d,
    transforms = {
      'webkitTransform': '-webkit-transform',
      'OTransform': '-o-transform',
      'msTransform': '-ms-transform',
      'MozTransform': '-moz-transform',
      'transform': 'transform' };


    // Add it to the body to get the computed style.
    document.body.insertBefore(el, null);

    for (var t in transforms) {
      if (el.style[t] !== undefined) {
        el.style[t] = "translate3d(1px,1px,1px)";
        has3d = window.getComputedStyle(el).getPropertyValue(transforms[t]);
      }
    }

    document.body.removeChild(el);

    return has3d !== undefined && has3d.length > 0 && has3d !== "none";
  };

  if (theme.browserHas3DTransforms()) {$('html').addClass('supports-transforms');}

  theme.namespaceFromSection = function (container) {
    return ['.', $(container).data('section-type'), $(container).data('section-id')].join('');
  };

  theme.inlineVideos = {
    init: target => {
      $('.section-background-video--inline', target).each(function () {
        theme.VideoManager.onSectionLoad($(this)[0]);
        $(this).addClass('cc-init');
      });
    },
    destroy: target => {
      $('.section-background-video--inline', target).each(function () {
        theme.VideoManager.onSectionUnload($(this)[0]);
        $(this).removeClass('cc-init');
      });
    } };


  //Load shopify payments button
  theme.initShopifyPaymentButtons = function ($elem) {
    if (Shopify.PaymentButton && $elem.find('.shopify-payment-button').length) {
      // resize after loading extra payment buttons
      var _f = null;
      _f = function f() {
        document.removeEventListener('shopify:payment_button:loaded', _f);
        $elem.trigger('changedsize');
      };
      document.addEventListener('shopify:payment_button:loaded', _f);

      Shopify.PaymentButton.init();
    }
  };

  //Initialise any components in the passed element
  theme.initComponents = function ($elem) {
    var $components = $elem.find("[data-components]");
    if ($components.length) {
      //Init each component
      var components = $components.data('components').split(',');
      components.forEach(component => {
        $(document).trigger('cc:component:load', [component, $elem[0]]);
      });
    }
  };

  // Check for full width sections
  theme.assessFullWidthSections = function () {
    document.querySelectorAll('#page-content .shopify-section > .use-alt-bg').forEach(elem => elem.parentElement.classList.add('has-alt-bg'));
  };

  theme.updateNavHeight = function () {
    var nav = theme.Nav();
    document.documentElement.style.setProperty('--nav-height', nav.bar.height() + "px");
    document.querySelectorAll('[data-cc-sticky-scroll-top]').forEach(elem => {
      elem.setAttribute('data-cc-sticky-scroll-top', nav.bar.height() + 20);
    });
  };

  // Perform common functions when the theme inits
  theme.init = function () {
    theme.checkViewportFillers();
    theme.assessAltLogo();
    theme.assessTopSectionPadding();
    theme.assessFullWidthSections();
    theme.calc100vh();
    theme.updateNavHeight();
  };

  // Perform common functions when the window resizes (debounced)
  theme.windowResize = function () {
    theme.assessTopSectionPadding();
    theme.calc100vh();
    theme.updateNavHeight();
  };
  jQuery(function ($) {
    $(document).on('click', '[data-cc-quick-buy]', function () {
      var nav = theme.Nav();
      var productUrl = $(this).attr('href');

      // Cancel current request if one exists
      if (theme.currentQuickbuyRequest) {
        theme.currentQuickbuyRequest.abort();
      }

      showThemeModal("<div class=\"theme-modal theme-modal--fullscreen theme-modal--quickbuy -light\" id=\"quick-buy-modal\" role=\"dialog\" aria-modal=\"true\"/>\n                        <a href=\"#\" data-modal-close class=\"modal-close\">&times;</a>\n                        <div class=\"theme-modal__loading\">".concat(

      theme.icons.loading, "</div>\n                    </div>"),
      'quick-buy', null);

      // load in content
      var ajaxUrl = productUrl;
      // ajaxUrl += ajaxUrl.indexOf('?') >= 0 ? '&view=ajax' : '?view=ajax';
      theme.currentQuickbuyRequest = $.get(ajaxUrl, function (response) {
        var $quickbuyModal = $('#quick-buy-modal');
        var $productDetail = $('<div>' + response + '</div>').find('.section-product-template');
        var $section = $productDetail.find('[data-section-type="product-template"]')[0];

        //Prepare the html
        $productDetail.find('.store-availability-container-outer').remove();
        $productDetail.find('[data-show-in-quickbuy="false"]').remove();
        $productDetail.find('.theme-gallery--zoom-enabled').removeClass('theme-gallery--zoom-enabled');
        $productDetail.find('.product-area__details__title').wrapInner($('<a>').attr('href', productUrl).attr('data-cc-animate-click', 'true'));
        $productDetail.find('.product-detail__more_details a').attr('href', productUrl);

        //Display the html
        $quickbuyModal.find('.theme-modal__loading').replaceWith($productDetail);

        //Load the section etc
        theme.initAnimateOnScroll();

        //Init the product template section
        theme.ProductTemplateSection.onSectionLoad($section, true);

        //Initialise any components
        theme.initComponents($quickbuyModal);

        //Load shopify payments button
        theme.initShopifyPaymentButtons($quickbuyModal);

        $(window).one('ccModalClosing', function () {
          theme.ProductTemplateSection.onSectionUnload($section, true);
        });

      }).always(function () {
        theme.currentQuickbuyRequest = false;
      });

      return false;
    });
  });
  ;
  class ProductBlockInstance {
    constructor(container) {
      this.productBlock = container;
      this.productBlockImageContainer = this.productBlock.querySelector('.image');
      this.imageContainer = this.productBlock.querySelector('.image-inner');
      this.swatchesContainer = this.productBlock.querySelector('.cc-swatches');

      this.slideDuration = 1000;
      this.swatchImagesPreloaded = false;
      this.imageSliderLoaded = false;
      this.widths = [460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

      this.imageWidth;
      this.hoverTimeout;
      this.preloadedImages = [];
      this.swatches = [];

      this.bindEvents();

      if (this.productBlock.querySelector('[data-section-type="background-video"]')) {
        this.initImageSlider();
      }
    }

    /**
     * Shows the next image in the product block
     */
    showNextSlideImage() {
      this.hoverTimeout = setTimeout(() => {
        var slides = this.imageContainer.querySelectorAll('.product-block--slide');
        if (slides && slides.length > 1) {
          if (!this.imageContainer.querySelector('.product-block--slide.-in')) {
            this.imageContainer.querySelector('.image__first').classList.add('-out');
            slides[1].classList.add('-in');
          } else {
            for (var _i4 = 0; _i4 < slides.length; _i4++) {
              //Trigger the next one to be visible
              if (slides[_i4].classList.contains('-in')) {
                slides[_i4].classList.remove('-in');
                if (_i4 === slides.length - 1) {
                  //If this is the last slide, loop round
                  this.destroyImageSliderLoadingBar();
                  slides[0].classList.add('-in');
                  this.initImageSliderLoadingBar();
                } else {
                  //Show the next image
                  slides[_i4 + 1].classList.add('-in');
                }
                break;
              }
            }
          }
        }
        this.showNextSlideImage();
      }, this.slideDuration);
    }

    /**
     * Show a specific slide with the passed image
     * @param imageUrl
     */
    showSpecificSlideImage(imageUrl) {
      var imageUrlStart = imageUrl.substring(0, imageUrl.lastIndexOf('_'));
      var nextSlide = this.imageContainer.querySelector(".product-block--slide[src^=\"".concat(imageUrlStart, "\"]"));
      if (nextSlide) {
        var currentSlide = this.imageContainer.querySelector(".product-block--slide.-in");
        if (currentSlide) {
          currentSlide.classList.remove('-in');
        }

        this.imageContainer.querySelector('.image__first').classList.add('-out');

        nextSlide.classList.add('-in');
      } else {
        console.warn('No next slide for ', imageUrlStart);
      }
    }

    /**
     * Preload an image
     * @param imageUrl
     */
    preloadImage(imageUrl) {
      if (!this.preloadedImages.includes(imageUrl)) {
        var imageElem = new Image();
        imageElem.src = imageUrl;
        this.preloadedImages.push(imageUrl);
      }
    }

    /**
     * Resolves the image url for the passed placeholder image url
     * @param url
     * @returns {*}
     */
    getImageUrl(url) {
      //Up the image width to get a decent quality image for retina
      var imageContainerWidth = theme.device.isRetinaDisplay() ? this.productBlock.clientWidth * 2 : this.productBlock.clientWidth;
      for (var _i5 = 0; _i5 < this.widths.length; _i5++) {
        if (this.widths[_i5] >= imageContainerWidth) {
          this.imageWidth = this.widths[_i5];
          return url.replace('{width}', this.widths[_i5]);
        }
      }
    }

    /**
     * Initialises the image slider for this product block
     */
    initImageSlider() {
      if (this.productBlock) {
        var allImages = this.productBlock.dataset.productImages;
        if (allImages && !this.imageSliderLoaded) {
          var allImagesArr = allImages.split(',');
          var sliderHtml = "";
          allImagesArr.forEach(image => {
            sliderHtml += "<img class=\"product-block--slide\" tabindex=\"-1\" src=\"".concat(this.getImageUrl(image), "\"/>");
          });

          this.imageContainer.innerHTML += sliderHtml;
          this.imageSliderLoaded = true;
        }
      }
    }

    /**
     * Destroys the image slider
     */
    destroyImageSlider() {
      if (this.imageSliderLoaded) {
        var slides = this.imageContainer.querySelectorAll('.product-block--slide');
        if (slides) {
          slides.forEach(slide => {
            slide.remove();
          });
        }
        this.imageSliderLoaded = false;
      }
    }

    /**
     * When the mouse hovers a swatch - replace the main image
     * @param e
     */
    handleMouseEnterSwatch(e) {
      if (e.target.dataset.variantImage) {
        if (!this.imageSliderLoaded) {
          this.initImageSlider();
        }
        var newUrl = this.getImageUrl(e.target.dataset.variantImage);
        this.showSpecificSlideImage(newUrl);
      }
    }

    /**
     * Remove focus from the image slider slides
     * @param e
     */
    handleMouseLeaveSwatch(e) {
      var currentSlide = this.imageContainer.querySelector(".product-block--slide.-in");
      if (currentSlide) {
        currentSlide.classList.remove('-in');
      }

      this.imageContainer.querySelector('.image__first').classList.remove('-out');
    }

    /**
     * On mobile, don't redirect the page when a swatch is clicked
     * @param e
     */
    handleClickSwatch(e) {
      e.preventDefault();
    }

    /**
     * Preload all swatch images and init the slider on mouseover the product block
     * @param e
     */
    handleMouseEnterProductBlock(e) {
      //Preload swatch images if present
      if (!this.swatchImagesPreloaded) {
        this.productBlock.querySelectorAll('.cc-swatches a').forEach(swatch => {
          if (swatch.dataset.variantImage) {
            this.preloadImage(this.getImageUrl(swatch.dataset.variantImage));
          }
        });
        this.swatchImagesPreloaded = true;
      }

      //Init the image slider
      if (this.productBlock.dataset.productImages && !this.imageSliderLoaded) {
        if (this.productBlock.classList.contains('all-images')) {
          this.initImageSlider();
        } else {
          setTimeout(this.initImageSlider, 500);
        }
      }
    }

    /**
     * Show the next image in the slider when hovering over the image
     * @param e
     */
    handleEnterImageContainer(e) {
      if (this.productBlock.classList.contains('all-images')) {
        this.showNextSlideImage();

        //Init the loading bar
        this.initImageSliderLoadingBar();
      }
    }

    /**
     * Mouse leaves a product block
     * @param e
     */
    handleLeaveImageContainer(e) {
      clearTimeout(this.hoverTimeout);

      if (this.imageSliderLoaded) {
        var activeSlide = this.imageContainer.querySelector('.product-block--slide.-in');
        if (activeSlide) {
          activeSlide.classList.remove('-in');
          this.imageContainer.querySelector('.image__first').classList.remove('-out');
        }

        this.destroyImageSliderLoadingBar();
      }
    }

    /**
     * Creates and starts the image slider loading bar
     */
    initImageSliderLoadingBar() {
      var loadingBarAnimateDelay = 100;
      var slides = this.imageContainer.querySelectorAll('.product-block--slide');
      var transitionDuration = slides.length * this.slideDuration - loadingBarAnimateDelay;
      var loadingBar = document.createElement('div');
      loadingBar.classList.add('loading-bar');
      loadingBar.style.transitionDuration = transitionDuration + 'ms';
      this.productBlockImageContainer.append(loadingBar);
      setTimeout(() => {
        loadingBar.classList.add('-in');
      }, loadingBarAnimateDelay);
    }

    /**
     * Remove the image slider loading bar
     */
    destroyImageSliderLoadingBar() {
      var loadingBar = this.productBlockImageContainer.querySelector('.loading-bar');
      if (loadingBar) {
        loadingBar.remove();
      }
    }

    /**
     * When the window is resized, check if image quality needs updating and if so destroy
     * the sliders (which re-init when needed)
     */
    handleWindowResize() {
      if (this.imageWidth && this.productBlock.clientWidth > this.imageWidth) {
        for (var _i6 = 0; _i6 < this.widths.length; _i6++) {
          if (this.widths[_i6] >= this.productBlock.clientWidth && this.widths[_i6] > this.imageWidth) {
            this.destroyImageSlider();
            break;
          }
        }
      }
    }

    /**
    * Bind various listeners
    */
    bindEvents() {
      this.focusSwatchHandler = this.handleMouseEnterSwatch.bind(this);
      this.mouseEnterSwatchHandler = theme.debounce(this.handleMouseEnterSwatch.bind(this), 150);
      this.mouseLeaveSwatchHandler = theme.debounce(this.handleMouseLeaveSwatch.bind(this), 150);
      this.touchDeviceClickHandler = this.handleClickSwatch.bind(this);
      this.mouseEnterProductBlockHandler = this.handleMouseEnterProductBlock.bind(this);
      this.mouseEnterImageContainerHandler = this.handleEnterImageContainer.bind(this);
      this.mouseLeaveImageContainerHandler = this.handleLeaveImageContainer.bind(this);
      this.windowResizeHandler = theme.debounce(this.handleWindowResize.bind(this));

      this.productBlock.querySelectorAll('.cc-swatches a').forEach(swatch => {
        swatch.addEventListener('mouseenter', this.mouseEnterSwatchHandler);
        swatch.addEventListener('focus', this.focusSwatchHandler);

        this.swatches.push(swatch);

        if (theme.device.isTouch()) {
          swatch.addEventListener('click', this.touchDeviceClickHandler);
        }
      });

      if (this.swatchesContainer) {
        this.swatchesContainer.addEventListener('mouseleave', this.mouseLeaveSwatchHandler);
      }

      this.productBlock.addEventListener('mouseenter', this.mouseEnterProductBlockHandler);
      this.imageContainer.addEventListener('mouseenter', this.mouseEnterImageContainerHandler);
      this.imageContainer.addEventListener('mouseleave', this.mouseLeaveImageContainerHandler);
      window.addEventListener('resize', this.windowResizeHandler);
    }

    /**
     * Destroy the listeners
     */
    destroy() {
      this.swatches.forEach(swatch => {
        swatch.removeEventListener('mouseenter', this.mouseEnterSwatchHandler);
        swatch.removeEventListener('click', this.touchDeviceClickHandler);
      });
      this.productBlock.removeEventListener('mouseenter', this.mouseEnterProductBlockHandler);
      this.productBlock.removeEventListener('mouseenter', this.mouseEnterImageContainerHandler);
      this.productBlock.removeEventListener('mouseleave', this.mouseLeaveImageContainerHandler);
      window.removeEventListener('resize', this.windowResizeHandler);

      if (this.swatchesContainer) {
        this.swatchesContainer.removeEventListener('mouseleave', this.mouseLeaveSwatchHandler);
      }
    }}


  class ProductBlock extends ccComponent {
    constructor() {var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'product-block';var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-".concat(name, ":not(.cc-initialized)");
      super(name, cssSelector);
    }

    init(container) {
      super.init(container);
      this.registerInstance(container, new ProductBlockInstance(container));
    }

    destroy(container) {
      this.destroyInstance(container);
      super.destroy(container);
    }}


  new ProductBlock();
  ;

  /*================ Sections ================*/
  theme.HeaderSection = new function () {
    var c;
    var currentScrollTop = 0;
    var default_threshold = 100;

    handleScroll = function handleScroll(nav, positioning, opacity) {
      if (opacity === 'opaque_on_scroll' || opacity === 'opaque_on_scroll_alt') {
        if ($(window).scrollTop() < 100) {
          nav.bar.turnOpaque(false);
        } else {
          nav.bar.turnOpaque(true);
        }
      } else if (opacity !== 'opaque') {
        nav.bar.turnOpaque(false);
      }

      var scrollTop = $(window).scrollTop();

      if ((positioning === 'peek' || nav.bar.isAnnouncementBar() && positioning == "sticky") && scrollTop > 100) {
        currentScrollTop = scrollTop;

        if (positioning != "sticky") {
          if (c < currentScrollTop && scrollTop > default_threshold) {
            nav.bar.hide(true);
          } else if (c > currentScrollTop && !(scrollTop <= 50)) {
            nav.bar.hide(false);
          }
        }

        c = currentScrollTop;

      } else {
        nav.bar.hide(false);
      }

      if (positioning == "sticky" || positioning == "peek") {
        if (scrollTop <= 50) {
          nav.bar.hideAnnouncement(false);
        } else {
          nav.bar.hideAnnouncement(true);
        }
      }
    };

    this.onSectionLoad = function (target) {
      theme.addControlPaddingToModal();
      $('body').toggleClass('modal-active', $('.theme-modal.reveal').length > 0);
      $('#page-menu a', target).attr('tabindex', '-1');
      $('#page-menu .main-nav li:has(ul)', target).addClass('has-children');
      $('#page-menu.nav-uses-modal .main-nav li.has-children > a', target).append('<span class="arr">' + theme.icons.chevronRight + '</span>');
      $('.disclosure', target).each(function () {
        $(this).data('disclosure', new theme.Disclosure($(this)));
      });

      var nav = new theme.Nav();
      var positioning = nav.bar.getPositionSetting();
      var opacity = nav.bar.getOpacitySetting();

      if (opacity === "opaque") {
        $('body').addClass('nav-opaque');
      } else {
        $('body').removeClass('nav-opaque');
      }

      if (positioning === "inline") {
        $('body').addClass('nav-inline');
      } else {
        $('body').removeClass('nav-inline');
      }

      if (opacity !== 'opaque') {
        $('body').addClass('nav-transparent');
      } else {
        $('body').removeClass('nav-transparent');
      }

      if (nav.bar.isAnnouncementBar()) {
        $('body').addClass('showing-announcement');
      } else {
        $('body').removeClass('showing-announcement');
      }

      if (opacity === 'opaque_on_scroll' || opacity === 'opaque_on_scroll_alt' || positioning === 'peek' || nav.bar.isAnnouncementBar()) {
        currentScrollTop = 0;
        $(window).on('throttled-scroll.nav', function () {
          handleScroll(nav, positioning, opacity);
        });
      }

      $(document).on('click.video-section', '.video-container__play', function () {
        if (theme.viewport.isXs()) {
          nav.bar.fadeOut(true);
        }
      });

      $(document).on('click.video-section', '.video-container__stop', function () {
        if (theme.viewport.isXs()) {
          nav.bar.fadeOut(false);
        }
      });

      // Keep the logo width equal to toolbar width
      if (nav.bar.hasInlineLinks() && nav.bar.hasLocalization()) {
        var $logo = $('.logo', target);
        var $toolbarRight = $('.nav-right-side', target);

        function doNavResizeEvents() {
          if (theme.viewport.isXlg() && $toolbarRight.width() > $logo.width()) {
            $logo.css('width', $toolbarRight.outerWidth() - 20 + 'px');
          } else {
            $logo.css('width', '');
          }
        }

        $(window).on('debouncedresize.headerSection doNavResizeEvents.headerSection', doNavResizeEvents).trigger('doNavResizeEvents');

        var event = new CustomEvent("cc-header-updated");
        window.dispatchEvent(event);
      }

      //Lazy load nav promo images
      setTimeout(function () {
        $('.lazyload--manual', target).removeClass('lazyload--manual').addClass('lazyload');
      }, 5000);

      theme.checkViewportFillers();
      theme.assessAltLogo();
      $(window).trigger('cc-header-updated');
    };

    this.onSectionUnload = function (target) {
      $('.disclosure', target).each(function () {
        $(this).data('disclosure').unload();
      });
      $(window).off('throttled-scroll.nav');
      $(window).off('headerSection');
      $(document).on('click.video-section');
    };
  }();

  theme.FooterSection = new function () {
    this.onSectionLoad = function (container) {
      $('.disclosure', container).each(function () {
        $(this).data('disclosure', new theme.Disclosure($(this)));
      });
    };

    this.onSectionUnload = function (container) {
      $('.disclosure', container).each(function () {
        $(this).data('disclosure').unload();
      });
    };
  }();

  theme.SlideshowSection = new function () {
    this.onSectionLoad = function (target) {
      theme.initContentSlider(target);
      $(window).trigger('slideshowfillheight');
      theme.checkViewportFillers();
      theme.assessAltLogo();
    };

    this.onSectionUnload = function (target) {
      $('.slick-slider', target).slick('unslick').off('init');
      $(window).off('.slideshowSection');
    };

    this.onBlockSelect = function (target) {
      $(target).closest('.slick-slider').
      slick('slickGoTo', $(target).data('slick-index')).
      slick('slickPause');
    };

    this.onBlockDeselect = function (target) {
      $(target).closest('.slick-slider').
      slick('slickPlay');
    };
  }();

  theme.FeaturedBlogSection = new function () {
    this.onSectionLoad = function (target) {
      if ($('.carousel-blog', target).length) {
        var $swiperCont = $('.swiper-container', target);
        if ($swiperCont.length === 1) {
          theme.initProductSlider($swiperCont, true);
        }
      }

      if ($('.slideshow-blog', target).length) {
        theme.initContentSlider(target, function (slide) {
          $('.slideshow-blog__titles__active', target).removeClass('slideshow-blog__titles__active');
          $("[data-go-to-slide=\"".concat(slide, "\"]"), target).parent().addClass('slideshow-blog__titles__active');
        });

        var $slideshowTitles = $('.slideshow-blog__titles', target);

        if ($('.slideshow[data-title-navigation="true"]', target).length) {
          function checkTitleNavHeight() {
            if (theme.viewport.isSm()) {
              $('.overlay-type .inner', target).css('padding-bottom', $slideshowTitles.height() + 50 + 'px');
            } else {
              $('.overlay-type .inner', target).removeAttr('style');
            }
          }
          checkTitleNavHeight();
          $(window).on('debouncedresize.titleNavHeight', checkTitleNavHeight);

          $('[data-go-to-slide]', target).on('click', function () {
            var slideNum = $(this).data('go-to-slide');
            $('.slideshow', target).slick('slickGoTo', slideNum).slick('slickPause');
            $('.slideshow-blog', target).addClass('slideshow--paused');;

            return false;
          });

          $('[data-go-to-slide]:first', target).parent().addClass('slideshow-blog__titles__active');
        }

        $(window).trigger('slideshowfillheight');
      }

      theme.checkViewportFillers();
      theme.assessAltLogo();
    };

    this.onSectionUnload = function (target) {
      $('.slick-slider', target).slick('unslick').off('init');
      $(window).off('debouncedresize.titleNavHeight');
      $('[data-go-to-slide]', target).off('click');
    };
  }();

  theme.ImageWithTextOverlay = new function () {
    var _ = this;
    _.checkTextOverImageHeights = function () {
      $('[data-section-type="image-with-text-overlay"], [data-nested-section-type="image-with-text-overlay"]').each(function () {
        var $imageContainer = $('.rimage-outer-wrapper', this);
        var imageHeight = $('.rimage-wrapper', this).outerHeight();
        var textVerticalPadding = parseInt($('.overlay', this).css('padding-top'));
        var textHeight = $('.overlay__content', this).height() + textVerticalPadding * 2;
        if (textHeight > imageHeight + 2) {// +2 for rounding errors
          $imageContainer.css('height', textHeight);
        } else {
          $imageContainer.css('height', '');
        }
      });
    };

    this.onSectionLoad = function (target) {
      $(window).off('.imageWithTextOverlaySection');
      if ($('.overlay__content', target).length) {
        $(_.checkTextOverImageHeights);
        $(window).on('debouncedresize.imageWithTextOverlaySection', _.checkTextOverImageHeights);
      }
      theme.checkViewportFillers();
    };

    this.onSectionUnload = function (target) {
      $(window).off('.imageWithTextOverlaySection');
    };
  }();

  theme.ImageBesideImageSection = new function () {
    var _ = this;
    _.checkTextOverImageHeights = function () {
      $('.image-beside-image__image').each(function () {
        var $imageContainer = $('.rimage-outer-wrapper', this);
        var imageHeight = $('.rimage-wrapper', this).outerHeight();
        var textVerticalPadding = parseInt($('.overlay', this).css('padding-top'));
        var textHeight = $('.overlay__content', this).height() + textVerticalPadding * 2;
        if (textHeight > imageHeight + 2) {// +2 for rounding errors
          $imageContainer.css('height', textHeight);
        } else {
          $imageContainer.css('height', '');
        }
      });
    };

    this.onSectionLoad = function (target) {
      $(window).off('.imageBesideImageSection');
      if ($('.overlay__content', target).length) {
        $(_.checkTextOverImageHeights);
        $(window).on('debouncedresize.imageBesideImageSection', _.checkTextOverImageHeights);
      }
      theme.checkViewportFillers();
    };

    this.onSectionUnload = function (target) {
      $(window).off('.imageBesideImageSection');
    };
  }();

  theme.ProductTemplateSection = new function () {
    var nav = theme.Nav();
    var galleries = {};

    this.onSectionLoad = function (target) {var isQuickbuy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var sectionUniqueId = new Date().getTime();
      $(target).attr('data-section-id', sectionUniqueId);

      var isFeaturedProduct = $(target).data('is-featured-product') || false;

      /// Init store availability if applicable
      if (!isFeaturedProduct && !isQuickbuy && $('[data-store-availability-container]', target).length) {
        this.storeAvailability = new theme.StoreAvailability($('[data-store-availability-container]', target)[0]);
      }

      // header assessment first (affects gallery height)
      theme.checkViewportFillers();
      theme.assessAltLogo();

      if (nav.bar.isCurrentlyOpaque() && !isFeaturedProduct && !isQuickbuy) {
        $('body').removeClass('header-section-overlap');
      }

      /// Product page upper gallery
      var $gallery = $('.theme-gallery', target);
      if ($gallery.length > 0) {
        galleries[sectionUniqueId] = new theme.ProductMediaGallery(
        $gallery, $('.theme-gallery-thumb', target), isFeaturedProduct, isQuickbuy, sectionUniqueId);
      }

      if (!isFeaturedProduct) {
        var $stickyAddToCart = $('.product-area__add-to-cart-xs', target);
        var stickyAddToCartInitialised = !$stickyAddToCart.length;
        var stickyAddToCartIsUnstuck = false;
        var productSection = $('.section-product-template')[0];

        /// Work out the tallest product tab and compensate the height of the details area
        /// (for position:sticky to work in this case, it needs a fixed height).
        function resizeProductDetails() {
          if (theme.viewport.isXs()) {
            if (!stickyAddToCartInitialised && !isQuickbuy) {
              $(window).on('throttled-scroll.sticky-add-to-cart', function () {
                if (productSection.getBoundingClientRect().bottom < $(window).outerHeight()) {
                  if (!stickyAddToCartIsUnstuck) {
                    $stickyAddToCart.addClass('-out');
                    stickyAddToCartIsUnstuck = true;
                  }
                } else {
                  if (stickyAddToCartIsUnstuck) {
                    $stickyAddToCart.removeClass('-out');
                    stickyAddToCartIsUnstuck = false;
                  }
                }
              });

              $('.product-area__add-to-cart-xs button', target).on('click', function (e) {
                $('.product-detail__form form.product-purchase-form:first', target).submit();
              });

              stickyAddToCartInitialised = true;
            }
          }
        }

        $(window).on("debouncedresizewidth.productDetails".concat(sectionUniqueId), resizeProductDetails);
        $(window).on("cc-header-updated.productDetails".concat(sectionUniqueId), resizeProductDetails);
        $(window).on("shopify:section:reorder.productDetails".concat(sectionUniqueId), resizeProductDetails);
        resizeProductDetails();
      }

      /// Boxed-options (do before initProductOptions - which applies classes to these boxes)
      theme.convertOptionsToBoxes(target);

      /// Product options
      theme.OptionManager.initProductOptions($(target));

      /// Visual style of dropdowns
      $('select:not(.original-selector)').selectReplace().closest('.selector-wrapper').addClass('has-pretty-select');

      /// Size chart
      $('.size-chart-link', target).on('click', function () {
        $.colorbox({
          inline: true,
          fixed: true,
          maxHeight: "80%",
          href: '#size-chart-content > .size-chart',
          onOpen: () => {
            theme.viewport.scroll.lock();
          },
          onClosed: () => {
            theme.viewport.scroll.unlock();
          } });

        return false;
      });

      // Keep colour swatches updated
      $(window).on("cc-variant-updated.product-swatches".concat(sectionUniqueId), (e, args) => {
        var $swatchesContainer = $('.cc-swatches', target);
        if ($swatchesContainer.length) {
          $swatchesContainer.find('.cc-swatches__label').remove();
          $swatchesContainer.find('label').append("<span class=\"cc-swatches__label\">".concat($swatchesContainer.find('.active').text(), "</span>"));
        }
      });

      /// Trigger the animations
      theme.initAnimateOnScroll();
      theme.checkViewportFillers();
      theme.initShopifyPaymentButtons($(target));
    };

    this.onSectionUnload = function (target, isQuickbuy) {
      var sectionUniqueId = $(target).attr('data-section-id');

      if (!isQuickbuy) {
        $(window).off('throttled-scroll.sticky-add-to-cart');
      }

      $(window).off(".productDetails".concat(sectionUniqueId));
      $(window).off("cc-variant-updated.product-swatches".concat(sectionUniqueId));
      $('.spr-container', target).off('click');
      $('.theme-gallery-thumb', target).off('click');
      $('.size-chart-link', target).off('click');
      $('.product-area__add-to-cart-xs button', target).off('click');

      theme.OptionManager.unloadProductOptions($(target));

      if (galleries[sectionUniqueId]) {
        galleries[sectionUniqueId].destroy();
      } else {
        console.warn('No galleries found');
      }

      if (this.storeAvailability && !isQuickbuy) {
        this.storeAvailability.onSectionUnload();
      }
    };
  }();

  theme.FilterManager = new function () {
    this.onSectionLoad = function (container) {
      this.namespace = theme.namespaceFromSection(container);
      this.$container = $(container);

      // ajax filter & sort
      if (this.$container.data('ajax-filtering')) {
        // ajax load on link click
        this.$container.on('click' + this.namespace, '.pagination a,.active-filter-controls a', this.functions.ajaxLoadLink.bind(this));

        // ajax load form submission
        this.$container.on('change' + this.namespace + ' submit' + this.namespace, '#FacetsForm',
        theme.debounce(this.functions.ajaxLoadForm.bind(this), 700));

        // handle back button
        this.registerEventListener(window, 'popstate', this.functions.ajaxPopState.bind(this));
      } else {
        this.$container.on('change' + this.namespace, '#FacetsForm', this.functions.submitForm);
      }

      // click on the mobile 'show filters' button
      this.$container.on('click' + this.namespace, '[data-show-filter]', this.functions.toggleFilter.bind(this));

      // the search query is updated
      this.$container.on('submit' + this.namespace, '#search-page-form', this.functions.updateSearchQuery.bind(this));

      theme.loadInfiniteScroll(container);
      this.functions.refreshSelects();
    };

    this.onSectionUnload = function (container) {
      this.$container.off(this.namespace);
      $(window).off(this.namespace);
      $(document).off(this.namespace);
      theme.unloadInfiniteScroll();
    };

    this.functions = {
      submitForm: function submitForm(e) {
        e.currentTarget.submit();
      },

      updateSearchQuery: function updateSearchQuery(e) {
        var $form = this.$container.find('#FacetsForm');
        if ($form.length) {
          e.preventDefault();
          $form.find('[name="q"]').val($(e.currentTarget).find('[name="q"]').val());

          if (this.$container.data('ajax-filtering')) {
            var ajaxLoadForm = this.functions.ajaxLoadForm.bind(this);
            ajaxLoadForm({
              type: null,
              currentTarget: $form[0] });

          } else {
            $form.submit();
          }
        }
      },

      toggleFilter: function toggleFilter() {
        var $filterBtn = $('[data-show-filter]', this.$container);
        var $productFilter = $('.cc-product-filter', this.$container);
        var $productFilterBg = $('.cc-product-filter-bg', this.$container);
        var nav = theme.Nav();

        if ($productFilter.hasClass('-in')) {
          $filterBtn.text($filterBtn.data('open-text'));
          nav.bar.fadeOut(false);
        } else {
          $filterBtn.text($filterBtn.data('close-text'));
          nav.bar.fadeOut(true);
        }

        $productFilter.toggleClass('-in');
        $productFilterBg.toggleClass('-in');

        return false;
      },

      ajaxLoadLink: function ajaxLoadLink(evt) {
        evt.preventDefault();
        this.functions.ajaxLoadUrl.call(this, $(evt.currentTarget).attr('href'));
      },

      ajaxLoadForm: function ajaxLoadForm(evt) {
        if (evt.type === 'submit') {
          evt.preventDefault();
        }

        var queryVals = [];
        evt.currentTarget.querySelectorAll('input, select').forEach(input => {
          if (
          (input.type !== 'checkbox' && input.type !== 'radio' || input.checked) && // is an active input value
          input.value !== '' // has a value
          ) {
              // if no value, check for the default and include
              if (input.value === '' && input.dataset.currentValue) {
                queryVals.push([input.name, encodeURIComponent(input.dataset.currentValue)]);
              } else {
                queryVals.push([input.name, encodeURIComponent(input.value)]);
              }
            }
        });

        evt.currentTarget.querySelectorAll('[data-current-value]').forEach(input => {
          input.setAttribute('value', input.dataset.currentValue);
        });
        var data = new FormData(evt.currentTarget);
        var queryString = new URLSearchParams(data).toString();
        this.functions.ajaxLoadUrl.call(this, '?' + queryString);
      },

      ajaxPopState: function ajaxPopState(event) {
        this.functions.ajaxLoadUrl.call(this, document.location.href);
      },

      initFilterResults: function initFilterResults() {
        theme.loadInfiniteScroll(this.container);
        theme.inlineVideos.init(this.container);

        // init scroll animations
        theme.initAnimateOnScroll();

        // init theme components
        var $components = this.$container.closest('[data-components]');
        if ($components.length) {
          var components = $components.data('components').split(',');
          components.forEach(function (component) {
            $(document).trigger('cc:component:load', [component, $components[0]]);
          }.bind(this));
        }
      },

      refreshSelects: function refreshSelects() {
        $('select:not(.original-selector)', this.$container).selectReplace().closest('.selector-wrapper').addClass('has-pretty-select');
      },

      ajaxLoadUrl: function ajaxLoadUrl(url) {
        var _this = this;

        // update url history
        var fullUrl = url;
        if (fullUrl.slice(0, 1) === '/') {
          fullUrl = window.location.protocol + '//' + window.location.host + fullUrl;
        }

        // start fetching URL
        var refreshContainerSelector = '[data-ajax-container]',
        $ajaxContainers = this.$container.find(refreshContainerSelector);

        // loading state
        $ajaxContainers.addClass('cc-product-filter-container--loading');
        $ajaxContainers.find('.product-list').append("<span class=\"loading\" aria-label=\"".concat(theme.strings.loading, "\">").concat(theme.icons.loading, " </span>"));
        theme.unloadInfiniteScroll(this.$container);
        theme.inlineVideos.destroy(this.$container);

        // fetch content
        if (this.currentAjaxLoadUrlFetch) {
          this.currentAjaxLoadUrlFetch.abort();
        }

        this.currentAjaxLoadUrlFetch = $.get(url, function (data) {
          this.currentAjaxLoadUrlFetch = null;

          var $newPage = $($.parseHTML(data));
          var newTitleTag = $newPage.filter('title').text().trim();
          document.title = newTitleTag;
          window.history.pushState({ path: fullUrl }, newTitleTag, fullUrl);

          // save active element
          if (document.activeElement) {
            this.activeElementId = document.activeElement.id;
          }

          // replace contents
          var $newAjaxContainers = $("<div>".concat(data, "</div>")).find(refreshContainerSelector);
          $newAjaxContainers.each(function (index) {
            var $newAjaxContainer = $(this);

            // preserve accordion state
            $($ajaxContainers[index]).find('.cc-accordion-item').each(function () {
              var accordionIndex = $(this).closest('.cc-accordion').index();
              if ($(this).hasClass('is-open')) {
                $newAjaxContainer.find(".cc-accordion:nth-child(".concat(accordionIndex + 1, ") .cc-accordion-item")).addClass('is-open').attr('open', '');
              } else {
                $newAjaxContainer.find(".cc-accordion:nth-child(".concat(accordionIndex + 1, ") .cc-accordion-item")).removeClass('is-open').removeAttr('open');
              }
            });

            // maintain mobile filter menu state
            if ($('.cc-product-filter', _this.$container).length && $('.cc-product-filter', _this.$container).hasClass('-in')) {
              $newAjaxContainer.find('.cc-product-filter').addClass('-in');
            }

            $($ajaxContainers[index]).html($newAjaxContainer.html());
            _this.functions.refreshSelects();
          });

          // init js
          this.functions.initFilterResults.call(this);

          //Update the mobile 'Close filters' button text
          var $filterSidebar = $('.cc-product-filter', _this.$container);
          var $filterBtn = $('[data-show-filter]', _this.$container);
          if ($filterSidebar.length && $filterSidebar.hasClass('-in')) {
            var buttonText;
            var resultCount = $('.product-list', _this.$container).data('result-count');

            if (resultCount === 1) {
              buttonText = $filterBtn.data('result-count-text-singular').replace("[x]", resultCount);
            } else {
              buttonText = $filterBtn.data('result-count-text').replace("[x]", resultCount);
            }

            $filterBtn.text(buttonText);
          }

          // remove loading state
          $ajaxContainers.removeClass('cc-product-filter-container--loading');

          // restore active element
          if (this.activeElementId) {
            var el = document.getElementById(this.activeElementId);
            if (el) {
              el.focus();
            }
          }

          var $resultContainer = $('[data-ajax-scroll-to]:first', this.$container);
          if ($(window).scrollTop() - 200 > $resultContainer.offset().top) {
            theme.viewport.scroll.to($resultContainer, -1, 25);
          }
        }.bind(this));
      } };

  }();

  theme.ListCollectionsSection = new function () {
    this.onSectionLoad = function (target) {
    };
  }();

  theme.BlogTemplateSection = new function () {
    this.onSectionLoad = function (target) {
      /// Visual style of dropdowns
      $('select').selectReplace();

      theme.allowRTEFullWidthImages(target);
    };
  }();

  theme.ArticleTemplateSection = new function () {
    this.onSectionLoad = function (target) {
      theme.checkViewportFillers();
      theme.assessAltLogo();
      theme.allowRTEFullWidthImages(target);
    };
  }();

  theme.CartTemplateSection = new function () {
    this.onSectionLoad = function (target) {
      theme.cartNoteMonitor.load($('#cartform [name="note"]', target));

      // terms and conditions checkbox
      if ($('#cartform input#terms', target).length > 0) {
        $(document).on('click.cartTemplateSection', '#cartform [name="checkout"]:submit, .additional-checkout-buttons :submit, .additional-checkout-buttons input[type=image], a[href="/checkout"]', function () {
          if ($('#cartform input#terms:checked').length == 0) {
            alert(theme.strings.cartConfirmation);
            return false;
          }
        });
      }
    };

    this.onSectionUnload = function (target) {
      theme.cartNoteMonitor.unload($('#cartform [name="note"]', target));
      $(document).off('.cartTemplateSection');
    };
  }();

  theme.CollectionListSection = new function () {
    this.onSectionLoad = function (target) {
      var $swiperCont = $('.swiper-container', target);
      if ($swiperCont.length === 1) {
        theme.initProductSlider($swiperCont);
      }
    };
  }();

  theme.FeaturedCollectionSection = new function () {
    this.onSectionLoad = function (target) {
      var $swiperCont = $('.swiper-container', target);
      if ($swiperCont.length === 1) {
        theme.initProductSlider($swiperCont);
      }
    };
  }();

  theme.ProductRecommendations = new function () {
    this.onSectionLoad = function (container) {
      // Look for an element with class 'product-recommendations'
      var productRecommendationsSection = document.querySelector(".product-recommendations");

      if (productRecommendationsSection === null) {return;}

      // Create request and submit it using Ajax
      var request = new XMLHttpRequest();
      request.open("GET", productRecommendationsSection.dataset.url, true);
      request.onload = function () {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
          theme.initAnimateOnScroll();

          var $swiperCont = $('.section-product-recommendations .swiper-container');

          if ($swiperCont.length === 1) {
            theme.initProductSlider($swiperCont);
            setTimeout(() => {
              theme.inlineVideos.init(productRecommendationsSection.parentElement);
              new ProductBlock();
            }, 500);
          } else {
            console.warn('Unable to find .section-product-recommendations');
          }
        }
      };
      request.send();

    };

    this.onSectionUnload = function (container) {
      theme.inlineVideos.destroy(container);
    };
  }();

  theme.GallerySection = new function () {
    this.onSectionLoad = function (container) {
      var $carouselGallery = $('.gallery--mobile-carousel', container);
      if ($carouselGallery.length) {
        var assessCarouselFunction = function assessCarouselFunction() {
          var isCarousel = $carouselGallery.hasClass('slick-slider'),
          shouldShowCarousel = theme.viewport.isXs();

          if (!shouldShowCarousel) {
            $('.lazyload--manual', $carouselGallery).removeClass('lazyload--manual').addClass('lazyload');
          }

          if (isCarousel && !shouldShowCarousel) {
            // Destroy carousel

            // - unload slick
            $carouselGallery.slick('unslick').off('init');
            $carouselGallery.removeAttr('data-transition');
            $carouselGallery.removeClass('slideshow');
            $carouselGallery.find('a, .gallery__item').removeAttr('tabindex').removeAttr('role');

            // - re-row items
            var rowLimit = $carouselGallery.data('grid');
            var $currentRow = null;
            $carouselGallery.find('.gallery__item').each(function (index) {
              if (index % rowLimit === 0) {
                $currentRow = $('<div class="gallery__row">').appendTo($carouselGallery);
              }
              $(this).appendTo($currentRow);
            });
          } else if (!isCarousel && shouldShowCarousel) {
            // Create carousel
            $carouselGallery.find('[data-cc-animate]').removeAttr('data-cc-animate');

            // - de-row items
            $carouselGallery.find('.gallery__item').appendTo($carouselGallery).addClass('slide');
            $carouselGallery.find('.gallery__row').remove();
            $carouselGallery.attr('data-transition', 'slide');
            $carouselGallery.addClass('slideshow');

            // - init carousel
            $carouselGallery.on('init', function () {
              $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');
            }).slick({
              autoplay: false,
              fade: false,
              speed: 600,
              infinite: true,
              useTransform: true,
              arrows: true,
              dots: true,
              prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronDown + '</button>',
              nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronDown + '</button>',
              cssEase: 'cubic-bezier(0.25, 1, 0.5, 1)',
              customPaging: function customPaging(slider, i) {
                // return "<button class=\"custom-dot\" type=\"button\" data-role=\"none\" role=\"button\" tabindex=\"0\">" + theme.icons.dots + "</button>";
                return '<button class="custom-dot black" type="button" data-role="none" role="button" tabindex="0">' + theme.icons.dots + '</button>' + '<button class="custom-dot yellow" type="button" data-role="none" role="button" tabindex="0">' + theme.icons.dotsActive + '</button>';

              } }).
            on('beforeChange', function (event, slick, currentSlide, nextSlide) {
              var $outgoingSlide = $(slick.$slides.get(currentSlide));
              $outgoingSlide.addClass('slick--leaving');
            }).on('afterChange', function (event, slick, currentSlide) {
              $(slick.$slides).filter('.slick--leaving').removeClass('slick--leaving');
            });
          }
        };

        assessCarouselFunction();
        $(window).on('debouncedresize.themeSection' + container.id, assessCarouselFunction);
      }
    };

    this.onSectionUnload = function (container) {
      $(window).off('.themeSection' + container.id);
      $('.slick-slider', container).each(function () {
        $(this).slick('unslick').off('init');
      });
    };

    this.onBlockSelect = function (block) {
      $(block).closest('.slick-slider').each(function () {
        $(this).slick('slickGoTo', $(this).data('slick-index')).slick('slickPause');
      });
    };

    this.onBlockDeselect = function (block) {
      $(block).closest('.slick-slider').each(function () {
        $(this).slick('slickPlay');
      });
    };
  }();

  theme.TestimonialsSection = new function () {
    var scrollax;

    this.onSectionLoad = function (container) {
      if (theme.settings.animationEnabledDesktop && theme.viewport.isSm()) {
        scrollax = new Scrollax(window).init();
      }
    };

    this.onSectionUnload = function (container) {
      if (scrollax && scrollax.Scrollax) {
        scrollax.Scrollax('destroy');
      }
    };
  }();

  theme.AccordionSection = new function () {
    this.onSectionLoad = function (container) {
      var event = new CustomEvent("cc-accordion-load");
      window.dispatchEvent(event);
    };

    this.onBlockSelect = function (container) {
      var accordionElem = container.querySelector('.cc-accordion-item:not(.is-open) .cc-accordion-item__title');
      if (accordionElem) {
        accordionElem.click();
      }
    };

    this.onSectionUnload = function (container) {
      var event = new CustomEvent("cc-accordion-unload");
      window.dispatchEvent(event);
    };
  }();

  theme.FaqSection = new function () {
    this.onSectionLoad = function (container) {
      this.intersectionObserver;
      this.namespace = theme.namespaceFromSection(container);
      this.container = container;
      this.pageContent = document.getElementById('page-content');
      this.sidebar = document.getElementById('faq-sidebar');
      this.accordions = this.pageContent.querySelectorAll('.cc-accordion-item__title');
      this.isScrolling = false;

      this.classNames = {
        questionContainerHidden: 'hidden' };


      //Init the FAQs area css classes
      this.functions.initFaqSections.call(this);
      window.addEventListener("shopify:section:load", this.functions.delayedInitFaqSections.bind(this));
      window.addEventListener("shopify:section:unload", this.functions.delayedInitFaqSections.bind(this));
      window.addEventListener("shopify:section:reorder", this.functions.initFaqSections.bind(this));

      //Init the search input
      this.searchInput = this.container.querySelector('#faq-search__input');
      if (this.searchInput) {
        this.registerEventListener(this.searchInput, 'change', this.functions.performSearch.bind(this));
        this.registerEventListener(this.searchInput, 'keyup', this.functions.performSearch.bind(this));
        this.registerEventListener(this.searchInput, 'paste', this.functions.performSearch.bind(this));
      }

      //Init the sidebar
      if (this.container.dataset.sidebarEnabled === "true") {
        this.functions.initSidebar.call(this);
        window.addEventListener("resize", this.functions.debounceUpdateSidebarPosition);
        window.addEventListener("shopify:section:load", this.functions.delayedInitSidebar.bind(this));
        window.addEventListener("shopify:section:unload", this.functions.delayedInitSidebar.bind(this));
        window.addEventListener("shopify:section:reorder", this.functions.initSidebar.bind(this));

        //Everytime an accordion is opened, reposition the sidebar
        this.accordions.forEach(accordion => {
          accordion.addEventListener('click', this.functions.debounceUpdateSidebarPosition);
        });

        //Add css class to the body to indicate the sidebar is enabled
        document.body.classList.add('faq-sidebar-enabled');
      }
    };

    this.onSectionUnload = function (container) {
      //Destroy the sidebar
      if (this.container.dataset.sidebarEnabled === "true") {
        window.removeEventListener("resize", this.functions.debounceUpdateSidebarPosition);
        window.removeEventListener("shopify:section:load", this.functions.delayedInitSidebar);
        window.removeEventListener("shopify:section:unload", this.functions.delayedInitSidebar);
        window.removeEventListener("shopify:section:reorder", this.functions.initSidebar);
        document.body.classList.remove('faq-sidebar-enabled');
      }

      //Destroy the FAQs area
      window.removeEventListener("shopify:section:load", this.functions.delayedInitFaqSections);
      window.removeEventListener("shopify:section:unload", this.functions.delayedInitFaqSections);
      window.removeEventListener("shopify:section:reorder", this.functions.initFaqSections);
      document.querySelectorAll('.section-faq-accordion').forEach(section => {
        section.classList.remove('section-faq-accordion');
      });

      //Unobserve intersections
      if (this.intersectionObserver) {
        this.pageContent.querySelectorAll('.section-faq-accordion h2 a').forEach(
        accordion => this.intersectionObserver.unobserve(accordion));
      }

      //Remove click bind from accordions
      this.accordions.forEach(accordion => {
        accordion.removeEventListener('click', this.functions.updateSidebarPosition);
      });

      //Remove active search
      this.pageContent.classList.remove('faq-search-active');
    };

    this.functions = {
      //Add css classes to the consecutive accordion sections that follow the FAQ section
      initFaqSections: function initFaqSections() {
        //Remove the class
        this.pageContent.querySelectorAll('.section-faq-accordion').forEach(section => section.classList.remove('section-faq-accordion'));

        //Re-add the class
        var foundFaqSection = false,foundNonAccordionSection = false;
        this.pageContent.querySelectorAll('.shopify-section').forEach(section => {
          if (!foundFaqSection) {
            if (section.classList.contains('section-faq')) {
              foundFaqSection = true;
            }
          } else {
            if (section.classList.contains('section-accordion') && foundNonAccordionSection === false) {
              section.classList.add('section-faq-accordion');
            } else {
              foundNonAccordionSection = true;
            }
          }
        });
      },

      //Delay the init of the FAQs until sections have finished loading/unloading
      delayedInitFaqSections: function delayedInitFaqSections() {
        setTimeout(this.functions.initFaqSections.bind(this), 10);
      },

      //Handles search
      performSearch: function performSearch() {
        // defer to avoid input lag
        setTimeout((() => {
          var splitValue = this.searchInput.value.toLowerCase().split(' ');
          var questionContainers = this.pageContent.querySelectorAll('.section-faq-accordion .cc-accordion');

          // sanitise terms
          var terms = [];
          splitValue.forEach(t => {
            if (t.length > 0) {
              terms.push(t);
            }
          });

          // add css to indicate whether a search is active
          if (terms.length > 0) {
            this.pageContent.classList.add('faq-search-active');
          } else {
            this.pageContent.classList.remove('faq-search-active');
          }

          // reset the found count
          var accordionSections = this.pageContent.querySelectorAll('.section-faq-accordion');
          if (accordionSections) {
            accordionSections.forEach(accordionSection => {
              accordionSection.classList.remove('faq-first-answer');
              if (terms.length > 0) {
                accordionSection.dataset.foundCount = '0';
              } else {
                accordionSection.removeAttribute('data-found-count');
              }
            });
          }

          // search
          var noResults = true;
          questionContainers.forEach((questionContainer => {
            var foundCount = 0;
            if (terms.length) {
              var termFound = false;
              var matchContent = questionContainer.textContent.toLowerCase();
              terms.forEach(term => {
                if (matchContent.includes(term)) {
                  if (noResults) {
                    questionContainer.closest('.section-accordion').classList.add('faq-first-answer');
                  }

                  termFound = true;
                  noResults = false;
                }
              });
              if (termFound) {
                questionContainer.classList.remove(this.classNames.questionContainerHidden);
                foundCount++;
              } else {
                questionContainer.classList.add(this.classNames.questionContainerHidden);
              }
            } else {
              questionContainer.classList.remove(this.classNames.questionContainerHidden);
            }

            // Update the found count of the section
            var sectionElem = questionContainer.closest('.section-accordion');
            sectionElem.dataset.foundCount = parseInt(sectionElem.dataset.foundCount) + foundCount;
          }).bind(this));

          //Show/hide the no results message
          if (noResults && terms.length) {
            this.container.classList.add('faq-no-results');
          } else {
            this.container.classList.remove('faq-no-results');
          }

          // Update the sidebar active links
          if (this.container.dataset.sidebarEnabled === "true") {
            var activeSidebar = this.sidebar.querySelector('.faq-sidebar--active');
            if (activeSidebar) {
              activeSidebar.classList.remove('faq-sidebar--active');
            }

            this.sidebar.querySelectorAll('a').forEach(link => {
              var id = link.getAttribute('href').replace('#', '');
              var anchorElem = document.getElementById(id);
              if (anchorElem) {
                if (anchorElem.offsetParent === null) {
                  link.classList.add('faq-sidebar--disabled');
                } else {
                  link.classList.remove('faq-sidebar--disabled');

                  if (!this.sidebar.querySelector('.faq-sidebar--active')) {
                    link.classList.add('faq-sidebar--active');
                  }
                }
              }
            });
            this.functions.updateSidebarPosition();
          }

        }).bind(this), 10);
      },

      //Init the sticky sidebar
      initSidebar: function initSidebar() {
        //Build the HTML of the sidebar from the FAQ accordion headings
        var anchorHtml = "";
        this.pageContent.querySelectorAll('.section-faq-accordion .section-heading h2').forEach((heading, index) => {
          var label = heading.innerText;
          var anchor = "faq-" + JSON.stringify(label.toLowerCase()).replace(/\W/g, '');
          heading.innerHTML = "<a id=\"".concat(anchor, "\"></a>").concat(label);
          anchorHtml += "<li><a href=\"#".concat(anchor, "\" ").concat(index === 0 ? 'class="faq-sidebar--active"' : '', ">").concat(label, "</a></li>");
        });

        // Append the sidebar HTML
        var nav = new theme.Nav();
        var top = nav.bar.hasStickySetting() ? nav.bar.height() + 50 : 50;

        this.sidebar.innerHTML = "<div class=\"faq-sidebar__inner\" style=\"top: ".concat(
        parseInt(top), "px\">\n          ").concat(
        this.container.dataset.sidebarTitle ? '<h3>' + this.container.dataset.sidebarTitle + '</h3>' : '', "\n          <ol>").concat(
        anchorHtml, "</ol>\n        </div>");


        //Bind click events to each anchor in the sidebar
        this.sidebar.querySelectorAll('a').forEach(anchor => {
          this.registerEventListener(anchor, 'click', this.functions.handleIndexClick.bind(this));
        });

        //Observe current quick link
        if ('IntersectionObserver' in window) {
          this.intersectionObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting && !this.isScrolling) {
                this.sidebar.querySelectorAll('a').forEach(link => {
                  if (link.getAttribute('href').replace('#', '') ===
                  entry.target.getAttribute('id')) {
                    link.classList.add('faq-sidebar--active');
                  } else {
                    link.classList.remove('faq-sidebar--active');
                  }
                });
              }
            });
          }, {
            rootMargin: '0px 0px -70%' });


          this.pageContent.querySelectorAll('.section-faq-accordion h2 a').forEach(
          accordion => this.intersectionObserver.observe(accordion));
        }

        this.functions.updateSidebarPosition();
      },

      //Delay the init of the sidebar until sections have finished loading/unloading
      delayedInitSidebar: function delayedInitSidebar() {
        setTimeout(this.functions.initSidebar.bind(this), 20);
      },

      //Calculates the position of the sidebar
      updateSidebarPosition: function updateSidebarPosition() {
        var sidebar = document.getElementById('faq-sidebar');
        var faqSection = document.querySelector('.section-faq');
        var foundFaqSection = false,firstNonAccordionSection = null;
        if (faqSection) {
          // Find the section that terminates the FAQ area
          document.querySelectorAll('#page-content .shopify-section').forEach(section => {
            if (!foundFaqSection) {
              if (section.classList.contains('section-faq')) {
                foundFaqSection = true;
              }
            } else if (firstNonAccordionSection === null && !section.classList.contains('section-accordion')) {
              firstNonAccordionSection = section;
            }
          });

          if (!firstNonAccordionSection) {
            firstNonAccordionSection = document.querySelector('.section-footer');
          }

          var faqSectionTop = faqSection.getBoundingClientRect().top + document.documentElement.scrollTop;
          var bodyPaddingTop = window.getComputedStyle(document.body).getPropertyValue("padding-top");
          bodyPaddingTop = parseInt(bodyPaddingTop.replace('px', ''));
          sidebar.style.top = faqSectionTop - bodyPaddingTop + 'px';

          if (firstNonAccordionSection) {
            var firstNonAccordionSectionTop = firstNonAccordionSection.getBoundingClientRect().top + document.documentElement.scrollTop;
            sidebar.style.height = firstNonAccordionSectionTop - faqSectionTop + 'px';

            var sidebarInner = sidebar.querySelector('.faq-sidebar__inner');
            if (sidebarInner) {
              sidebarInner.style.maxHeight = firstNonAccordionSectionTop - faqSectionTop - 100 + 'px';
            }
          }
        }
      },

      debounceUpdateSidebarPosition: theme.debounce(() => this.functions.updateSidebarPosition),

      handleIndexClick: function handleIndexClick(e) {
        e.preventDefault();

        //Highlight the relevant index immediately
        var activeSidebar = this.sidebar.querySelector('.faq-sidebar--active');
        if (activeSidebar) {
          activeSidebar.classList.remove('faq-sidebar--active');
        }
        e.target.classList.add('faq-sidebar--active');

        this.isScrolling = true;
        theme.viewport.scroll.to(e.currentTarget.getAttribute('href'), -1, 50, () => {
          this.isScrolling = false;
        });
      } };

  }();


  jQuery(function ($) {
    lazySizesConfig.minSize = 200;
    var nav = theme.Nav();

    /// Visual style of dropdowns
    $('select:not(.original-selector)').selectReplace().closest('.selector-wrapper').addClass('has-pretty-select');

    /// General-purpose lightbox
    $('a[rel=lightbox]').colorbox();

    /// Galleries (only on large screens)
    if (theme.viewport.isSm()) {
      $('a[rel="gallery"]').colorbox({ rel: 'gallery' });
    }

    /// Translations for colorbox
    $.extend($.colorbox.settings, {
      previous: theme.strings.colorBoxPrevious,
      next: theme.strings.colorBoxNext,
      close: theme.icons.close });


    /// Image-links
    $('.rte a img').closest('a').addClass('contains-img');

    /// Slideshow fills viewport
    theme.lastViewportWidth = 0;
    $(window).on('debouncedresize slideshowfillheight', function (e) {
      // if only height changed, don't do anything, to avoid issue with viewport-size-change on mobile-scroll
      if (e.type == 'debouncedresize' && theme.lastViewportWidth == $(window).width()) {
        return;
      }

      // set height of slideshows
      var desiredHeight = $(window).height();

      if (nav.bar.isAnnouncementBar()) {
        desiredHeight -= nav.bar.heightOfAnnouncementBar();
      }
      $('.slideshow.fill-viewport, .slideshow.fill-viewport .slide').css('min-height', desiredHeight);

      // check for content that must be contained
      $('.slideshow.fill-viewport').each(function () {
        var inner = 0;
        $(this).find('.slide').each(function () {
          var t = 0;
          $('.fill-viewport__contain', this).each(function () {
            t += $(this).outerHeight(true);
          });
          if (inner < t) {
            inner = t;
          }
        });
        if (inner > desiredHeight) {
          $(this).css('min-height', inner);
          $('.slide', this).css('min-height', inner);
        }
      });

      theme.lastViewportWidth = $(window).width();

      // bump down any header-overlap areas to cater for announcements
      if ($('body.header-section-overlap').length && nav.bar.isAnnouncementBar()) {
        $('#page-content').css('margin-top', nav.bar.heightOfAnnouncementBar());
      } else {
        $('#page-content').css('margin-top', '');
      }
    });

    /// Some states are dependent on scroll position
    $(window).on('scroll assessFeatureHeaders', function () {
      var scrollTop = $(window).scrollTop();
      var appearenceBuffer = 60;
      var windowBottom = scrollTop + $(window).height() - appearenceBuffer;

      $('body').toggleClass('scrolled-down', scrollTop > 0);

      theme.assessAltLogo();

      $('.feature-header:not(.feature-header--visible)').filter(function () {
        var offset = $(this).offset().top;
        var height = $(this).outerHeight();
        return offset + height >= scrollTop && offset <= windowBottom;
      }).addClass('feature-header--visible');
    });

    /// Side up and remove
    $.fn.slideUpAndRemove = function () {var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;
      $(this).each(function () {
        $(this).slideUp(speed, function () {
          $(this).remove();
        });
      });
    };

    /// Overlay menu nav
    var previousNavRoutes = ['_root'];

    updateNavCtas = function updateNavCtas() {
      var trimmedTitle = previousNavRoutes[previousNavRoutes.length - 1];
      var $ctasToShow = $("#page-menu .nav-ctas__container[data-for-nav-item=\"".concat(trimmedTitle, "\"]:hidden"));

      if ($ctasToShow.length > 0) {
        if ($('#page-menu .nav-ctas__container:visible').length) {
          $('#page-menu .nav-ctas__container:visible').fadeOut(drilldownTransSpeed, function () {
            $ctasToShow.fadeIn(drilldownTransSpeed);
          });
        } else {
          setTimeout(function () {
            $ctasToShow.fadeIn(drilldownTransSpeed);
          }, drilldownTransSpeed);
        }
      } else {
        $('#page-menu .nav-ctas__container:visible').fadeOut(drilldownTransSpeed);
      }
    };

    //Drill down
    var drilldownTransSpeed = 250;
    $(document).on('click', '#page-menu.nav-uses-modal .main-nav li.has-children > a', function () {
      var trimmedTitle = $(this).text().replace(/^\s\s*/, '').replace(/\s\s*$/, '').toLowerCase();
      previousNavRoutes.push(trimmedTitle);

      //- Links
      var $content = $('<div class="container growth-area"/>').append($(this).siblings('ul').clone().wrap("<div class=\"nav-body main-nav growth-area\"/>").
      parent());

      //- Title, in its own menu row, using subnav style for the other links
      var $menuList = $content.find('.main-nav > ul').wrap('<li/>').parent().wrap('<ul/>').parent();
      if (theme.strings.back.length > 0) {
        $menuList.prepend("<li class=\"main-nav__back\" data-nav-title=\"".concat(trimmedTitle, "\"><a href=\"#\" data-revert-back><span class=\"arr arr--left\">").concat(theme.icons.chevronLeft, "</span>").concat(theme.strings.back, "</a></li>"));
      }

      //Hide current & show new
      var $containers = $('#page-menu > .inner > .nav-container > .container:not(.inactive)');
      $containers.addClass('inactive').fadeOut(drilldownTransSpeed, function () {
        $content.hide().insertAfter($containers.last()).fadeIn(drilldownTransSpeed);
        $content.closest('.theme-modal').focus(); // add focus for keyboard scrolling
      });

      updateNavCtas();

      //Hide the footer links
      $('#page-menu > .inner > .nav-container > .nav-footer-links').fadeOut(drilldownTransSpeed);

      return false;
    });

    //Drill back up
    $(document).on('click', '#page-menu.nav-uses-modal a[data-revert-back]', function () {
      previousNavRoutes.pop();
      updateNavCtas();

      $('#page-menu.nav-uses-modal > .inner > .nav-container > .container:not(.inactive)').fadeOutAndRemove(drilldownTransSpeed, function () {
        var $menuToShow = $('#page-menu.nav-uses-modal > .inner > .nav-container > .container.inactive:last');
        $menuToShow.removeClass('inactive').fadeIn(drilldownTransSpeed);

        if ($menuToShow.data('root-nav')) {
          $('#page-menu > .inner > .nav-container > .nav-footer-links').fadeIn(drilldownTransSpeed);
        }
      });
      return false;
    });

    //Close and reset nav
    $(document).on('reset-modal', '#page-menu.nav-uses-modal', function () {
      closeThemeModal();
      setTimeout(function () {
        $('#page-menu.nav-uses-modal > .inner > .nav-container > .container').removeClass('inactive').show().slice(1).remove();
      }, 300); // Delay to match transition on .theme-modal.reveal
      return false;
    }).on('click', 'a[data-reset-and-close]', function () {
      $('#page-menu.nav-uses-modal').trigger('reset-modal');
      return false;
    });


    /// Inline nav links

    //Handle expanding nav
    theme.lastHoverInteractionTimestamp = -1;
    $(document).on('click keydown', '.multi-level-nav .nav-rows .contains-children > a', function (e) {
      if (e.type == 'click' || e.key == 'Enter') {
        $(this).parent().find('ul:first').slideToggle(300);
        return false;
      }
    });

    $(document).on(theme.device.isTouch() ? 'click forceopen forceclose' : 'forceopen forceclose', '.multi-level-nav .contains-mega-menu a.has-children', function (e) {
      $('.nav-ctas__cta .lazyload--manual').removeClass('lazyload--manual').addClass('lazyload');

      // skip column headings
      if ($(this).hasClass('column-title')) {
        return true;
      }

      var navAnimSpeed = 200;

      // check if mouse + click events occurred in same event chain
      var thisInteractionTimestamp = Date.now();
      if (e.type == 'click' && thisInteractionTimestamp - theme.lastHoverInteractionTimestamp < 500) {
        return false;
      }
      if (e.type == 'forceopen' || e.type == 'forceclose') {
        theme.lastHoverInteractionTimestamp = thisInteractionTimestamp;
      }

      //Set some useful vars
      var $tierEl = $(this).closest('[class^="tier-"]');
      var $tierCont = $tierEl.parent();
      var targetTierNum = parseInt($tierEl.attr('class').split('-')[1]) + 1;
      var targetTierClass = 'tier-' + targetTierNum;

      ///Remove nav for all tiers higher than this one (unless we're opening on same level on hover)
      if (e.type != 'forceopen') {
        $tierCont.children().each(function () {
          if (parseInt($(this).attr('class').split('-')[1]) >= targetTierNum) {
            if (e.type == 'forceclose') {
              $(this).removeClass('tier-appeared');
              var $this = $(this);
              theme.hoverRemoveTierTimeoutId = setTimeout(function () {
                $this.remove();
              }, 260);
            } else {
              $(this).slideUpAndRemove(navAnimSpeed);
            }
          }
        });
      }

      //Are we expanding or collapsing
      if ($(this).hasClass('expanded') && e.type != 'forceopen') {
        //Collapsing. Reset state
        $(this).removeClass('expanded').removeAttr('aria-expanded').removeAttr('aria-controls');
      } else {
        ///Show nav
        //Reset other nav items at this level
        $tierEl.find('a.expanded').removeClass('expanded').removeAttr('aria-expanded');
        clearTimeout(theme.hoverRemoveTierTimeoutId);

        //If next tier div doesn't exist, make it
        var $targetTierEl = $tierCont.children('.' + targetTierClass);
        if ($targetTierEl.length == 0) {
          $targetTierEl = $('<div />').addClass(targetTierClass).attr('id', 'menu-' + targetTierClass).appendTo($tierCont);
          if (navAnimSpeed > 0) {
            // new tier, start at 0 height
            $targetTierEl.css('height', '0px');
          }
        } else {
          if (navAnimSpeed > 0) {
            // tier exists, fix its height before replacing contents
            $targetTierEl.css('height', $targetTierEl.height() + 'px');
          }
        }
        // populate new tier
        $targetTierEl.empty().stop(true, false).append($(this).siblings('ul').clone().attr('style', ''));
        if (navAnimSpeed > 0) {
          // transition to correct height, then clear height css
          $targetTierEl.animate(
          {
            height: $targetTierEl.children().outerHeight() },

          navAnimSpeed,
          function () {
            $(this).css('height', '');
          });

        }
        // add class after reflow, for any transitions
        setTimeout(function () {
          $targetTierEl.addClass('tier-appeared');
        }, 10);
        //Mark as expanded
        $(this).addClass('expanded').attr('aria-expanded', 'true').attr('aria-controls', 'menu-' + targetTierClass);
        $('body').addClass('nav-mega-open');
      }
      return false;
    });

    /// Expanding nav on hover
    theme.closeOpenMenuItem = function () {
      $('body').removeClass('nav-mega-open');
      $('.multi-level-nav.reveal-on-hover .has-children.expanded').trigger('forceclose');
    };

    $(document).on('mouseenter mouseleave', '.multi-level-nav.reveal-on-hover .tier-1 .contains-mega-menu', function (e) {
      if (theme.viewport.isSm()) {
        clearTimeout(theme.closeOpenMenuItemTimeoutId);
        if (e.type == 'mouseenter') {
          $(this).children('a').trigger('forceopen');
        } else {
          theme.closeOpenMenuItemTimeoutId = setTimeout(theme.closeOpenMenuItem, 200);
        }
      }
    });

    $(document).on('mouseleave', '.multi-level-nav.reveal-on-hover .tier-appeared', function (e) {
      if (theme.viewport.isSm()) {
        clearTimeout(theme.closeOpenMenuItemTimeoutId);
        theme.closeOpenMenuItemTimeoutId = setTimeout(theme.closeOpenMenuItem, 50);
      }
    });

    $(document).on('mouseenter', '.multi-level-nav.reveal-on-hover .tier-2, .multi-level-nav.reveal-on-hover .tier-3', function (e) {
      if (theme.viewport.isSm()) {
        clearTimeout(theme.closeOpenMenuItemTimeoutId);
      }
    });

    // Keyboard access
    $(document).on('keydown', '.multi-level-nav .contains-children > a.has-children', function (e) {
      if (e.key == 'Enter') {
        if ($(this).parent().hasClass('contains-mega-menu')) {
          if ($(this).attr('aria-expanded') == 'true') {
            theme.closeOpenMenuItem();
          } else {
            $(this).trigger('forceopen');
          }
        } else {
          $(this).parent().toggleClass('reveal-child');
        }
        return false;
      }
    });

    function isPageScrollin() {
      return $('#page-content').outerHeight() > $(window).height();
    }

    /// Modal windows
    var removeModalTimeoutID = -1;
    var closeModalDelay = 300;
    window.closeThemeModal = function (immediate, callbackFn) {
      $('a[data-modal-toggle].active').removeClass('active');

      var $modal = $('.theme-modal.reveal');

      $modal.removeClass('reveal').addClass('unreveal');

      if ($('html.supports-transforms').length && (typeof immediate == 'undefined' || !immediate)) {
        removeModalTimeoutID = setTimeout(function () {
          $('body').removeClass('modal-active');
          $('body, #page-content, #site-control').css('padding-right', '');
        }, closeModalDelay); // Delay to match transition on .theme-modal.reveal
      } else {
        $('body').removeClass('modal-active');
        $('body, #site-control').css('padding-right', '');
      }

      // tabindex
      $modal.find('a').attr('tabindex', '-1');

      if (immediate) {
        $('body').removeAttr('data-modal-id');
      } else {
        setTimeout(function () {
          $('body').removeAttr('data-modal-id');
        }, 200);
      }

      $(window).trigger('ccModalClosing');

      setTimeout(function () {
        $('body').removeClass('modal-closing');

        if ($modal.attr('id') === 'quick-buy-modal') {
          $modal.remove();
        }

        if (callbackFn) {
          callbackFn();
        }

        $(window).trigger('ccModalClosed');
      }, 300);

      $('#search-modal').removeClass('-in');
    };

    //Show arbitrary content in modal window
    window.showThemeModal = function (el, id, callbackFn) {
      //Close current
      closeThemeModal(true);
      //Remove any existing temporary modals
      $('.theme-modal.temp').remove();
      theme.Nav().bar.hide(false);
      //Actually add to the page
      var $el = $(el);
      $el.appendTo('body');
      setTimeout(function () {
        $el.addClass('reveal');
      }, 10);
      theme.addControlPaddingToModal();
      var scrollbarWidth = $.scrollBarWidth();
      //When body is under a modal & has scrollbar, it is not allowed to scroll,
      //so we overflow:hidden it and add a padding the same size as the scrollbar
      if (isPageScrollin()) {
        $('#page-content, #site-control').css('padding-right', scrollbarWidth);
      }
      //Set page state
      $('body').addClass('modal-active modal-opening');

      if (id) {
        $('body').attr('data-modal-id', id);
      }

      setTimeout(function () {
        if ($('.theme-modal:visible [data-modal-close]').length) {
          $('.theme-modal:visible [data-modal-close]').focus();
        }

        $('body').removeClass('modal-opening');
      }, 300);

      //Compensate for an 'always visible' scrollbar
      if (scrollbarWidth > 0) {
        $('.theme-modal:visible').addClass('scrollbar-visible');
      }

      if (callbackFn) {
        callbackFn($el);
      }
    };

    //Show existing modal container hidden on page
    window.showInPageModal = function ($target) {
      $target.removeClass('unreveal').addClass('reveal');
      theme.addControlPaddingToModal();
      var $inputs = $target.find('.focus-me'); //Any inputs to highlight?

      $(this).addClass('active');
      //When body is under a modal, it is not allowed to scroll, so we need this to keep it the same width
      if (isPageScrollin()) {
        $('body, #site-control').css('padding-right', $.scrollBarWidth());
      }
      $('body').addClass('modal-active modal-opening').attr('data-modal-id', $target.attr('id'));
      $('a[tabindex]', $target).removeAttr('tabindex');

      if ($inputs.length == 0) {
        $target.closest('.theme-modal').focus(); // add focus for keyboard scrolling
      } else {
        if (theme.viewport.isSm()) {
          $inputs.focus();
        }
      }

      if ($target.attr('id') === "search-modal") {
        setTimeout(function () {
          $('#search-modal').addClass('-in');
        }, 400);
      }

      setTimeout(function () {
        $('body').removeClass('modal-opening');
      }, 400);
    };

    $(document).on('click', 'body:not(.modal-active) a[data-modal-toggle]', function (e) {
      e.preventDefault();
      window.showInPageModal($($(this).data('modal-toggle')));
    });

    //Close modal on escape keypress
    $(document).on('keyup', function (e) {
      if (e.which == 27) {
        closeThemeModal();
      }
    });
    //Close modal button
    $(document).on('click', 'body.modal-active a[data-modal-close]', function () {
      closeThemeModal();
      return false;
    });
    //Click outside container to close modal
    $(document).on('click', '.theme-modal', function (e) {
      if (e.target == this) {
        closeThemeModal();

        //Trigger any reset events (e.g. in drilldown nav)
        $(this).trigger('reset-modal');
        return false;
      }
    });
    //Switch to a different modal
    $(document).on('click', 'body.modal-active a[data-modal-toggle]', function () {
      closeThemeModal(true);
      $(this).click();
      return false;
    });

    $(document).on('click', '.site-control a[data-modal-nav-toggle]', function () {
      if ($('body.modal-active').length) {
        closeThemeModal(true);
        setTimeout(function () {
          $('#page-menu .crumbs a:first').trigger('click');
        }, 305); // after modal fade-out
      } else {
        $('.nav-ctas__cta .lazyload--manual').removeClass('lazyload--manual').addClass('lazyload');
        window.showInPageModal($('#page-menu'));
      }
      return false;
    });

    //Immmediately select contents when focussing on some inputs
    $(document).on('focusin click', 'input.select-on-focus', function () {
      $(this).select();
    }).on('mouseup', 'input.select-on-focus', function (e) {
      e.preventDefault(); //Prevent mouseup killing select()
    });

    //Textareas increase size as you type
    $('#template textarea').each(function () {$(this).autogrow({ animate: false, onInitialize: true });});

    $(document).on('click', '.quantity-wrapper [data-quantity]', function () {
      var adj = $(this).data('quantity') == 'up' ? 1 : -1;
      var $qty = $(this).closest('.quantity-wrapper').find('[name=quantity]');
      $qty.val(Math.max(1, parseInt($qty.val()) + adj));
      return false;
    });

    /// Redirection dropdowns
    $(document).on('change', 'select.redirecter', function () {
      window.location = $(this).val();
    });

    theme.getUrlParameter = function (name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    /// Scroll to the newsletter when necessary
    var formType = theme.getUrlParameter('form_type');
    if (theme.getUrlParameter('customer_posted') || formType && formType === 'customer') {
      if (window.location.hash && window.location.hash === "footer_newsletter_signup") {
        setTimeout(() => {
          $('html,body').animate({
            scrollTop: $('#footer_newsletter_signup').offset().top - 100 },
          1000);
        }, 100);
      }
    }

    /// Detect android for 100vh fix
    if (navigator.userAgent.toLowerCase().indexOf("android") > -1) {
      $('html').addClass('os-android');
    }

    /// Bind checkout button clicks
    $(document).on('click', '[data-cc-checkout-button]', function (e) {
      if ($('#cc-checkout-form').length) {
        $('#cc-checkout-form').submit();
        return false;
      } else {
        console.warn('Unable to find form with id cc-checkout-form');
      }
    });

    /// Bind pseudo-page-to-page animation event
    $(document).on('click', '[data-cc-animate-click]', function (e) {
      if (theme.settings.animationEnabledDesktop && theme.viewport.isSm() ||
      theme.settings.animationEnabledMobile && theme.viewport.isXs()) {
        if ((window.location.hostname === this.hostname || !this.hostname.length) &&
        $(this).attr('href').length > 0 &&
        $(this).attr('href') !== '#') {
          e.preventDefault();

          var isAnimationFast = $('body').hasClass('animation-speed-fast');
          var pageNavigateDelay = isAnimationFast ? 100 : 200;
          var loaderVisibleDuration = isAnimationFast ? 800 : 1300;
          var $veil = $('#cc-veil');
          var isLoadingAnimation = $veil.hasClass('cc-veil--animate');
          var url = $(this).attr('href');

          $('body').append("<link rel=\"prefetch\" href=\"".concat(url, "\">"));

          $veil.addClass('-in');

          if (isLoadingAnimation) {
            setTimeout(() => {
              $veil.addClass('cc-veil--animate--in').addClass('cc-veil--animate--running');
            }, pageNavigateDelay + 100);
          }

          setTimeout(() => {
            $veil.removeClass('cc-veil--animate--in');
            window.location.href = url;
          }, isLoadingAnimation ? loaderVisibleDuration : pageNavigateDelay);

          //Failsafe - remove the veil after a few second just in case
          setTimeout(() => {
            $('#cc-veil').removeClass('-in');
          }, 8000);

          return false;
        }
      }
    });

    // Process lazy loaded images on page load
    setTimeout(lazySizes.autoSizer.checkElems, 1000);

    /// Watch for tabbing
    function handleFirstTab(e) {
      if (e.keyCode === 9) {// 9 == tab
        $('body').addClass('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
      }
    }
    window.addEventListener('keydown', handleFirstTab);

    //Hide the footer on the challenge page
    if (document.querySelector('.shopify-challenge__container')) {
      document.getElementById('shopify-section-footer').style.display = 'none';
    }

    if (theme.device.isTouch()) {
      document.getElementsByTagName('html')[0].classList.add('touch');
    }

    //Remove the scroll animation from the first element for new users
    var firstSection = document.body.querySelector('.template-index #page-content .shopify-section:first-child [data-cc-animate]');
    if (firstSection && window.localStorage.getItem('is_first_visit') === null) {
      firstSection.removeAttribute('data-cc-animate');
    }
    window.localStorage.setItem('is_first_visit', 'false');

    ///Init stuff
    $(document).on('shopify:section:reorder', function (e) {
      theme.init();
    });

    $(document).on('shopify:section:load', function (e) {
      /// Image-links inside any rte block
      $('.rte a img', e.target).closest('a').addClass('contains-img');

      /// Feature-sized headers have a little fluff
      if ($('.feature-header', e.target).length) {
        $(window).trigger('assessFeatureHeaders');
      }

      /// Init any inline videos
      theme.inlineVideos.init(e.target);

      theme.init();
    }); // end of shopify:section:load

    $(document).on('shopify:section:unload', function (e) {
      /// Unload any inline videos
      theme.inlineVideos.destroy(e.target);

      setTimeout(() => {
        theme.init();
      }, 0);
    });

    //Theme resize events
    $(window).on('debouncedresizewidth', theme.windowResize);

    //Broadcast an event when the screen changes between Xs and Sm
    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 768px)');
      if (mq.addEventListener) {
        mq.addEventListener('change', event => {
          var customEvent = new CustomEvent("cc-mobile-viewport-size-change");
          window.dispatchEvent(customEvent);
        });
      }
    }

    //Init the theme
    $(function () {
      theme.init();
      $(window).trigger('slideshowfillheight');
      $(window).trigger('assessFeatureHeaders');
    });

    /// Register all sections
    var deferredLoadViewportExcess = 1200;
    theme.Sections.init();
    theme.Sections.register('header', theme.HeaderSection, { deferredLoad: false });
    theme.Sections.register('footer', theme.FooterSection, { deferredLoadViewportExcess });
    theme.Sections.register('slideshow', theme.SlideshowSection, { deferredLoadViewportExcess });
    theme.Sections.register('video', theme.VideoManager, { deferredLoadViewportExcess });
    theme.Sections.register('background-video', theme.VideoManager, { deferredLoadViewportExcess });
    theme.Sections.register('image-with-text-overlay', theme.ImageWithTextOverlay, { deferredLoadViewportExcess });
    theme.Sections.register('image-beside-image', theme.ImageBesideImageSection, { deferredLoadViewportExcess });
    theme.Sections.register('featured-collection', theme.FeaturedCollectionSection, { deferredLoadViewportExcess });
    theme.Sections.register('collection-list', theme.CollectionListSection, { deferredLoadViewportExcess });
    theme.Sections.register('featured-blog', theme.FeaturedBlogSection, { deferredLoadViewportExcess });
    theme.Sections.register('product-template', theme.ProductTemplateSection, { deferredLoadViewportExcess: 200 });
    theme.Sections.register('collection-template', theme.FilterManager, { deferredLoad: false });
    theme.Sections.register('blog-template', theme.BlogTemplateSection, { deferredLoad: false });
    theme.Sections.register('article-template', theme.ArticleTemplateSection, { deferredLoad: false });
    theme.Sections.register('list-collections', theme.ListCollectionsSection, { deferredLoadViewportExcess });
    theme.Sections.register('cart-template', theme.CartTemplateSection, { deferredLoad: false });
    theme.Sections.register('product-recommendations', theme.ProductRecommendations, { deferredLoadViewportExcess });
    theme.Sections.register('gallery', theme.GallerySection, { deferredLoadViewportExcess });
    theme.Sections.register('testimonials', theme.TestimonialsSection, { deferredLoadViewportExcess });
    theme.Sections.register('accordion', theme.AccordionSection, { deferredLoadViewportExcess });
    theme.Sections.register('faq', theme.FaqSection, { deferredLoadViewportExcess });
    theme.Sections.register('search-template', theme.FilterManager, { deferredLoad: false });
  });


  //Register dynamically pulled in sections
  $(function ($) {
    if (cc.sections.length) {
      cc.sections.forEach(section => {
        try {
          var data = {};
          if (typeof section.deferredLoad !== 'undefined') {
            data.deferredLoad = section.deferredLoad;
          }
          if (typeof section.deferredLoadViewportExcess !== 'undefined') {
            data.deferredLoadViewportExcess = section.deferredLoadViewportExcess;
          }
          theme.Sections.register(section.name, section.section, data);
        } catch (err) {
          console.error("Unable to register section ".concat(section.name, "."), err);
        }
      });
    } else {
      console.warn('Barry: No common sections have been registered.');
    }
  });

})(theme.jQuery);

let swiper = new Swiper(".swiper-skewed-image", {
  lazy: true,
  slidesPerView: 4,
  spaceBetween: 10,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
  },
 });

 let collectionSwiper = new Swiper(".swiper-container-collection", {
  lazy: true,
  spaceBetween: 20,
  slidesPerView: 4,
  slidesPerGroup: 4,
  loop: true,
  pagination: {
    el: ".featured-cl.swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    500: {
      slidesPerView: 1,
      slidesPerGroup: 1
    },
    700: {
      slidesPerView: 2,
      slidesPerGroup: 2
    },
    1000: {
      slidesPerView: 3,
      slidesPerGroup: 3
    }
  }
 });

 let recommendSwiper = new Swiper(".swiper-container-rec", {
  lazy: true,
  spaceBetween: 20,
  slidesPerView: 4,
  slidesPerGroup: 4,
  pagination: {
    el: ".swiper-pagination-rec",
    clickable: true,
  },
  breakpoints: {
    767: {
      slidesPerView: 1.2,
      spaceBetween: 10
    },

    898: {
      slidesPerView: 2,
      slidesPerGroup: 2
    },
    1280: {
      slidesPerView: 3,
      slidesPerGroup: 3
    }
  }
 });

 let productSwiper = new Swiper(".swiper-container-product", {
  lazy: true,
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  pagination: {
    el: ".swiper-pagination-product",
    clickable: true,
  },
  breakpoints: {
    767: {
      slidesPerView: 1,
      spaceBetween: 10
    }
  }
 });

 let colectionlistSwiper = new Swiper(".swiper-collection-list", {
  lazy: true,
  loop: false,
  spaceBetween: 0,
  slidesPerView: 4,
  slidesPerGroup: 4,
  pagination: {
    el: ".swiper-pagination-collection",
    clickable: true,
  },
  breakpoints: {
    767: {
      slidesPerView: 1.2,
      slidesPerGroup: 1
    },

    898: {
      slidesPerView: 2,
      slidesPerGroup: 2
    },
    1280: {
      slidesPerView: 3,
      slidesPerGroup: 3
    }
  }
});
/* Built with Barry v1.0.8 */